var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSoftwareDevelopment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "133.18 59.006 924.194 455.204",
    width: "924.194px",
    height: "455.204px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m229.02 428.96c-6.01 3.47-15.76 3.47-21.78 0c-1.73-1-2.95-2.18-3.68-3.44c-8.23 1.62-17.7 0.55-24.27-3.24c-6.97-4.02-8.65-9.94-5.05-14.88c-2.45-0.4-4.76-1.15-6.69-2.26c-6.01-3.47-6.01-9.1 0-12.57c6.01-3.47 15.76-3.47 21.78 0c3.13 1.81 4.62 4.2 4.49 6.57c6.71-0.35 13.64 0.96 18.78 3.92c5.1 2.95 7.36 6.91 6.8 10.76c3.51 0.17 6.94 1.02 9.62 2.57c6.01 3.47 6.01 9.1 0 12.57z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m293.78 422.25l-24.41-14.32c-1.44-0.84-1.44-2.92 0-3.75l22.97-13.12c1.68-0.97 3.75-0.97 5.43 0.01l24.41 14.32c1.44 0.84 1.44 2.92 0 3.75l-22.97 13.12c-1.68 0.97-3.75 0.97-5.43-0.01z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m483.1 429.9c10.7 6.18 10.7 16.2 0 22.37c-10.7 6.18-28.05 6.18-38.75 0c-10.7-6.18-10.7-16.2 0-22.37c10.7-6.18 28.05-6.18 38.75 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m828.58 472.79l-14.49-8.65c-1.74-1.01-1.74-3.53 0.01-4.54l34.03-19.45c2.03-1.17 4.54-1.17 6.57 0.01l14.49 8.65c1.74 1.01 1.74 3.53-0.01 4.54l-34.03 19.45c-2.03 1.17-4.54 1.17-6.57-0.01z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m901.95 435.83c3.25-1.87 7.39-2.91 11.64-3.11c-0.68-4.66 2.05-9.45 8.23-13.02c6.22-3.59 14.59-5.17 22.72-4.75c-0.16-2.86 1.64-5.76 5.43-7.94c7.28-4.2 19.07-4.2 26.35 0c7.28 4.2 7.28 11.01 0 15.21c-2.33 1.35-5.13 2.26-8.09 2.74c4.35 5.98 2.32 13.13-6.11 18c-7.94 4.59-19.4 5.88-29.36 3.92c-0.89 1.52-2.36 2.95-4.46 4.16c-7.28 4.2-19.07 4.2-26.35 0c-7.28-4.2-7.28-11.01 0-15.21z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m748.29 141.95l-29.53-17.33c-1.74-1.01-1.74-3.53 0.01-4.54l27.79-15.88c2.03-1.17 4.54-1.17 6.57 0.01l29.53 17.33c1.74 1.01 1.74 3.53-0.01 4.54l-27.79 15.88c-2.03 1.17-4.54 1.17-6.57-0.01z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m724.01 195.18l-45.82-26.56c-3.46-2.01-3.45-7.01 0.01-9.02l55.16-31.52c4.03-2.33 9.01-2.33 13.04 0.02l45.82 26.56c3.46 2.01 3.45 7.01-0.01 9.01l-55.16 31.52c-4.03 2.33-9.01 2.32-13.04-0.02z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m589.04 185.29l-34.11-20.01c-2.01-1.17-2.01-4.08 0.01-5.25l32.1-18.34c2.35-1.36 5.24-1.35 7.59 0.01l34.11 20.02c2.01 1.17 2.01 4.08-0.01 5.25l-32.1 18.34c-2.35 1.36-5.24 1.35-7.59-0.01z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m591.19 150.8l-29.53-17.33c-1.74-1.01-1.74-3.53 0.01-4.54l27.79-15.88c2.03-1.17 4.54-1.17 6.57 0.01l29.53 17.33c1.74 1.01 1.74 3.53-0.01 4.54l-27.79 15.88c-2.03 1.17-4.54 1.17-6.57-0.01z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m648.28 470.75l-10.36-6.15c-1.74-1.01-1.74-3.53 0.01-4.54l10.01-5.97c2.03-1.17 4.54-1.17 6.57 0.01l10.36 6.15c1.74 1.01 1.74 3.53-0.01 4.54l-10.01 5.97c-2.03 1.17-4.54 1.17-6.57-0.01z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m588.28 448.9l-10.36-6.15c-1.74-1.01-1.74-3.53 0.01-4.54l10.01-5.97c2.03-1.17 4.54-1.17 6.57 0.01l10.36 6.15c1.74 1.01 1.74 3.53-0.01 4.54l-10.01 5.97c-2.03 1.17-4.54 1.17-6.57-0.01z"
  })), /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre }\n\t\t.s0 { fill: #150035 } \n\t\t.s1 { fill: #ffffff } \n\t\t.s2 { fill: #39a1ff } \n\t\t.s3 { fill: #117aca } \n\t\t.s4 { fill: #1a0e33 } \n\t"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "content"
  }, /*#__PURE__*/React.createElement("g", {
    id: "illustration"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>",
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m144.7 419.65l-0.52-0.9l61.88-35.67l0.52 0.9l-61.88 35.67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m147.53 421.16l-0.52-0.9l61.88-35.67l0.52 0.9l-61.88 35.67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m150.1 422.77l-0.52-0.9l61.88-35.67l0.52 0.9l-61.88 35.67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m152.99 424.25l-0.52-0.9l61.88-35.67l0.52 0.9l-61.88 35.67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m155.37 425.9l-0.52-0.9l61.88-35.67l0.52 0.9l-61.88 35.67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m158.2 427.41l-0.52-0.9l61.88-35.67l0.52 0.9l-61.89 35.67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m160.77 429.02l-0.52-0.9l61.88-35.67l0.52 0.9l-61.88 35.67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m163.65 430.5l-0.52-0.9l61.88-35.67l0.52 0.9l-61.88 35.67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m166.22 432.11l-0.52-0.9l61.88-35.67l0.52 0.9l-61.88 35.67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m169.1 433.61l-0.52-0.9l61.88-35.67l0.52 0.9l-61.88 35.67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m171.67 435.22l-0.52-0.9l61.88-35.67l0.52 0.9l-61.88 35.67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m174.55 436.7l-0.52-0.9l61.88-35.67l0.52 0.9l-61.88 35.67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m176.93 438.35l-0.52-0.9l61.88-35.67l0.52 0.9l-61.88 35.67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m179.76 439.86l-0.52-0.9l61.88-35.67l0.52 0.9l-61.88 35.67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m182.33 441.47l-0.52-0.9l61.88-35.67l0.52 0.9l-61.89 35.67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m185.22 442.95l-0.52-0.9l61.88-35.67l0.52 0.9l-61.88 35.67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m187.78 444.56l-0.52-0.9l61.88-35.67l0.52 0.9l-61.89 35.67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m189.03 446.84l-0.52-0.9l61.88-35.67l0.52 0.9l-61.88 35.67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m191.86 448.35l-0.52-0.9l61.88-35.67l0.52 0.9l-61.88 35.67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m194.43 449.95l-0.52-0.9l61.88-35.67l0.52 0.9l-61.89 35.67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m197.31 451.43l-0.52-0.9l61.88-35.67l0.52 0.9l-61.88 35.67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m199.88 453.04l-0.52-0.9l61.88-35.67l0.52 0.9l-61.89 35.67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m133.7 413.54l-0.52-0.9l61.88-35.67l0.52 0.9l-61.88 35.67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m136.53 415.05l-0.52-0.9l61.88-35.67l0.52 0.9l-61.88 35.67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m139.1 416.65l-0.52-0.9l61.88-35.67l0.52 0.9l-61.88 35.67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m141.99 418.13l-0.52-0.9l61.88-35.67l0.52 0.9l-61.88 35.67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m144.55 419.74l-0.52-0.9l61.88-35.67l0.52 0.9l-61.89 35.67z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m227.03 294.93c-1.11-1.51-2.46-3.7-4.04-6.57c0.02-0.13 2.3-16.17-0.39-27.81c0-0.01 0.01-0.02 0.02-0.01c0.57 1.11 8.32 16.34 10.82 26.52c1.73 7.04 2.6 10.56 2.6 10.56c-1.85 4.5-5.02 9.29-9.52 14.37l-3.17 2.82c-0.28 0.25-0.72 0.21-0.94-0.1l-2.85-3.88c-0.13-0.18-0.16-0.4-0.09-0.6c0.61-1.61 3.36-8.81 4.73-10.71c1.26-1.73 2.2-3.26 2.84-4.59z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m222.92 315.87c-0.05 0-0.11 0-0.16-0.01c-0.43-0.05-0.83-0.27-1.08-0.62l-2.85-3.88c-0.31-0.42-0.39-0.96-0.2-1.45c0.78-2.07 3.43-8.97 4.85-10.92c1.29-1.77 2.13-3.27 2.51-3.99c-0.6-0.87-1.99-2.96-3.78-6.21l-0.15-0.26l0.04-0.3c0.02-0.16 2.26-16.09-0.38-27.47l-0.18-0.76l1.47-0.57l0.39 0.68c0.87 1.69 8.41 16.58 10.91 26.74l2.67 10.85l-0.11 0.27c-0.12 0.28-2.91 6.98-9.68 14.63l-3.24 2.9c-0.28 0.25-0.65 0.39-1.03 0.39zm-2.56-5.47l2.6 3.54l2.96-2.63c5.76-6.5 8.59-12.48 9.17-13.78l-2.52-10.27c-1.61-6.56-5.5-15.37-8.13-20.95c0.98 9.64-0.26 19.98-0.51 21.87c2.23 4.03 3.82 6.19 3.83 6.21l0.32 0.44l-0.23 0.49c-0.04 0.08-1.01 2.1-2.92 4.73c-1.01 1.39-3.08 6.41-4.57 10.36z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m227.26 295.8l-0.46-1.74c1.62-0.42 3.27-0.11 3.34-0.1l-0.34 1.77c-0.01 0-1.33-0.25-2.55 0.07z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m224.72 415.45c0.92 0.39 1.93 1.93 3.02 4.62c1.28 3.16 4.5 7.13 6.37 8.68c1.88 1.54-0.88 7.54-6.97 4.81c-2.68-1.2-5.12-2.34-7.01-3.24c-2.6-1.24-4.44-3.68-4.85-6.53c-0.29-2.02-0.41-4.22 0.1-5.51c0.75-1.91 2.75-3.26 5.99-4.07l3.34 1.25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m230.11 435.16c-0.99 0-2.11-0.23-3.33-0.78c-2.69-1.21-5.13-2.35-7.02-3.25c-2.9-1.38-4.9-4.08-5.35-7.22c-0.39-2.72-0.34-4.73 0.15-5.97c1.29-3.26 6.39-4.56 6.61-4.61l0.27-0.07l3.64 1.36c0.29 0.12 1.81 0.94 3.5 5.11c1.24 3.06 4.4 6.91 6.11 8.32c1.15 0.94 1.22 2.85 0.17 4.54c-0.84 1.36-2.48 2.57-4.75 2.57zm-8.78-20.02c-1.39 0.4-4.37 1.6-5.11 3.46c-0.36 0.92-0.38 2.72-0.04 5.05c0.36 2.54 1.99 4.73 4.34 5.85c1.88 0.9 4.31 2.03 6.99 3.23c2.96 1.33 4.94 0.3 5.81-1.09c0.58-0.94 0.58-1.9 0.21-2.2c-2.11-1.74-5.35-5.87-6.64-9.03c-1.31-3.23-2.41-4.04-2.56-4.14l-3.01-1.13z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m224.61 415.8c0.82 2.92 1.65 5.17 2.5 6.74c1.02 1.88-0.92 3.5-4.61 1.16c-2.46-1.56-3.98-4.14-4.56-7.75l6.02-0.93l0.64 0.77z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m225.73 425.77c-1.06 0-2.34-0.44-3.7-1.3c-3.98-2.53-4.93-8.13-4.96-8.37l-0.14-0.89l7.42-1.15l1.09 1.31l0.05 0.19c0.01 0.04 1.21 4.32 2.43 6.56c0.6 1.11 0.49 2.25-0.3 2.98c-0.48 0.45-1.13 0.67-1.88 0.67zm-6.69-9.07c0.41 1.54 1.51 4.69 3.95 6.25c1.87 1.19 3.05 1.15 3.39 0.83c0.19-0.17 0.09-0.53-0.06-0.81c-1.18-2.17-2.27-5.86-2.53-6.74l-0.19-0.23l-4.56 0.71z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m174.32 375.69c-1.26 4.54-1.07 8.61 0.57 12.22c2.46 5.42-3.28 9.19-8.11 3.34c-3.22-3.9-4.85-8.29-4.88-13.16c-0.82-1.15-0.91-5.49 0.12-6.45c1.46-1.35 3.92-2.76 7.41-1.85c4.04 1.05 5.67 3.01 4.88 5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m171.9 395.09c-1.78 0-3.88-0.93-5.81-3.27c-4.53-5.49-5.03-12.1-5.08-13.48c-0.86-1.67-0.98-6.08 0.41-7.36c1.62-1.5 4.36-3.07 8.25-2.06c2.38 0.62 4.04 1.71 4.94 3.26c1.08 1.86 0.61 3.68 0.59 3.75l0 0.01c-0.02 0.06-1.77 6.56 0.52 11.61c1.47 3.23 0.34 5.79-1.42 6.89c-0.67 0.42-1.49 0.66-2.39 0.66zm-4.6-24.69c-2.1 0-3.66 0.97-4.66 1.9c-0.63 0.59-0.64 4.38 0 5.26l0.16 0.23l0 0.29c0 0.07 0.12 7.07 4.68 12.6c2.22 2.69 4.54 3.05 5.86 2.23c1.1-0.68 1.75-2.38 0.73-4.62c-2.54-5.6-0.73-12.43-0.62-12.83c0.09-0.38 0.71-3.52-4.24-4.8c-0.68-0.18-1.32-0.25-1.92-0.25z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m174.32 375.69l-1.53 4.79c-1.04 1.01-4.13-1.28-4.74-2.59c-0.28-0.61-0.54-1.37-0.71-2.29c-0.43-2.28 0.27-4.21 2.09-5.81l4.88 5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m172.1 381.63c-0.16 0-0.33-0.01-0.51-0.05c-1.66-0.31-3.78-2.08-4.35-3.32c-0.35-0.75-0.61-1.59-0.78-2.5c-0.73-3.87 2.26-6.54 2.39-6.65l0.7-0.61l5.79 7l-1.75 5.47l-0.16 0.16c-0.25 0.25-0.67 0.51-1.32 0.51zm-2.69-10.47c-0.65 0.85-1.53 2.4-1.18 4.27c0.14 0.77 0.36 1.46 0.64 2.08c0.46 0.99 2.46 2.34 3.18 2.34c0 0 0 0 0 0l1.26-3.96l-3.91-4.72z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m219.79 322.53c1.98 12.88-1.34 25.61-9.93 38.17l-6.56 5.26l-11.34 3l-17.93 6.74c-0.3 0.11-0.63 0.1-0.91-0.04l-0.65-0.32c-1.51-0.74-2.59-2.16-2.9-3.81l-0.21-1.09c-0.08-0.43 0.08-0.87 0.43-1.13c2-1.51 8.87-6.67 13.13-9.62c6.4-4.44 10.38-6.97 14.8-7.91c2.95-0.63 2.36-10.69-1.77-30.17l11.82-5.65l12.02 6.59z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m173.62 376.66c-0.31 0-0.62-0.07-0.91-0.21l-0.65-0.32c-1.76-0.86-3.02-2.53-3.39-4.45l-0.21-1.09c-0.15-0.77 0.15-1.54 0.77-2.02c2-1.51 8.85-6.66 13.16-9.65c6.07-4.21 10.4-7.04 15.13-8.05c1.89-0.4 0.74-14-2.46-29.11l-0.15-0.69l12.88-6.16l12.81 7.02l0.07 0.44c0.03 0.2 2.87 19.9-10.08 38.82l-0.18 0.19l-6.71 5.38l-11.52 3.05l-17.85 6.71c-0.23 0.09-0.48 0.13-0.72 0.13zm23.36-54.57c1.96 9.39 5.6 29.56 0.93 30.55c-4.4 0.94-8.59 3.68-14.48 7.77c-4.28 2.97-11.11 8.1-13.1 9.6c-0.07 0.06-0.11 0.15-0.09 0.24l0.21 1.09c0.26 1.37 1.16 2.56 2.42 3.17l0.65 0.32c0.06 0.03 0.13 0.04 0.2 0.01l17.93-6.74l11.24-2.97l6.31-5.05c11.42-16.77 10.09-34.06 9.76-36.99l-11.21-6.15l-10.77 5.15z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m210.3 328.66c8.39 23.74 12.64 38.1 12.75 43.06c0.16 6.73 1.59 37.82 1.86 43.71c0.03 0.58-0.32 1.11-0.86 1.33c-1.72 0.69-3.64 0.71-5.36 0.04l-0.32-0.12c-0.46-0.18-0.78-0.58-0.86-1.06c-0.42-2.53-1.93-10.78-4.59-17.58c-2.13-5.43-2.48-12.47-1.05-21.12c-2.92-8.43-6.46-14.54-10.62-18.35c-6.23-5.71-15.27-20.73-15.16-30.28c0.07-6.36 8.14-6.24 24.23 0.38z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m221.31 418.19c-1 0-2-0.18-2.95-0.55l-0.32-0.12c-0.75-0.29-1.3-0.96-1.43-1.75c-0.4-2.38-1.9-10.66-4.55-17.4c-3.04-7.77-1.43-19.51-1.14-21.37c-0.6-1.65-4.74-12.68-10.3-17.78c-6.22-5.7-15.56-20.96-15.46-30.95c0.02-1.69 0.71-3.03 2-3.88c5.63-3.73 21.67 2.69 23.48 3.44l0.37 0.15l0.13 0.38c0.52 1.46 12.63 35.84 12.8 43.34c0.16 6.7 1.58 37.57 1.86 43.69c0.04 0.96-0.53 1.85-1.42 2.21c-0.99 0.4-2.03 0.6-3.07 0.6zm-29.23-93.16c-1.63 0-3 0.25-3.93 0.86c-0.8 0.53-1.18 1.29-1.19 2.4c-0.1 9.18 8.82 24.05 14.87 29.6c6.33 5.8 10.68 18.2 10.86 18.72l0.07 0.22l-0.04 0.23c-0.02 0.13-2.06 12.84 1 20.65c2.71 6.9 4.24 15.34 4.65 17.76c0.03 0.17 0.14 0.31 0.3 0.37l0.32 0.12c1.52 0.59 3.2 0.57 4.7-0.04c0.19-0.08 0.31-0.25 0.3-0.45c-0.28-6.12-1.7-37-1.86-43.73c-0.16-6.81-11.21-38.54-12.57-42.4c-3.81-1.53-12.07-4.31-17.5-4.31z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m177.68 270.02c2.34-4.41 8.07-8.32 17.18-11.72l5.62 0.86l8.57-3.96c8.1 1.26 12.77 2.7 14 4.33c1.85 2.44 2.89 19.61 1.27 26.19c-1.08 4.39-1.19 16.66-0.35 36.82c-3.44 2.15-5.75 3.58-6.93 4.27c-1.18 0.69-2.45-0.75-3.81-4.32l-0.39-0.07c-0.58 2.57-1.12 4.65-1.63 6.23c-20.67 4.16-30.19 1.43-28.57-8.19c1.62-9.62 1.42-21.86-0.58-36.71c-5.27-4.75-6.73-9.33-4.39-13.74z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m197.73 330.91c-5.4 0-11.02-0.81-13.97-3.67c-1.81-1.75-2.48-4.08-2.01-6.92c2.22-13.2-0.19-33.37-0.54-36.12c-1.4-1.35-7.81-8.06-4.33-14.59c3.64-6.84 17.09-11.93 17.66-12.14l0.22-0.08l5.58 0.85l8.57-3.96l0.27 0.04c2.09 0.33 12.61 2.08 14.58 4.67c2.1 2.77 3.03 20.4 1.43 26.95c-1.57 6.38-0.33 36.27-0.32 36.57l0.02 0.52l-0.44 0.28c-0.21 0.13-5.19 3.25-6.95 4.28c-0.49 0.28-1.03 0.33-1.57 0.15c-1.09-0.38-2.04-1.81-2.69-3.04c-0.64 2.62-1.14 4.16-1.17 4.24l-0.16 0.5l-0.52 0.1c-0.47 0.09-6.9 1.36-13.66 1.36zm-2.77-71.68c-1.73 0.68-13.4 5.42-16.49 11.22c-3.15 5.93 4.12 12.58 4.19 12.64l0.25 0.22l0.04 0.33c0.03 0.22 2.99 22.58 0.57 36.98c-0.38 2.25 0.11 3.99 1.48 5.33c5.42 5.26 22.31 2.51 25.5 1.93c0.26-0.89 0.84-2.89 1.45-5.64l0.19-0.84l1.74 0.32l0.18 0.47c0.82 2.15 2.03 3.87 2.49 3.87c0 0 0 0 0 0c1.45-0.85 5.19-3.19 6.48-3.99c-0.17-4.18-1.14-30.33 0.39-36.55c1.69-6.88 0.38-23.46-1.11-25.43c-1.1-1.45-8.26-3.16-13.15-3.94l-8.56 3.96l-5.65-0.86z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m211.74 254.33c-0.23 2.39 0.27 5.5 1.5 9.35c-3.41 1.43-7.37 1.06-10.32-1.16c-1.76-1.33-3.13-2.79-4.11-4.38c0.92-2.23 1.39-4.1 1.4-5.61c7.92-1.18 11.76-0.58 11.53 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m209.04 265.42c-2.4 0-4.75-0.75-6.67-2.19c-2.75-2.08-4.27-4.52-4.33-4.63l-0.24-0.39l0.18-0.42c1.29-3.12 1.33-5.25 1.33-5.27l0.01-0.77l0.76-0.12c1.57-0.23 9.54-1.3 11.85 0.9c0.53 0.51 0.78 1.16 0.71 1.88c-0.32 3.36 1.44 8.93 1.46 8.99l0.25 0.79l-0.76 0.32c-1.47 0.62-3.02 0.92-4.54 0.92zm-9.22-7.4c0.5 0.71 1.76 2.35 3.64 3.77c2.42 1.83 5.68 2.31 8.67 1.33c-0.5-1.76-1.58-5.96-1.29-8.89c0.02-0.17-0.03-0.28-0.16-0.4c-1.16-1.1-6.1-0.98-9.64-0.52c-0.1 0.92-0.4 2.59-1.23 4.71z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m199.75 255.3c-0.81 2.51 0.25 5.23 2.41 6.75c2.38 1.67 4.65 2.5 6.81 2.47l-0.84 5.51c-7.41-0.77-12.48-3.95-15.2-9.55c0.54-2.83 2.82-4.58 6.86-5.27l-0.03 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m208.88 271.01l-0.85-0.09c-11.48-1.19-15.74-9.69-15.92-10.05l-0.13-0.27l0.06-0.29c0.92-4.8 7.32-5.94 7.59-5.99l1.47-0.25l-0.5 1.52c-0.66 2.05 0.19 4.41 2.07 5.73c3.25 2.28 6.22 2.3 6.28 2.3h0l1.06-0.01l-1.13 7.4zm-15.01-10.66c0.77 1.38 4.62 7.42 13.49 8.68l0.56-3.69c-1.32-0.18-3.73-0.75-6.29-2.55c-2.1-1.48-3.24-3.95-3.03-6.35c-1.59 0.51-4.12 1.66-4.73 3.91z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m211.65 260.17l4.53-0.63c1.43 4.16 0.71 7.33-2.14 9.51l-3.15-4.68c1.25-1.28 1.5-2.67 0.76-4.19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m213.83 270.34l-4.09-6.09l0.51-0.52c1.39-1.42 0.62-3.1 0.59-3.17l-0.52-1.11l6.47-0.91l0.24 0.7c2.33 6.78-2.4 10.48-2.45 10.52l-0.76 0.58zm-1.8-5.92l2.16 3.22c0.93-1.09 2.35-3.47 1.36-7.11l-2.74 0.38c0.16 0.91 0.15 2.23-0.79 3.51z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m217.85 238.4c1.4 3.09 1.84 6.93 1.31 11.54c-0.32 2.82-1.16 5.55-2.32 8.14l-0.66 1.46c-0.26 0.58-0.83 0.95-1.47 0.94c-2.25-0.03-7.65-0.58-12.1-4.76l-1.64-1.92c-0.73-0.85-1.13-1.93-1.13-3.05c-1.3-0.28-2.21-1.1-2.72-2.45c-0.4-1.06-0.24-2.25 0.26-3.27c0.34-0.69 1.15-1 1.87-0.73l1.51-1.98l5.43-7.04l11.66 3.12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m214.74 261.37c-0.01 0-0.02 0-0.03 0c-2.25-0.03-8-0.58-12.71-5l-1.71-1.99c-0.72-0.84-1.18-1.88-1.3-2.98c-0.79-0.34-2.07-1.12-2.7-2.79c-0.46-1.23-0.35-2.68 0.3-3.98c0.44-0.89 1.35-1.39 2.3-1.32l6.96-9.05l12.65 3.38l0.18 0.39c0.09 0.2 2.19 4.94 1.39 12.02c-0.31 2.73-1.12 5.56-2.4 8.4l-0.66 1.46c-0.4 0.9-1.29 1.47-2.26 1.47zm-16.01-16.27c-0.22 0-0.43 0.12-0.53 0.33c-0.43 0.86-0.51 1.79-0.23 2.55c0.57 1.52 2.01 1.87 2.07 1.89l0.7 0.16l0.01 0.72c0 0.9 0.32 1.77 0.91 2.46l1.64 1.92c4.18 3.92 9.39 4.42 11.43 4.45c0 0 0.01 0 0.01 0c0.27 0 0.51-0.16 0.62-0.41l0.66-1.46c1.2-2.67 1.96-5.32 2.25-7.87c0.62-5.48-0.63-9.48-1.09-10.69l-10.64-2.85l-6.97 9.08l-0.63-0.24c-0.07-0.03-0.14-0.04-0.21-0.04z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m217.71 232.86c1.33 1.13 3.26 1.96 5.68 0.81c-0.15 5.62-3.08 8.39-8.77 8.31c-8.49-0.11-12.99-0.34-13.27 3.05c0 0.03-0.03 0.05-0.06 0.04l-1.5-0.57c-1.32-0.5-2.74 0.42-2.83 1.83l0 0.03c-1.62-1.15-2.43-3-2.43-5.54c0-3.81 2.89-12.7 11.43-12.35c0.55 0.02 1.07 0.05 1.56 0.08c3.79 0.24 7.29 1.85 10.18 4.31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m197.77 248.01l-1.33-0.92c-0.11-0.08-2.81-2.05-2.81-6.27c0-2.93 1.37-7.41 4.39-10.3c2.17-2.09 4.86-3.08 7.98-2.95c0.56 0.02 1.09 0.05 1.59 0.08c3.8 0.24 7.5 1.8 10.71 4.52c1.49 1.26 3.03 1.48 4.72 0.68l1.33-0.63l-0.04 1.47c0 0.09-0.39 9.28-9.69 9.19l-1.14-0.02c-7.64-0.11-11.03-0.06-11.22 2.25l-0.04 0.44l-0.78 0.52l-1.96-0.73c-0.36-0.14-0.75-0.1-1.07 0.11c-0.32 0.21-0.52 0.55-0.54 0.93l-0.1 1.63zm7.71-18.65c-2.42 0-4.51 0.83-6.21 2.46c-2.81 2.7-3.84 6.86-3.84 9c0 1.84 0.63 3.11 1.19 3.89c0.21-0.3 0.48-0.55 0.8-0.76c0.81-0.52 1.79-0.63 2.69-0.29l0.56 0.21c1.04-2.99 5.44-2.92 12.82-2.82l1.14 0.02c5.68 0.08 7.23-3.92 7.68-6.09c-1.82 0.4-3.59-0.09-5.19-1.44c-2.9-2.46-6.24-3.88-9.66-4.09c-0.49-0.03-1-0.06-1.54-0.08c-0.15-0.01-0.3-0.01-0.44-0.01z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m212.83 322.49l-1.8-0.12c1.37-21.46-0.06-48.8-0.08-49.07l1.8-0.1c0.01 0.27 1.45 27.72 0.08 49.28z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m204.32 363.3c-0.01-0.01-0.96-1.5-1.99-2.59l-0.45-0.48c-1.53-1.63-5.12-5.43-6.46-7.38l1.14-0.78c1.28 1.86 4.82 5.61 6.33 7.21l0.45 0.48c1.11 1.19 2.1 2.73 2.14 2.79l-1.17 0.75z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m215.45 346.07l-5.34-15.85l1.31-0.44l5.34 15.85l-1.31 0.44z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m189.44 341.52l-0.26-1.36c2.32-0.45 3.92-1.44 4.75-2.94c1.43-2.6 0.16-5.96 0.14-5.99l1.29-0.5c0.06 0.16 1.53 3.99-0.21 7.16c-1.03 1.88-2.95 3.11-5.7 3.64z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m212.38 377.37l-1.05-0.9c1.46-1.7 2.7-2.34 2.76-2.36l0.62 1.24l-0.31-0.62l0.31 0.62c-0.01 0.01-1.07 0.55-2.33 2.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m220.52 414.35c-1.09 0-2.36-0.23-3.79-0.85l0.55-1.27c4.39 1.9 6.88-0.51 6.99-0.62l0.99 0.97c-0.09 0.1-1.77 1.76-4.73 1.76z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m175.75 374.76c-0.16-0.08-3.86-2.06-4.5-6.99l1.37-0.18c0.55 4.22 3.73 5.92 3.77 5.94l-0.64 1.23z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m200.11 242.52c-0.75-2.47-0.6-4.49 0.44-6.01c1.4-2.04 4.07-2.64 6.05-2.78c3.39-0.24 3.6-2.01 3.61-2.08l1.38 0.09c-0.01 0.12-0.22 3.04-4.89 3.37c-1.68 0.12-3.92 0.6-5.01 2.19c-0.79 1.15-0.88 2.77-0.26 4.82l-1.33 0.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m197.44 243.43c-2.23-1.87-1.24-5.31-1.2-5.46l1.33 0.39c-0.01 0.03-0.77 2.72 0.76 4.01l-0.89 1.06z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m226.57 429.05v-1.8c2.38 0 3.98-2.12 4-2.15l1.45 1.07c-0.09 0.12-2.15 2.88-5.45 2.88z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m171.62 384.82c-1.14 0-2.49-0.26-3.77-1.17l1.05-1.46c2.15 1.54 4.73 0.49 4.76 0.48l0.69 1.66c-0.08 0.04-1.22 0.5-2.73 0.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m171.36 388.41c-0.92 0-2.03-0.2-3.33-0.74l0.69-1.66c3.45 1.42 4.85-0.14 4.91-0.21l1.4 1.13c-0.06 0.08-1.21 1.47-3.66 1.47z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m229.37 430.8l-0.17-1.79c1.96-0.19 3.37-2.04 3.38-2.06l1.46 1.06c-0.07 0.1-1.87 2.53-4.66 2.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m196.1 264.16l-1.6-0.83c1.58-3.06 5.01-4.63 5.16-4.7l0.74 1.64c-0.03 0.01-3.01 1.39-4.3 3.88z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m200.77 251.24l-1.79-0.23c0.23-1.8 1.21-2.83 1.32-2.95l1.29 1.26c-0.01 0.01-0.66 0.71-0.82 1.92z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m252.33 320.25c-0.03 0.65-0.35 1.29-1 1.66l-19.19 11.01c-1.61 0.93-3.6 0.93-5.21-0.01l-18.92-10.97c-0.6-0.35-0.91-0.93-0.98-1.53l0-0.03c-0.01-0.1-0.01-8.74-0.02-9.66c0-0.11 0.11-0.19 0.22-0.16l3.59 1c0.04 0.01 0.09 0.01 0.13-0.02l18.77-10.77c0.05-0.03 0.12-0.03 0.17 0l1.87 11.25c0.01 0.01 0.03 0.01 0.04 0.02l20.39-1.83c0.08 0.02 0.13 0.08 0.13 0.16c0 0.75-0.01 9.81-0.01 9.84l0 0.03z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m229.54 334.52c-1.06 0-2.12-0.27-3.07-0.82l-18.91-10.97c-0.8-0.47-1.32-1.27-1.42-2.21c-0.01-0.12-0.01-0.15-0.02-7.16l0-2.62c0-0.34 0.15-0.65 0.42-0.86c0.27-0.2 0.62-0.27 0.94-0.18l3.29 0.92l18.51-10.62c0.33-0.19 0.74-0.19 1.07 0l0.37 0.21l1.8 10.86l19.76-1.77l0.16 0.04c0.47 0.13 0.79 0.55 0.79 1.03c0 0.1-0.01 9.81-0.01 9.88l-0.01 0.1c-0.03 0.93-0.57 1.83-1.44 2.33l-19.19 11.01c-0.94 0.54-1.99 0.81-3.05 0.81zm-21.62-22.83l0 1.65c0 2.79 0.01 6.77 0.01 7.01c0.02 0.18 0.12 0.57 0.53 0.81l18.91 10.97c1.33 0.77 2.98 0.78 4.31 0.01l19.19-11.01c0.47-0.27 0.54-0.73 0.54-0.92l0-0.03c0-0.47 0-6.68 0.01-8.99l-19.71 1.77l-0.4-0.15l-0.37-0.21l-1.74-10.48l-18.13 10.4l-0.49-0.08l-2.67-0.74z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m252.34 310.39c0 0.75-0.01 9.81-0.01 9.84l0 0.03c-0.03 0.65-0.35 1.29-1 1.66l-19.19 11.01c-0.85 0.49-1.81 0.72-2.76 0.69l0.01-14.63l2.39-6.95c0.01 0.01 0.03 0.01 0.04 0.02l20.39-1.83c0.08 0.02 0.13 0.08 0.13 0.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m229.54 334.52c-0.06 0-0.12 0-0.19 0l-0.87-0.03l0.05-15.8l2.74-7.98l0.73 0.42l20.28-1.82l0.16 0.05c0.47 0.13 0.78 0.54 0.78 1.03c0 0.1-0.01 9.81-0.01 9.88c-0.04 1.03-0.58 1.93-1.45 2.43l-19.19 11.01c-0.92 0.53-1.97 0.81-3.04 0.81zm0.75-15.39l0 13.52c0.5-0.09 0.97-0.26 1.4-0.51l19.19-11.01c0.47-0.27 0.54-0.73 0.54-0.92c0-0.17 0.01-6.65 0.01-9.02l-19 1.7l-2.14 6.23z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m209.92 317.75l-0.01 5.22l-1.91-1.11c-0.6-0.35-0.91-0.93-0.97-1.53l0-0.03c-0.01-0.1-0.01-8.74-0.02-9.66c0-0.12 0.11-0.19 0.22-0.16l3.32 0.92c-0.23 0.65-0.44 1.23-0.63 1.74v4.61z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m210.82 324.53l-3.26-1.89c-0.8-0.47-1.32-1.27-1.42-2.21c-0.01-0.12-0.01-0.15-0.02-7.16l0-2.62c0-0.34 0.15-0.65 0.42-0.85c0.26-0.2 0.61-0.27 0.94-0.18l4.25 1.18l-0.33 0.91c-0.26 0.72-0.48 1.33-0.58 1.6l-0.01 11.23zm-2.9-12.93l0 1.65c0 2.79 0.01 6.77 0.01 7.01c0.02 0.18 0.12 0.57 0.53 0.81l0.55 0.32l0.06-8.57c0.08-0.22 0.18-0.49 0.3-0.82l-1.46-0.41z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m227.02 323.14l-19-11.02c-1.34-0.78-1.33-2.71 0-3.48l19.28-11.06c1.56-0.9 3.48-0.9 5.04 0.01l19 11.02c1.34 0.78 1.33 2.71 0 3.48l-19.28 11.06c-1.56 0.9-3.48 0.9-5.04-0.01z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m229.55 324.72c-1.03 0-2.06-0.27-2.98-0.8l-19-11.02c-0.91-0.53-1.45-1.47-1.45-2.52c0-1.05 0.55-1.99 1.46-2.52l19.28-11.06c1.83-1.06 4.11-1.05 5.94 0.01l19 11.02c0.91 0.53 1.45 1.47 1.45 2.52c0 1.05-0.54 1.99-1.46 2.52l-19.28 11.06c-0.91 0.53-1.94 0.79-2.96 0.79zm0.27-26.92c-0.71 0-1.43 0.18-2.06 0.55l-19.28 11.06c-0.5 0.29-0.55 0.77-0.55 0.96c0 0.19 0.05 0.67 0.55 0.96l19 11.02c1.27 0.74 2.86 0.74 4.14 0.01l19.28-11.06c0.5-0.29 0.55-0.77 0.55-0.96c0-0.19-0.05-0.67-0.55-0.96l-19-11.02c-0.64-0.37-1.36-0.56-2.07-0.56z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m261.8 308.94c-0.03 0.65-0.35 1.29-1 1.66l-19.19 11.01c-1.61 0.93-3.6 0.93-5.21-0.01l-18.92-10.97c-0.6-0.35-0.91-0.93-0.97-1.53l0-0.03c-0.01-0.1-0.01-8.74-0.02-9.66c0-0.12 0.11-0.19 0.22-0.16l3.59 1c0.04 0.01 0.09 0.01 0.13-0.02l18.77-10.77c0.05-0.03 0.12-0.03 0.17 0l1.87 11.25c0.01 0.01 0.03 0.01 0.04 0.02l20.39-1.83c0.07 0.02 0.13 0.08 0.13 0.16c0 0.75-0.01 9.81-0.01 9.84l0 0.03z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m239.01 323.21c-1.06 0-2.12-0.28-3.07-0.82l-18.91-10.97c-0.8-0.47-1.32-1.27-1.42-2.21c-0.01-0.12-0.01-0.15-0.02-7.16l0-2.62c0-0.34 0.15-0.65 0.42-0.85c0.27-0.2 0.62-0.27 0.94-0.18l3.3 0.92l18.51-10.62c0.33-0.19 0.75-0.19 1.08 0.01l0.36 0.21l1.8 10.86l19.76-1.77l0.16 0.04c0.47 0.13 0.79 0.54 0.79 1.03l-0.02 9.98c-0.04 0.93-0.58 1.83-1.44 2.33l-19.19 11.01c-0.94 0.54-1.99 0.81-3.05 0.81zm-21.62-22.83l0 1.65c0 2.79 0.01 6.77 0.01 7.01c0.02 0.18 0.12 0.57 0.53 0.81l18.91 10.97c1.33 0.77 2.98 0.78 4.31 0.01l19.19-11.01c0.47-0.27 0.54-0.73 0.55-0.92h0l0.01-9.02l-19.7 1.77l-0.41-0.15l-0.37-0.21l-1.74-10.48l-18.13 10.4l-0.49-0.08l-2.67-0.74z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m261.81 299.07c0 0.75-0.01 9.81-0.01 9.84l0 0.03c-0.03 0.65-0.35 1.29-1 1.66l-19.19 11.01c-0.85 0.49-1.81 0.72-2.76 0.69l0.01-14.63l2.39-6.95c0.01 0.01 0.03 0.01 0.04 0.02l20.39-1.83c0.07 0.02 0.13 0.08 0.13 0.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m239.02 323.21c-0.06 0-0.12 0-0.19 0l-0.87-0.03l0.05-15.8l2.74-7.98l0.73 0.42l20.28-1.82l0.16 0.04c0.47 0.13 0.79 0.54 0.79 1.03l-0.02 9.98c-0.04 0.93-0.58 1.83-1.44 2.33l-19.19 11.01c-0.92 0.53-1.97 0.81-3.04 0.81zm0.75-15.39l0 13.52c0.5-0.09 0.97-0.26 1.4-0.51l19.19-11.01c0.47-0.27 0.54-0.73 0.55-0.92l0.01-9.02l-19 1.7l-2.14 6.23z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m219.4 306.44l-0.01 5.21l-1.91-1.11c-0.6-0.35-0.91-0.93-0.98-1.53l0-0.03c-0.01-0.1-0.01-8.74-0.02-9.66c0-0.11 0.11-0.19 0.22-0.16l3.32 0.92c-0.23 0.65-0.44 1.23-0.63 1.74v4.61z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m220.29 313.22l-3.26-1.89c-0.8-0.47-1.32-1.27-1.42-2.21c-0.01-0.12-0.01-0.16-0.02-7.16l0-2.62c0-0.34 0.15-0.65 0.42-0.86c0.27-0.2 0.62-0.27 0.94-0.18l4.25 1.18l-0.33 0.91c-0.26 0.72-0.48 1.33-0.58 1.6l-0.01 11.23zm-2.9-12.93l0 1.66c0 2.79 0.01 6.77 0.01 7.01c0.02 0.18 0.12 0.57 0.53 0.81l0.55 0.32l0.06-8.57c0.08-0.22 0.18-0.49 0.3-0.82l-1.46-0.41z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m236.49 311.83l-19-11.02c-1.34-0.78-1.33-2.71 0-3.48l19.28-11.06c1.56-0.9 3.48-0.9 5.04 0.01l19 11.02c1.34 0.78 1.33 2.71 0 3.48l-19.28 11.06c-1.56 0.9-3.48 0.9-5.04-0.01z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m239.02 313.41c-1.03 0-2.06-0.27-2.98-0.8l-19-11.02c-0.91-0.53-1.45-1.47-1.45-2.52c0-1.05 0.55-1.99 1.46-2.52l19.28-11.06c1.83-1.06 4.11-1.05 5.94 0.01l19 11.02c0.91 0.53 1.45 1.47 1.45 2.52c0 1.05-0.55 1.99-1.46 2.52l-19.28 11.06c-0.91 0.53-1.94 0.79-2.96 0.79zm0.27-26.92c-0.71 0-1.43 0.18-2.06 0.55l-19.28 11.06c-0.5 0.29-0.55 0.77-0.55 0.96c0 0.19 0.05 0.67 0.55 0.96l19 11.02c1.27 0.74 2.86 0.74 4.14 0.01l19.28-11.06c0.5-0.29 0.55-0.77 0.55-0.96c0-0.19-0.05-0.67-0.55-0.96l-19-11.02c-0.64-0.37-1.36-0.56-2.07-0.56z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m241.96 322.22l-0.69-1.2l9.33-5.35l0.69 1.2l-9.33 5.35z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m263.51 291.51c-0.03 0.65-0.35 1.29-1 1.66l-19.19 11.01c-1.61 0.93-3.6 0.93-5.21-0.01l-18.92-10.97c-0.6-0.35-0.91-0.93-0.97-1.53l0-0.03c-0.01-0.1-0.01-8.74-0.02-9.66c0-0.12 0.11-0.19 0.22-0.16l3.59 1c0.04 0.01 0.09 0.01 0.13-0.02l18.78-10.77c0.05-0.03 0.12-0.03 0.17 0l1.87 11.25c0.01 0.01 0.03 0.01 0.04 0.02l20.39-1.83c0.07 0.02 0.13 0.08 0.13 0.16c0 0.75-0.01 9.81-0.01 9.84l0 0.03z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m240.72 305.78c-1.06 0-2.12-0.27-3.07-0.82l-18.91-10.97c-0.8-0.47-1.32-1.27-1.42-2.21c-0.01-0.12-0.01-0.15-0.02-7.23l0-2.55c0-0.34 0.15-0.65 0.42-0.85c0.27-0.2 0.62-0.27 0.94-0.18l3.3 0.92l18.51-10.62c0.33-0.19 0.75-0.19 1.08 0.01l0.36 0.21l1.8 10.86l19.76-1.77l0.16 0.04c0.47 0.13 0.79 0.54 0.79 1.03l-0.02 9.98c-0.04 0.93-0.58 1.83-1.44 2.33l-19.19 11.01c-0.94 0.54-1.99 0.81-3.05 0.81zm-21.62-22.83l0 1.59c0 2.79 0.01 6.83 0.01 7.07c0.02 0.18 0.12 0.58 0.53 0.81l18.91 10.97c1.33 0.78 2.98 0.78 4.31 0.01l19.19-11.01c0.47-0.27 0.54-0.73 0.55-0.92h0l0.01-9.02l-19.71 1.77l-0.38-0.14l-0.38-0.21l-1.74-10.49l-18.13 10.4l-0.49-0.08l-2.67-0.74z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m263.52 281.64c0 0.75-0.01 9.81-0.01 9.84l0 0.03c-0.03 0.65-0.35 1.29-1 1.66l-19.19 11.01c-0.85 0.49-1.81 0.72-2.76 0.69l0.01-14.63l2.39-6.95c0.01 0.01 0.03 0.01 0.04 0.02l20.39-1.83c0.07 0.02 0.13 0.08 0.13 0.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m240.72 305.78c-0.06 0-0.12 0-0.19 0l-0.87-0.03l0.06-15.8l2.73-7.96l0.73 0.4l20.29-1.82l0.16 0.04c0.47 0.13 0.79 0.54 0.79 1.03l-0.02 9.98c-0.04 0.93-0.58 1.83-1.44 2.33l-19.19 11.01c-0.92 0.53-1.97 0.81-3.04 0.81zm0.75-15.39l-0.01 13.52c0.5-0.09 0.97-0.26 1.4-0.51l19.19-11.01c0.47-0.27 0.54-0.73 0.55-0.92l0.01-9.02l-19 1.7l-2.14 6.23z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m221.11 289l-0.01 5.21l-1.91-1.11c-0.6-0.35-0.91-0.93-0.98-1.53l0-0.03c-0.01-0.1-0.01-8.74-0.02-9.66c0-0.12 0.11-0.19 0.22-0.16l3.32 0.92c-0.23 0.65-0.44 1.23-0.63 1.74v4.61z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m222 295.78l-3.26-1.89c-0.8-0.47-1.32-1.27-1.42-2.21c-0.01-0.12-0.02-0.15-0.02-7.23l0-2.55c0-0.34 0.15-0.65 0.42-0.86c0.27-0.2 0.62-0.27 0.94-0.18l4.25 1.18l-0.33 0.91c-0.26 0.72-0.48 1.33-0.58 1.6l-0.01 11.23zm-2.9-12.93l0 1.59c0 2.79 0.01 6.83 0.01 7.07c0.02 0.18 0.12 0.58 0.53 0.81l0.55 0.32l0.06-8.57c0 0 0.12-0.32 0.3-0.82l-1.46-0.41z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m238.2 294.4l-19-11.02c-1.34-0.78-1.33-2.71 0-3.48l19.28-11.06c1.56-0.9 3.48-0.9 5.04 0.01l19 11.02c1.34 0.78 1.33 2.71 0 3.48l-19.28 11.06c-1.56 0.9-3.48 0.9-5.04-0.01z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m240.73 295.98c-1.03 0-2.06-0.27-2.98-0.8l-19-11.02c-0.91-0.53-1.45-1.47-1.45-2.52c0-1.05 0.55-1.99 1.46-2.52l19.28-11.06c1.83-1.06 4.11-1.05 5.94 0.01l19 11.02c0.91 0.53 1.45 1.47 1.45 2.52c0 1.05-0.55 1.99-1.46 2.52l-19.28 11.06c-0.91 0.53-1.94 0.79-2.96 0.79zm0.27-26.92c-0.71 0-1.43 0.18-2.06 0.55l-19.28 11.06c-0.5 0.29-0.55 0.77-0.55 0.96c0 0.19 0.05 0.67 0.55 0.96l19 11.02c1.27 0.74 2.86 0.74 4.13 0.01l19.28-11.06c0.5-0.29 0.55-0.77 0.55-0.96c0-0.19-0.05-0.67-0.55-0.96l-19-11.02c-0.64-0.37-1.36-0.56-2.07-0.56z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m254.86 271.82l12.25 7.22l-12.3 6.94l-12.37-7.12l12.42-7.04z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m254.8 287.02l-14.18-8.17l14.25-8.07l14.04 8.28l-14.11 7.96zm-10.55-8.15l10.56 6.08l10.5-5.92l-10.46-6.16l-10.6 6z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m200.7 314.8c1.3-2.47 3.03-3.6 5.22-3.4l1.91 0.48l-0.02 0.58l-1.61 1.51l0.29 0.36l3.97 0.48c8.24 1.04 2.72 6.15-0.34 6.48c-1.94 0.21-3.82 0.29-5.38 0.31c-2.47 0.03-4.88-0.68-6.93-2.07c0.63-0.69 1.6-2.27 2.89-4.74z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m204.56 322.51c-2.61 0-5.12-0.77-7.27-2.23l-0.86-0.59l0.7-0.76c0.04-0.05 0.96-1.12 2.76-4.55c2.2-4.19 5.94-3.89 6.1-3.87l2.75 0.67l-0.05 1.68l-0.79 0.74l2.66 0.32c4.25 0.53 5.13 2.17 5.12 3.45c-0.02 2.34-3.33 4.59-5.47 4.82c-1.7 0.18-3.55 0.29-5.47 0.31c-0.06 0-0.12 0-0.18 0zm-5.45-3.22c1.7 0.96 3.58 1.43 5.6 1.42c1.87-0.02 3.65-0.13 5.3-0.3c1.62-0.17 3.86-1.94 3.87-3.05c0.01-0.74-1.35-1.37-3.54-1.64l-4.33-0.52l-1.05-1.29l1.51-1.42l-0.7-0.18c-0.41-0.02-2.78 0.05-4.28 2.92c-1.09 2.08-1.88 3.35-2.38 4.07z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m198.29 313.02l3.12 1.44c0.43 2.23-0.09 4.27-1.56 6.12l-2.95-1.21l-3.64-4.91l5.02-1.44z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m200.14 321.68l-3.8-1.57l-4.56-6.15l6.6-1.89l3.84 1.78l0.09 0.45c0.03 0.15 0.69 3.79-1.74 6.85l-0.42 0.53zm-2.66-3.04l2.05 0.84c1.1-1.73 1.11-3.58 1.04-4.41l-2.36-1.09l-3.45 0.99l2.72 3.66z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m187.99 278.13c-0.54 4.46-4.54 11.98-12.01 22.55c3.92 0.46 7.88 2.82 10.54 4.9c1.77 1.39 5.69 3.87 11.77 7.45c-0.08 3.62-0.54 5.73-1.39 6.35c-10.22-0.79-28.15-11.43-33.25-14.57c-0.83-0.51-1.21-1.53-0.9-2.45c2.98-8.87 12.51-27.11 15.38-32.33c1.27-2.3 4.65-2.38 6.89-1c0.02 0.01 0.03 0.02 0.04 0.02c2.48 1.6 3.45 4.63 2.91 9.09z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m197.17 320.3l-0.33-0.03c-10.39-0.8-28.38-11.45-33.65-14.7c-1.2-0.74-1.72-2.18-1.28-3.5c3.12-9.29 13.14-28.27 15.45-32.47c0.6-1.08 1.59-1.84 2.89-2.18c1.68-0.44 3.7-0.12 5.26 0.84l0.05 0.03c0.17 0.11 4.19 2.78 3.32 9.96c-0.7 5.84-8.73 17.96-11.36 21.79c4.04 0.89 7.64 3.35 9.55 4.84c2.58 2.02 11.59 7.32 11.68 7.38l0.45 0.27l-0.01 0.53c-0.12 5.45-1.37 6.78-1.76 7.06l-0.27 0.19zm-15.36-51.28c-0.38 0-0.75 0.04-1.1 0.14c-0.56 0.15-1.32 0.5-1.77 1.31c-2.3 4.17-12.24 23.01-15.32 32.18c-0.18 0.53 0.04 1.1 0.52 1.4c5.1 3.14 22.31 13.34 32.37 14.4c0.24-0.47 0.76-1.8 0.88-4.9c-1.91-1.13-9.06-5.4-11.41-7.24c-1.59-1.25-5.76-4.2-10.09-4.71l-1.5-0.18l0.87-1.24c0.11-0.16 11.08-15.74 11.85-22.14c0.71-5.9-2.29-8.07-2.51-8.22l-0.02-0.01c-0.82-0.5-1.82-0.77-2.76-0.77z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m172.73 303.11l-1.29-1.26c1.67-1.71 4.32-2.05 4.43-2.06l0.22 1.79c-0.02 0-2.15 0.28-3.36 1.53z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>",
    clipPath: "url(#cp2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m254.98 422.48l-0.52-0.9l58.03-33.51l0.52 0.9l-58.03 33.51z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m258.03 424.1l-0.52-0.9l58.03-33.51l0.52 0.9l-58.03 33.51z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m260.8 425.83l-0.52-0.9l58.03-33.51l0.52 0.9l-58.03 33.51z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m263.91 427.43l-0.52-0.9l58.03-33.51l0.52 0.9l-58.03 33.51z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m266.47 429.21l-0.52-0.9l58.03-33.51l0.52 0.9l-58.03 33.51z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m269.52 430.84l-0.52-0.9l58.03-33.51l0.52 0.9l-58.03 33.51z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m272.29 432.57l-0.52-0.9l58.03-33.51l0.52 0.9l-58.03 33.51z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m275.4 434.16l-0.52-0.9l58.03-33.51l0.52 0.9l-58.03 33.51z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m278.16 435.89l-0.52-0.9l58.03-33.51l0.52 0.9l-58.03 33.51z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m281.26 437.52l-0.52-0.9l58.03-33.51l0.52 0.9l-58.03 33.51z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m284.03 439.25l-0.52-0.9l58.03-33.51l0.52 0.9l-58.03 33.51z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m287.14 440.84l-0.52-0.9l58.03-33.51l0.52 0.9l-58.03 33.51z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m289.7 442.63l-0.52-0.9l58.03-33.51l0.52 0.9l-58.03 33.51z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m292.75 444.25l-0.52-0.9l58.03-33.51l0.52 0.9l-58.03 33.51z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m295.52 445.98l-0.52-0.9l58.03-33.51l0.52 0.9l-58.03 33.51z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m298.63 447.58l-0.52-0.9l58.03-33.51l0.52 0.9l-58.03 33.51z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m301.39 449.31l-0.52-0.9l58.03-33.51l0.52 0.9l-58.03 33.51z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m243.13 415.89l-0.52-0.9l58.03-33.51l0.52 0.9l-58.03 33.51z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m246.18 417.51l-0.52-0.9l58.03-33.51l0.52 0.9l-58.03 33.51z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m248.94 419.25l-0.52-0.9l58.03-33.51l0.52 0.9l-58.03 33.51z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m252.05 420.84l-0.52-0.9l58.03-33.51l0.52 0.9l-58.03 33.51z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m254.82 422.57l-0.52-0.9l58.03-33.51l0.52 0.9l-58.03 33.51z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m314.99 398.77c-0.03 0.65-0.35 1.29-1 1.66l-19.19 11.01c-1.61 0.93-3.6 0.93-5.21-0.01l-18.92-10.97c-0.6-0.35-0.91-0.93-0.97-1.53l0-0.03c-0.01-0.1-0.01-8.74-0.02-9.66c0-0.11 0.11-0.19 0.22-0.16l3.59 1c0.04 0.01 0.09 0.01 0.13-0.02l18.77-10.77c0.05-0.03 0.12-0.03 0.17 0l1.87 11.25c0.01 0.01 0.03 0.01 0.04 0.02l20.39-1.83c0.08 0.02 0.13 0.08 0.13 0.16c0 0.75-0.01 9.81-0.01 9.84l0 0.03z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m292.2 413.04c-1.06 0-2.12-0.27-3.07-0.83l-18.91-10.97c-0.8-0.47-1.32-1.27-1.42-2.21c-0.01-0.12-0.02-0.15-0.02-7.23l0-2.55c0-0.34 0.15-0.65 0.42-0.86c0.27-0.2 0.62-0.27 0.94-0.18l3.29 0.92l18.51-10.62c0.33-0.19 0.74-0.19 1.07 0l0.37 0.21l1.8 10.87l19.77-1.77l0.16 0.05c0.46 0.14 0.78 0.55 0.78 1.03c0 0.1-0.01 9.81-0.01 9.88l-0.01 0.1c-0.03 0.93-0.57 1.83-1.44 2.33l-19.19 11.01c-0.94 0.54-1.99 0.82-3.05 0.82zm-21.62-22.83l0 1.59c0 2.79 0.01 6.82 0.01 7.07c0.02 0.18 0.12 0.58 0.53 0.82l18.91 10.97c1.33 0.77 2.98 0.77 4.31 0.01l19.19-11.01c0.33-0.19 0.53-0.52 0.54-0.92l0-0.03c0-0.48 0-6.68 0.01-8.99l-19.71 1.77l-0.35-0.12l-0.41-0.2l-1.75-10.52l-18.13 10.4l-0.49-0.08l-2.68-0.75z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m315 388.91c0 0.75-0.01 9.81-0.01 9.84l0 0.03c-0.03 0.65-0.35 1.29-1 1.66l-19.19 11.01c-0.85 0.49-1.81 0.72-2.76 0.69l0.01-14.63l2.39-6.95c0.01 0.01 0.03 0.01 0.04 0.02l20.39-1.83c0.08 0.02 0.13 0.08 0.13 0.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m292.21 413.04c-0.06 0-0.12 0-0.19 0l-0.87-0.03l0.05-15.8l2.75-8l0.73 0.44l20.27-1.82l0.16 0.04c0.47 0.13 0.79 0.55 0.79 1.03c0 0.1-0.01 9.81-0.01 9.88c-0.04 1.03-0.58 1.93-1.45 2.43l-19.19 11.01c-0.92 0.53-1.97 0.81-3.04 0.81zm0.75-15.39l-0.01 13.52c0.5-0.09 0.97-0.26 1.4-0.51l19.19-11.01c0.47-0.27 0.54-0.73 0.54-0.92c0-0.17 0.01-6.65 0.01-9.02l-19 1.7l-2.14 6.23z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m272.59 396.27l-0.01 5.22l-1.91-1.11c-0.6-0.35-0.91-0.93-0.97-1.53l0-0.03c-0.01-0.1-0.01-8.74-0.02-9.66c0-0.12 0.11-0.19 0.22-0.16l3.32 0.92c-0.23 0.65-0.44 1.23-0.63 1.74v4.61z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m273.48 403.05l-3.26-1.9c-0.8-0.47-1.32-1.27-1.42-2.21c-0.01-0.12-0.02-0.15-0.02-7.23l0-2.55c0-0.34 0.15-0.65 0.42-0.85c0.27-0.2 0.62-0.27 0.94-0.18l4.25 1.18l-0.32 0.91c-0.26 0.72-0.48 1.33-0.58 1.6l-0.01 11.23zm-2.9-12.93l0 1.59c0 2.79 0.01 6.83 0.01 7.07c0.02 0.18 0.12 0.57 0.53 0.81l0.55 0.32l0.06-8.57c0 0 0.12-0.32 0.3-0.82l-1.46-0.41z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m289.68 401.67l-19-11.02c-1.34-0.78-1.33-2.71 0-3.48l19.28-11.06c1.56-0.9 3.48-0.9 5.04 0.01l19 11.02c1.34 0.78 1.33 2.71 0 3.48l-19.28 11.06c-1.56 0.9-3.48 0.9-5.04-0.01z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m292.21 403.25c-1.03 0-2.06-0.27-2.98-0.8l-19-11.02c-0.91-0.53-1.45-1.47-1.45-2.52c0-1.05 0.55-1.99 1.46-2.52l19.28-11.06c1.83-1.06 4.11-1.06 5.94 0.01l19 11.02c0.91 0.53 1.45 1.47 1.45 2.52c0 1.05-0.55 1.99-1.46 2.52l-19.28 11.06c-0.91 0.53-1.94 0.79-2.96 0.79zm0.27-26.92c-0.71 0-1.42 0.18-2.06 0.55l-19.28 11.06c-0.5 0.29-0.55 0.77-0.55 0.96c0 0.19 0.05 0.67 0.55 0.96l19 11.02c1.28 0.74 2.86 0.74 4.13 0.01l19.28-11.06c0.5-0.29 0.55-0.77 0.55-0.96c0-0.19-0.05-0.67-0.55-0.96l-19-11.02c-0.64-0.37-1.36-0.56-2.07-0.56z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m289.32 377.74c0.33 0 0.59 0.29 0.56 0.61l-1.65 8.31c0 1-0.97 1.99-2.92 2.47c-1.07 0.27-2.21 0.27-3.28 0c-1.95-0.48-2.92-1.48-2.92-2.47l-1.65-8.31c-0.03-0.33 0.23-0.61 0.56-0.61h11.31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m283.66 390.23c-0.63 0-1.25-0.08-1.86-0.23c-2.21-0.55-3.55-1.75-3.6-3.25l-1.64-8.23c-0.05-0.49 0.08-0.9 0.36-1.21c0.28-0.31 0.67-0.48 1.08-0.48h11.31c0.41 0 0.81 0.18 1.08 0.48c0.28 0.31 0.41 0.72 0.37 1.12l-1.65 8.32c-0.06 1.49-1.39 2.7-3.6 3.25c-0.61 0.15-1.23 0.23-1.86 0.23zm-5.24-11.59l1.58 8.02c0 0.52 0.69 1.22 2.23 1.6c0.93 0.23 1.92 0.23 2.85 0c1.54-0.38 2.23-1.08 2.23-1.6l0.02-0.18l1.56-7.85h-10.48z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m288.1 375.18c2.45 1.41 2.45 3.71 0 5.12c-2.45 1.41-6.42 1.41-8.87 0c-2.45-1.41-2.45-3.71 0-5.12c2.45-1.41 6.42-1.41 8.87 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m283.66 382.27c-1.76 0-3.52-0.4-4.89-1.19c-1.47-0.85-2.29-2.04-2.29-3.34c0-1.3 0.81-2.49 2.29-3.34c2.74-1.58 7.03-1.58 9.77 0c1.47 0.85 2.29 2.04 2.29 3.34c0 1.3-0.81 2.49-2.29 3.34c-1.37 0.79-3.13 1.19-4.89 1.19zm0-7.25c-1.45 0-2.91 0.31-3.99 0.93c-0.88 0.51-1.39 1.16-1.39 1.78c0 0.62 0.51 1.27 1.39 1.78c2.16 1.25 5.81 1.25 7.97 0c0.88-0.51 1.39-1.16 1.39-1.78c0-0.62-0.51-1.27-1.39-1.78c-1.08-0.62-2.53-0.93-3.99-0.93z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m493.82 110.21v27.45c0 0.6-0.19 1.03-0.5 1.24l-7 4.14c-0.17 0.1-0.39 0.04-0.49-0.13l-6.55-11.47c-0.03-0.05-0.08-0.1-0.13-0.13l6.2 3.35c-0.88-0.51-1.59-1.86-1.59-3.03v-12.35c0-0.06-0.02-0.12-0.05-0.18l-6.58-11.52c-0.1-0.17-0.04-0.38 0.13-0.48l6.96-4.14c0.02-0.01 0.04-0.02 0.05-0.03l0 0c0.28-0.19 0.66-0.19 1.08 0.05l6.88 4.2c0.88 0.51 1.59 1.86 1.59 3.03z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m486.15 143.98c-0.11 0-0.21-0.01-0.32-0.04c-0.33-0.09-0.6-0.29-0.77-0.59l-6.55-11.48c0.05 0.09 0.12 0.16 0.2 0.2l0.88-1.57l3.35 1.81c-0.04-0.23-0.06-0.47-0.06-0.7v-12.2l-6.51-11.4c-0.34-0.59-0.13-1.36 0.45-1.7l6.95-4.13c0.6-0.4 1.34-0.39 2.04 0.02l6.89 4.21c1.16 0.67 2.03 2.31 2.03 3.8v27.45c0 0.89-0.32 1.59-0.89 1.98l-7.05 4.17c-0.2 0.12-0.41 0.17-0.64 0.17zm-4.57-10.35l4.76 8.34l6.52-3.86c0 0 0 0 0 0c-0.02 0 0.06-0.15 0.06-0.47v-27.45c0-0.91-0.6-1.94-1.14-2.25l-0.02-0.01l-6.88-4.2c-0.08-0.04-0.13-0.05-0.15-0.05l-6.54 3.9l6.31 11.06c0.11 0.18 0.17 0.4 0.17 0.62v12.35c0 0.91 0.6 1.94 1.13 2.25l-0.88 1.57l-3.35-1.81zm11.29 4.49c0 0 0 0 0 0l0 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m486.43 114.6c0 0 0.01 0 0.01-0.01l7.22-4.29c0.07-0.04 0.16 0.01 0.16 0.09v27.26c0 0.6-0.19 1.03-0.5 1.24l-6.91 4.08c-0.22 0.13-0.51 0.06-0.63-0.17l-6.48-11.35c-0.06-0.06-0.11-0.11-0.17-0.17l4.8-4.62c-1.67-8.47-3.35-7.72-5.05 2.23l7.54-14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m486.19 143.94c-0.12 0-0.24-0.02-0.35-0.05c-0.35-0.09-0.65-0.32-0.83-0.64l-6.63-11.46l-1.32 2.5l0.94-5.55c0.91-5.35 2.17-8.08 3.73-8.1c0.14 0 0.31 0.02 0.46 0.06l3.54-6.71l0.16-0.12l7.76-4.62l0.56 0.26c0.31 0.18 0.51 0.51 0.51 0.87v27.26c0 0.89-0.32 1.59-0.89 1.99l-6.96 4.12c-0.21 0.13-0.45 0.19-0.69 0.19zm-5.88-12.54l6.04 10.57l6.52-3.85l0 0c-0.02 0 0.06-0.15 0.06-0.47v-25.87l-5.81 3.45l-3.6 6.82c0.48 0.94 0.9 2.39 1.31 4.43l0.09 0.48l-4.6 4.43zm2.1-7.24l-2.92 5.54l3.47-3.34c-0.2-0.94-0.38-1.65-0.55-2.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m484.85 143.24l-6.88-4.2c-0.88-0.51-1.59-1.86-1.59-3.03v-27.45c0-1.17 0.71-1.7 1.59-1.2l6.88 4.2c0.88 0.51 1.59 1.86 1.59 3.03v27.45c0 1.17-0.71 1.7-1.59 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m485.48 144.33c-0.35 0-0.73-0.1-1.08-0.31l-0.02-0.01l-6.88-4.21c-1.14-0.66-2.02-2.3-2.02-3.8v-27.45c0-0.94 0.36-1.7 1-2.06c0.57-0.33 1.28-0.3 1.94 0.08l6.9 4.22c1.14 0.66 2.02 2.3 2.02 3.8v27.45c0 0.94-0.36 1.7-1 2.06c-0.26 0.15-0.55 0.23-0.86 0.23zm-0.17-1.86c0.09 0.05 0.15 0.06 0.17 0.06c-0.03-0.01 0.06-0.16 0.06-0.49v-27.45c0-0.91-0.6-1.94-1.13-2.25l-6.9-4.22c-0.08-0.05-0.14-0.06-0.16-0.06h0c0.03 0.01-0.06 0.16-0.06 0.49v27.45c0 0.91 0.6 1.94 1.13 2.25l6.89 4.21z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m483.59 110.96l-0.95-1.53l7.1-4.42l0.95 1.53l-7.1 4.42z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m487.44 134.66l-0.71-1.19l6.25-3.76l0.71 1.19l-6.25 3.76z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m507.45 151.06v27.45c0 0.6-0.19 1.03-0.5 1.24l-7 4.14c-0.17 0.1-0.39 0.04-0.49-0.13l-6.55-11.47c-0.03-0.05-0.08-0.1-0.13-0.13l6.2 3.35c-0.88-0.51-1.59-1.86-1.59-3.03v-12.35c0-0.06-0.02-0.12-0.05-0.18l-6.58-11.52c-0.1-0.17-0.04-0.38 0.13-0.48l6.96-4.14c0.02-0.01 0.04-0.02 0.05-0.03l0 0c0.28-0.19 0.66-0.19 1.08 0.05l6.88 4.2c0.88 0.51 1.59 1.86 1.59 3.03z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m499.78 184.84c-0.11 0-0.22-0.01-0.32-0.04c-0.33-0.09-0.6-0.3-0.77-0.59l-6.55-11.47c0.05 0.08 0.11 0.15 0.2 0.2l0.88-1.57l3.35 1.81c-0.04-0.23-0.06-0.47-0.06-0.7v-12.21l-6.51-11.4c-0.34-0.59-0.13-1.35 0.45-1.7l6.96-4.14c0.6-0.4 1.34-0.39 2.04 0.01l6.89 4.21c1.16 0.67 2.02 2.31 2.02 3.8v27.45c0 0.89-0.32 1.59-0.89 1.98l-7.05 4.17c-0.2 0.12-0.42 0.18-0.64 0.18zm-7.64-12.11c0 0 0 0 0 0l0 0zm3.07 1.75l4.77 8.35l6.52-3.86l0 0c-0.02 0 0.06-0.15 0.06-0.47v-27.45c0-0.91-0.6-1.94-1.13-2.25l-0.02-0.01l-6.88-4.21c-0.08-0.04-0.13-0.05-0.15-0.05c0 0 0 0 0 0l-6.54 3.9l6.31 11.06c0.11 0.2 0.17 0.41 0.17 0.62v12.35c0 0.91 0.6 1.94 1.13 2.25l-0.88 1.57l-3.35-1.81z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m500.06 155.45c0 0 0.01 0 0.01-0.01l7.22-4.29c0.07-0.04 0.16 0.01 0.16 0.09v27.26c0 0.6-0.19 1.03-0.5 1.24l-6.91 4.08c-0.22 0.13-0.51 0.06-0.63-0.17l-6.48-11.35c-0.06-0.06-0.11-0.11-0.17-0.17l4.8-4.62c-1.67-8.47-3.35-7.72-5.05 2.23l7.54-14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m499.82 184.8c-0.12 0-0.24-0.02-0.35-0.05c-0.35-0.09-0.65-0.32-0.83-0.64l-6.63-11.46l-1.32 2.5l0.95-5.56c0.91-5.36 2.17-8.08 3.73-8.1c0.16-0.01 0.31 0.02 0.46 0.06l3.54-6.71l0.16-0.12l7.76-4.61l0.56 0.25c0.32 0.18 0.51 0.51 0.51 0.88v27.26c0 0.89-0.32 1.59-0.89 1.98l-6.96 4.12c-0.21 0.13-0.45 0.19-0.69 0.19zm-5.88-12.54l6.04 10.57l6.52-3.86l0 0c-0.02 0 0.06-0.15 0.06-0.47v-25.86l-5.81 3.45l-3.6 6.82c0.48 0.94 0.9 2.39 1.3 4.43l0.09 0.48l-4.6 4.43zm2.1-7.24l-2.92 5.54l3.47-3.34c-0.2-0.94-0.38-1.65-0.55-2.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m498.48 184.1l-6.88-4.2c-0.88-0.51-1.59-1.86-1.59-3.03v-27.45c0-1.17 0.71-1.7 1.59-1.2l6.88 4.2c0.88 0.51 1.59 1.86 1.59 3.03v27.45c0 1.17-0.71 1.7-1.59 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m499.11 185.19c-0.35 0-0.73-0.1-1.08-0.31l-0.02-0.01l-6.88-4.21c-1.14-0.66-2.02-2.3-2.02-3.8v-27.45c0-0.94 0.37-1.7 1-2.06c0.57-0.33 1.28-0.3 1.94 0.08l6.9 4.22c1.14 0.66 2.02 2.3 2.02 3.8v27.45c0 0.94-0.36 1.7-1 2.06c-0.26 0.15-0.55 0.23-0.86 0.23zm-0.18-1.86c0.1 0.05 0.16 0.06 0.17 0.06c0 0 0 0 0 0c-0.03 0 0.05-0.16 0.05-0.49v-27.45c0-0.91-0.6-1.94-1.13-2.25l-6.9-4.22c-0.08-0.05-0.14-0.06-0.16-0.06c0.03 0-0.06 0.16-0.06 0.49v27.45c0 0.91 0.6 1.94 1.13 2.25l6.88 4.21z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m497.22 151.81l-0.95-1.53l7.1-4.42l0.95 1.53l-7.1 4.42z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m501.07 175.52l-0.71-1.19l6.25-3.76l0.71 1.19l-6.25 3.76z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m439.08 384.25l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m441.91 385.76l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m444.48 387.36l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m447.36 388.84l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m449.74 390.5l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m452.58 392.01l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m455.14 393.62l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m458.03 395.09l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m460.6 396.7l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m463.47 398.21l-0.5-0.91l12.31-6.82l0.5 0.91l-12.31 6.82z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m466.04 399.81l-0.5-0.91l25.88-14.34l0.5 0.91l-25.88 14.34z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m468.93 401.29l-0.5-0.91l25.88-14.34l0.5 0.91l-25.88 14.34z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m472.88 402.08l-0.5-0.91l23.15-12.83l0.5 0.91l-23.15 12.83z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m477.14 402.95l-0.51-0.91l21.03-11.69l0.51 0.91l-21.03 11.69z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m395.85 359.43l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m398.68 360.94l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m401.25 362.55l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m404.13 364.02l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m406.51 365.68l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m409.34 367.19l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m411.91 368.8l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m414.8 370.27l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m417.36 371.88l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m420.24 373.39l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m422.81 375l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m425.7 376.47l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m428.08 378.13l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m430.91 379.64l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m433.48 381.25l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m436.36 382.73l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m438.93 384.33l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m366.42 338.96l-0.5-0.91l8.59-4.75l0.5 0.91l-8.59 4.75z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m367.35 341.52l-0.5-0.91l11.95-6.61l0.5 0.91l-11.95 6.61z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m368.99 343.64l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m371.88 345.12l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m374.45 346.73l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m377.32 348.23l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m379.89 349.84l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m382.78 351.32l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m385.16 352.97l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m387.99 354.48l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m390.56 356.09l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m393.44 357.57l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m509.99 399.92l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m512.82 401.43l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m515.39 403.03l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m518.27 404.51l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m520.65 406.17l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m523.48 407.68l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m526.05 409.29l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m528.94 410.76l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m531.51 412.37l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m534.38 413.88l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m536.95 415.48l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m539.84 416.96l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m543.78 417.75l-0.5-0.91l10.93-6.05l0.5 0.91l-10.93 6.05z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m548.06 418.62l-0.51-0.9l6.66-3.78l0.51 0.9l-6.66 3.78z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m466.76 375.1l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m469.59 376.61l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m472.15 378.22l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m475.04 379.69l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m477.42 381.35l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m480.25 382.86l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m482.82 384.47l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m491.92 385.47l-0.5-0.91l10.02-5.48l0.5 0.91l-10.02 5.48z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m494.81 386.95l-0.5-0.91l10.01-5.45l0.5 0.91l-10.01 5.45z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m496.02 389.25l-0.5-0.91l11.36-6.15l0.5 0.91l-11.36 6.15z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m498.18 391.26l-0.5-0.91l12.1-6.68l0.5 0.91l-12.1 6.68z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m498.99 393.8l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m501.82 395.31l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m504.38 396.92l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m507.27 398.4l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m509.84 400l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m437.33 354.63l-0.5-0.91l8.59-4.75l0.5 0.91l-8.59 4.75z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m438.26 357.19l-0.5-0.91l11.95-6.61l0.5 0.91l-11.95 6.61z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m439.9 359.31l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m442.79 360.79l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m445.35 362.4l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m448.23 363.9l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m450.8 365.51l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m453.69 366.99l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m456.07 368.64l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m458.9 370.15l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m461.47 371.76l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m464.35 373.24l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m398.65 332.84l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m401.49 334.35l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m404.05 335.96l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m406.94 337.44l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m409.32 339.09l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m412.15 340.6l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m414.72 342.21l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m417.6 343.69l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m420.17 345.3l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m423.05 346.8l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m425.62 348.41l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m428.5 349.89l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m432.45 350.68l-0.5-0.91l10.93-6.05l0.5 0.91l-10.93 6.05z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m436.72 351.54l-0.51-0.9l6.66-3.78l0.51 0.9l-6.66 3.78z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m355.42 308.02l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m358.25 309.53l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m360.82 311.14l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m363.71 312.62l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m366.09 314.27l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m368.92 315.78l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m371.49 317.39l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m374.37 318.87l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m376.94 320.48l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m379.82 321.98l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m382.39 323.59l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m385.27 325.07l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m387.65 326.73l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m390.48 328.23l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m393.05 329.84l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m395.94 331.32l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m398.5 332.93l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m326 287.55l-0.5-0.91l8.59-4.75l0.5 0.91l-8.59 4.75z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m294.97 308.02l-0.51-0.91l43.91-24.52l0.51 0.91l-43.91 24.52z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m297.89 309.36l-0.51-0.91l44.35-24.69l0.51 0.91l-44.35 24.69z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m300.78 310.84l-0.51-0.91l44.35-24.69l0.51 0.91l-44.35 24.69z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m303.34 312.45l-0.51-0.91l44.35-24.69l0.51 0.91l-44.35 24.69z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m306.22 313.95l-0.51-0.91l44.35-24.69l0.51 0.91l-44.35 24.69z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m291.39 303.87l-0.51-0.91l42.48-23.65l0.51 0.91l-42.48 23.65z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m292.73 306.16l-0.51-0.91l43.71-24.33l0.51 0.91l-43.71 24.33z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m308.79 315.56l-0.51-0.91l44.35-24.69l0.51 0.91l-44.35 24.69z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m313.18 316.2l-0.51-0.91l42.85-23.85l0.51 0.91l-42.85 23.85z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m316.39 317.39l-0.51-0.91l42.01-23.38l0.51 0.91l-42.01 23.38z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m344.66 304.69l-0.5-0.91l16.57-9.18l0.5 0.91l-16.57 9.18z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m350.13 304.68l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m353.02 306.16l-0.5-0.91l13.67-7.56l0.5 0.91l-13.67 7.56z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m361.32 315.29l9.58 0.2c0.17 0 0.33-0.04 0.48-0.12l36.69-21.18c2.25-1.3 5.65-1.44 7.6-0.32l83.22 48.05c0.05 0.03 0.11 0.06 0.17 0.08l27.63 9.28c0.38 0.13 0.63 0.48 0.63 0.88l0 6.94c0.24 0.98-0.38 2.07-1.81 2.89l-45.86 26.48c-2.25 1.3-5.65 1.44-7.6 0.31l-110.38-63.73c-0.89-0.51-1.3-1.21-1.29-1.93l0-6.91c0-0.52 0.43-0.93 0.94-0.92z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m471.62 389.53l-110.38-63.73c-1.13-0.65-1.74-1.61-1.73-2.69v-6.91c0-0.49 0.19-0.94 0.54-1.29c0.35-0.34 0.76-0.57 1.3-0.51l9.61 0.19l36.69-21.18c2.53-1.46 6.26-1.6 8.48-0.32l83.23 48.05l27.63 9.28c0.73 0.25 1.23 0.93 1.23 1.71l0 6.85c0.27 1.38-0.56 2.77-2.24 3.75l-45.86 26.47c-1.37 0.79-3.09 1.2-4.73 1.2c-1.39 0-2.73-0.29-3.75-0.88zm-63.1-94.59l-36.69 21.18c-0.28 0.16-0.56 0.29-0.94 0.24l-9.57-0.2l-0.06 6.96c-0.01 0.55 0.46 0.93 0.85 1.16l110.38 63.73c1.67 0.97 4.75 0.82 6.72-0.31l45.86-26.47c1-0.58 1.54-1.32 1.39-1.93l-0.05-7.19l-27.63-9.28c-0.11-0.04-0.22-0.09-0.32-0.15l-83.22-48.05c-0.75-0.43-1.77-0.64-2.85-0.64c-1.35 0-2.78 0.33-3.87 0.96zm-47.2 21.22l0.01-0.88l-0.02 0.88l0.01 0z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m362.22 313.05l45.86-26.48c2.25-1.3 5.65-1.44 7.6-0.31l110.38 63.73c1.95 1.13 1.7 3.09-0.55 4.39l-45.86 26.48c-2.25 1.3-5.65 1.44-7.6 0.32l-110.38-63.73c-1.95-1.13-1.7-3.09 0.55-4.39z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m471.62 381.93l-110.38-63.73c-1.13-0.65-1.76-1.6-1.76-2.67c0-1.22 0.84-2.4 2.3-3.24l45.86-26.48c2.53-1.46 6.26-1.6 8.48-0.31l110.38 63.73c1.13 0.65 1.75 1.6 1.75 2.67c0 1.22-0.84 2.4-2.3 3.24l-45.86 26.48c-1.37 0.79-3.09 1.19-4.73 1.19c-1.39 0-2.73-0.29-3.75-0.88zm-63.1-94.59l-45.86 26.48c-0.89 0.51-1.42 1.16-1.42 1.72c0 0.53 0.48 0.92 0.88 1.15l110.38 63.73c1.68 0.97 4.76 0.82 6.72-0.31l45.86-26.48c0.89-0.51 1.42-1.16 1.42-1.72c0-0.53-0.48-0.92-0.88-1.15l-110.38-63.73c-0.75-0.43-1.77-0.64-2.85-0.64c-1.35 0-2.78 0.32-3.87 0.95z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m474.71 382.45h1.35v6.54h-1.35v-6.54z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m521.68 356.38h1.35v6.54h-1.35v-6.54z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m364.64 319.76h1.35v6.54h-1.35v-6.54z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m314.88 65.05c-0.09-0.12-0.05-0.29 0.08-0.36l8.19-4.54c0.44-0.34 1.05-0.36 1.72 0.03l247.42 142.85c1.34 0.77 2.42 2.84 2.42 4.62v189.32c0 0.89-0.27 1.54-0.71 1.87l-8.63 4.78l-8.59-10.35l3.38-1.48l-235.29-135.84c-1.34-0.77-2.42-2.84-2.42-4.62v-176.02l-7.57-10.26z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m555.35 392.93l2.86-1.25l-233.78-134.97c-1.6-0.93-2.86-3.29-2.86-5.38v-175.73l-7.39-10.02c-0.19-0.26-0.27-0.59-0.2-0.91c0.07-0.32 0.27-0.59 0.55-0.75l8.07-4.47c0.75-0.58 1.73-0.59 2.7-0.04l247.42 142.85c1.6 0.93 2.86 3.29 2.86 5.38v189.32c0 1.14-0.38 2.06-1.16 2.64l-9.26 5.14l-9.8-11.81zm-231.78-332.02l-7.55 4.19l7.31 9.91v176.31c0 1.47 0.91 3.24 1.98 3.86l236.79 136.71l-3.9 1.71l7.38 8.9l7.89-4.36c0.17-0.13 0.36-0.51 0.36-1.17v-189.32c0-1.47-0.91-3.24-1.98-3.86l-247.42-142.85c-0.14-0.08-0.3-0.15-0.48-0.15c-0.12 0-0.25 0.04-0.38 0.13z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m313.8 256.13v-189.32c0-1.78 1.08-2.6 2.42-1.83l247.42 142.85c1.34 0.77 2.42 2.84 2.42 4.62v189.32c0 1.78-1.08 2.6-2.42 1.83l-247.42-142.85c-1.34-0.77-2.42-2.84-2.42-4.62z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m563.2 404.35l-247.42-142.85c-1.6-0.93-2.86-3.29-2.86-5.38v-189.32c0-1.26 0.47-2.25 1.28-2.72c0.72-0.42 1.59-0.37 2.46 0.13l247.42 142.85c1.6 0.93 2.86 3.29 2.86 5.38v189.32c0 1.26-0.47 2.25-1.28 2.72c-0.33 0.19-0.69 0.28-1.06 0.28c-0.45 0-0.93-0.14-1.4-0.41zm-248.12-338.75c-0.18 0.11-0.4 0.48-0.4 1.2v189.32c0 1.47 0.91 3.24 1.98 3.86l247.42 142.85c0.14 0.08 0.49 0.26 0.7 0.13c0.18-0.11 0.4-0.48 0.4-1.19v-189.32c0-1.47-0.91-3.24-1.98-3.86l-247.42-142.85c-0.1-0.06-0.32-0.17-0.52-0.17c-0.07 0-0.13 0.01-0.18 0.04z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m315.87 254.86v-187.59c0-0.52 0.32-0.76 0.71-0.54l246.7 142.43c0.39 0.23 0.71 0.83 0.71 1.36v187.59c0 0.52-0.32 0.76-0.71 0.54l-246.7-142.43c-0.39-0.23-0.71-0.83-0.71-1.36z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m562.84 400.41l-246.7-142.43l0 0c-0.66-0.38-1.15-1.28-1.15-2.12v-187.59c0-0.6 0.25-1.08 0.69-1.34c0.41-0.24 0.9-0.22 1.34 0.04l246.7 142.43c0.67 0.38 1.15 1.27 1.15 2.12v187.59c0 0.6-0.25 1.08-0.68 1.33c-0.19 0.11-0.4 0.17-0.62 0.17c-0.24 0-0.49-0.07-0.72-0.2zm-246.09-144.55c0 0.25 0.18 0.54 0.27 0.6l246.09 142.08v-187.02c0-0.25-0.18-0.54-0.27-0.6l-246.09-142.08v187.02z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m313.8 256.35v-10.83l252.26 145.64v10.83c0 1.66-1.16 2.33-2.6 1.5l-247.06-142.64c-1.44-0.83-2.6-2.84-2.6-4.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m563.02 404.25l-247.06-142.64c-1.7-0.99-3.04-3.3-3.04-5.26v-12.35l253.57 146.4l0.44 0.25v11.34c0 1.11-0.44 2-1.2 2.44c-0.33 0.19-0.71 0.29-1.11 0.29c-0.51 0-1.06-0.16-1.6-0.47zm-248.34-157.21v9.31c0 1.35 0.99 3.06 2.16 3.74l247.06 142.64c0.4 0.23 0.76 0.3 0.96 0.18c0.2-0.12 0.32-0.46 0.32-0.92v-10.32l-250.5-144.63z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m423.62 316.62l0.68-1.17l31.94 18.44l-0.67 1.17l-31.94-18.44z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m565.78 209.21l8.48-5.09l0.9 1.5l-8.48 5.09l-0.9-1.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m329.78 72.33l8.48-5.09l0.9 1.5l-8.48 5.09l-0.9-1.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m565.78 388.59l8.48-5.09l0.9 1.51l-8.48 5.09l-0.9-1.51z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m501.41 369.37l0.68-1.17l5.36 3.12l-0.68 1.17l-5.36-3.12z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m473.34 377.22l-95.05-54.21l0.87-1.52l95.05 54.21c1.04 0.59 2.31 0.57 3.32-0.05l5.72-3.15l0.75 1.49l-5.55 3.16c-0.8 0.5-1.71 0.75-2.63 0.75c-0.86 0-1.72-0.22-2.49-0.66z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m368.52 317.51c-0.75-0.42-1.2-1.18-1.21-2.03c-0.01-0.86 0.43-1.63 1.17-2.06l9.81-5.75l0.89 1.51l-9.81 5.75c-0.27 0.16-0.3 0.42-0.3 0.53c0 0.1 0.03 0.37 0.31 0.52l7.04 3.93l-0.85 1.53l-7.04-3.93z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m566.25 382.07l8.48-5.09l0.9 1.51l-8.48 5.09l-0.9-1.51z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m335.24 75.41l8.48-5.09l0.9 1.5l-8.48 5.09l-0.9-1.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m566.22 218.22l8.48-5.09l0.9 1.5l-8.47 5.09l-0.9-1.5z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m527.99 345.27l-176.4-101.85c-0.88-0.51-1.59-1.86-1.59-3.03v-126.13c0-1.17 0.71-1.7 1.59-1.2l176.4 101.85c0.88 0.51 1.59 1.86 1.59 3.03v126.13c0 1.17-0.71 1.7-1.59 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m528.62 346.15c-0.32 0-0.65-0.09-0.98-0.28l-176.4-101.84c-1.08-0.63-1.93-2.22-1.93-3.63v-126.13c0-0.87 0.33-1.55 0.9-1.88c0.5-0.29 1.13-0.26 1.73 0.08l176.4 101.85c1.08 0.63 1.93 2.22 1.93 3.63v126.13c0 0.87-0.33 1.55-0.9 1.88c-0.23 0.13-0.48 0.2-0.75 0.2zm-177.66-232.59c-0.03 0-0.05 0-0.06 0.01c-0.08 0.05-0.2 0.27-0.2 0.68v126.13c0 0.91 0.58 2.05 1.24 2.43l176.4 101.85c0.15 0.08 0.28 0.11 0.34 0.08c0.08-0.05 0.2-0.27 0.2-0.68v-126.13c0-0.91-0.58-2.05-1.24-2.43l-176.4-101.85c-0.11-0.06-0.21-0.1-0.28-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m342.94 238.43l-5.83-3.37c-0.88-0.51-1.59-1.86-1.59-3.03v-126.13c0-1.17 0.71-1.7 1.59-1.2l5.83 3.37c0.88 0.51 1.59 1.86 1.59 3.03v126.13c0 1.17-0.71 1.7-1.59 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m343.57 239.31c-0.32 0-0.65-0.09-0.98-0.28l-5.83-3.37c-1.08-0.63-1.93-2.22-1.93-3.63v-126.13c0-0.87 0.33-1.55 0.89-1.88c0.5-0.29 1.14-0.26 1.73 0.08l5.83 3.37c1.08 0.63 1.93 2.22 1.93 3.63v126.13c0 0.87-0.33 1.55-0.89 1.88c-0.23 0.13-0.49 0.2-0.75 0.2zm-0.29-1.48c0.15 0.09 0.28 0.12 0.35 0.08c0.07-0.04 0.2-0.24 0.2-0.68v-126.13c0-0.91-0.58-2.05-1.24-2.43l-5.83-3.37c-0.15-0.09-0.29-0.12-0.35-0.08c-0.07 0.04-0.2 0.23-0.2 0.68v126.13c0 0.91 0.58 2.05 1.24 2.43l5.83 3.37z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m548.58 357.16l-11.77-6.79c-0.88-0.51-1.59-1.86-1.59-3.03v-126.13c0-1.17 0.71-1.7 1.59-1.2l11.77 6.79c0.88 0.51 1.59 1.86 1.59 3.03v126.13c0 1.17-0.71 1.7-1.59 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m549.22 358.04c-0.32 0-0.65-0.09-0.98-0.28l-11.76-6.79c-1.08-0.62-1.93-2.22-1.93-3.63v-126.13c0-0.87 0.33-1.55 0.89-1.88c0.51-0.29 1.13-0.26 1.73 0.08l11.76 6.79c1.08 0.62 1.93 2.22 1.93 3.63v126.13c0 0.87-0.33 1.55-0.89 1.88c-0.23 0.13-0.48 0.2-0.75 0.2zm-0.29-1.48c0.15 0.08 0.28 0.12 0.35 0.08c0.08-0.05 0.2-0.27 0.2-0.68v-126.13c0-0.91-0.58-2.05-1.24-2.43l-11.76-6.79c-0.15-0.09-0.28-0.12-0.35-0.08c-0.07 0.04-0.2 0.23-0.2 0.68v126.13c0 0.91 0.58 2.05 1.24 2.43l11.77 6.79z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m527.99 225.86l-176.4-101.85c-0.88-0.51-1.59-1.86-1.59-3.03v-6.72c0-1.17 0.71-1.7 1.59-1.2l176.4 101.85c0.88 0.51 1.59 1.86 1.59 3.03v6.72c0 1.17-0.71 1.7-1.59 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m528.62 226.74c-0.32 0-0.65-0.09-0.98-0.28l-176.4-101.85c-1.08-0.63-1.93-2.22-1.93-3.63v-6.72c0-0.87 0.33-1.55 0.89-1.88c0.5-0.29 1.13-0.26 1.73 0.08l176.4 101.85c1.08 0.63 1.93 2.22 1.93 3.63v6.72c0 0.87-0.33 1.55-0.89 1.88c-0.23 0.13-0.49 0.2-0.75 0.2zm-177.66-113.17c-0.03 0-0.05 0-0.06 0.01c-0.08 0.05-0.2 0.27-0.2 0.68v6.72c0 0.91 0.58 2.05 1.24 2.43l176.4 101.85c0.15 0.09 0.28 0.12 0.34 0.08c0.08-0.05 0.2-0.27 0.2-0.68v-6.72c0-0.91-0.58-2.05-1.24-2.43l-176.4-101.85c-0.11-0.06-0.21-0.1-0.28-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m512 211.15c0 1.2-0.84 1.69-1.88 1.09c-1.04-0.6-1.88-2.06-1.88-3.26c0-1.2 0.84-1.69 1.88-1.09c1.04 0.6 1.88 2.06 1.88 3.26z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m518.21 214.74c0 1.2-0.84 1.69-1.88 1.09c-1.04-0.6-1.88-2.06-1.88-3.26c0-1.2 0.84-1.69 1.88-1.09c1.04 0.6 1.88 2.06 1.88 3.26z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m358.34 122.44c0 1.2-0.84 1.69-1.88 1.09c-1.04-0.6-1.88-2.06-1.88-3.26c0-1.2 0.84-1.69 1.88-1.09c1.04 0.6 1.88 2.06 1.88 3.26z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m364.55 126.02c0 1.2-0.84 1.69-1.88 1.09c-1.04-0.6-1.88-2.06-1.88-3.26c0-1.2 0.84-1.69 1.88-1.09c1.04 0.6 1.88 2.06 1.88 3.26z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m524.42 218.33c0 1.2-0.84 1.69-1.88 1.09c-1.04-0.6-1.88-2.06-1.88-3.26c0-1.2 0.84-1.69 1.88-1.09c1.04 0.6 1.88 2.06 1.88 3.26z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m388.38 189.43l-28.46-16.43c-0.88-0.51-1.59-1.86-1.59-3.03v-30.5c0-1.17 0.71-1.7 1.59-1.2l28.46 16.43c0.88 0.51 1.59 1.86 1.59 3.03v30.5c0 1.17-0.71 1.7-1.59 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m389.02 190.31c-0.32 0-0.65-0.09-0.98-0.28l-28.46-16.43c-1.08-0.63-1.93-2.22-1.93-3.63v-30.5c0-0.87 0.33-1.55 0.89-1.88c0.51-0.29 1.14-0.26 1.73 0.08l28.46 16.43c1.08 0.63 1.93 2.22 1.93 3.63v30.5c0 0.87-0.33 1.55-0.89 1.88c-0.23 0.13-0.49 0.2-0.75 0.2zm-0.29-1.48c0.15 0.09 0.28 0.11 0.35 0.08c0.07-0.04 0.2-0.23 0.2-0.68v-30.5c0-0.91-0.58-2.05-1.24-2.43l-28.46-16.43c-0.15-0.09-0.29-0.12-0.35-0.08c-0.07 0.04-0.2 0.23-0.2 0.68v30.5c0 0.91 0.58 2.05 1.24 2.43l28.46 16.43z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m520.14 288.53l-17.18-9.92c-0.88-0.51-1.59-1.86-1.59-3.03v-53.53c0-1.17 0.71-1.7 1.59-1.2l17.18 9.92c0.88 0.51 1.59 1.86 1.59 3.03v53.53c0 1.17-0.71 1.7-1.59 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m520.77 289.41c-0.32 0-0.65-0.09-0.98-0.28l-17.18-9.92c-1.08-0.63-1.93-2.22-1.93-3.63v-53.53c0-0.87 0.33-1.55 0.9-1.88c0.5-0.29 1.13-0.26 1.73 0.08l17.18 9.92c1.08 0.63 1.93 2.22 1.93 3.63v53.53c0 0.87-0.33 1.55-0.89 1.88c-0.23 0.13-0.48 0.2-0.75 0.2zm-0.29-1.48c0.15 0.09 0.28 0.12 0.35 0.08c0.08-0.05 0.2-0.27 0.2-0.68v-53.53c0-0.91-0.58-2.05-1.24-2.43l-17.18-9.92c-0.15-0.09-0.29-0.12-0.35-0.08c-0.08 0.05-0.2 0.27-0.2 0.68v53.53c0 0.91 0.58 2.05 1.24 2.43l17.18 9.92z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m520.14 300.23l-17.18-9.92c-0.88-0.51-1.59-1.86-1.59-3.03v-1.62c0-1.17 0.71-1.7 1.59-1.2l17.18 9.92c0.88 0.51 1.59 1.86 1.59 3.03v1.62c0 1.17-0.71 1.7-1.59 1.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s1",
    d: "m519.82 300.84l0.35-0.6l-0.37 0.59l-7.96-4.59l0.69-1.2l7.95 4.59l-0.67 1.21zm1.19-3.78c-0.12-0.86-0.64-1.75-1.21-2.08l-5.26-3.04l0.69-1.2l5.26 3.04c0.93 0.54 1.71 1.81 1.89 3.09l-1.37 0.19zm-13.14-3.12l-5.25-3.03c-0.94-0.54-1.72-1.82-1.89-3.11l1.37-0.19c0.12 0.85 0.65 1.77 1.21 2.09l5.25 3.03l-0.69 1.2zm2.69-4.3l-7.94-4.58l0.33-0.61l0.26-0.64l0.12 0.07l0-0.01l0 0.01l7.92 4.56l-0.69 1.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m520.14 331.44l-17.18-9.92c-0.88-0.51-1.59-1.86-1.59-3.03v-1.62c0-1.17 0.71-1.7 1.59-1.2l17.18 9.92c0.88 0.51 1.59 1.86 1.59 3.03v1.62c0 1.17-0.71 1.7-1.59 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m520.77 332.32c-0.32 0-0.65-0.09-0.98-0.28l0 0l-17.18-9.92c-1.08-0.63-1.93-2.22-1.93-3.63v-1.62c0-0.87 0.33-1.55 0.89-1.88c0.5-0.29 1.13-0.26 1.73 0.08l17.18 9.92c1.08 0.62 1.93 2.22 1.93 3.63v1.62c0 0.87-0.33 1.55-0.89 1.88c-0.23 0.13-0.49 0.2-0.75 0.2zm-0.29-1.48c0.15 0.09 0.28 0.12 0.35 0.08c0.08-0.05 0.2-0.27 0.2-0.68v-1.62c0-0.91-0.58-2.05-1.24-2.43l-17.18-9.92c-0.15-0.09-0.29-0.12-0.35-0.08c-0.07 0.04-0.2 0.23-0.2 0.68v1.62c0 0.91 0.58 2.05 1.24 2.43l17.18 9.92z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m520.14 319.24l-17.18-9.92c-0.88-0.51-1.59-1.86-1.59-3.03v-9.9c0-1.17 0.71-1.7 1.59-1.2l17.18 9.92c0.88 0.51 1.59 1.86 1.59 3.03v9.9c0 1.17-0.71 1.7-1.59 1.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s1",
    d: "m519.82 320.85l-6.92-3.99l0.69-1.2l6.89 3.98l-0.67 1.21zm2.6-3.27h-1.39v-7.96h1.39v7.96zm-12.97-2.71l-6.84-3.95l0.29-0.63l0.38-0.58l6.86 3.96l-0.69 1.2zm-7.38-8.07h-1.39v-7.96h1.39v7.96zm17.74-0.08l-6.86-3.96l0.69-1.2l6.85 3.95l-0.3 0.63l-0.38 0.58zm-10.31-5.95l-6.88-3.97l0.64-1.23l6.93 4l-0.69 1.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m388.38 255.37l-28.46-16.43c-0.88-0.51-1.59-1.86-1.59-3.03v-55.17c0-1.17 0.71-1.7 1.59-1.2l28.46 16.43c0.88 0.51 1.59 1.86 1.59 3.03v55.17c0 1.17-0.71 1.7-1.59 1.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s1",
    d: "m388.07 255.98l-0.01 0v0v0l-7.27-4.2l0.69-1.2l7.25 4.18l-0.66 1.22zm2.59-3.48h-1.39v-8.37h1.39v8.37zm-13.49-2.81l-7.25-4.18l0.69-1.2l7.25 4.18l-0.69 1.2zm-10.87-6.27l-6.72-3.88c-0.21-0.12-0.42-0.29-0.62-0.48l0.98-0.98c0.11 0.11 0.22 0.2 0.33 0.26l6.72 3.88l-0.69 1.2zm24.36-3.46h-1.39v-8.37h1.39v8.37zm-31.63-5.28h-1.39v-8.37h1.39v8.37zm31.63-7.27h-1.39v-8.37h1.39v8.37zm-31.63-5.28h-1.39v-8.37h1.39v8.37zm31.63-7.27h-1.39v-8.37h1.39v8.37zm-31.63-5.28h-1.39v-8.37h1.39v8.37zm31.63-7.27h-1.39v-3.31c0-0.91-0.58-2.05-1.24-2.43l-1.3-0.75l0.69-1.2l1.3 0.75c1.08 0.63 1.93 2.22 1.93 3.63v3.31zm-31.63-5.28h-1.39v-8.37h1.39v8.37zm24.08-3.3l-7.25-4.18l0.69-1.2l7.25 4.18l-0.69 1.2zm-10.87-6.27l-7.25-4.18l0.69-1.2l7.25 4.18l-0.69 1.2zm-13.21-2.98h-1.39v-3.74c0-2 1.47-2.46 2.62-1.8l1.8 1.04l-0.69 1.2l-1.8-1.04c-0.15-0.08-0.24-0.1-0.28-0.1c-0.15 0-0.26 0.3-0.26 0.7v3.74z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m494.15 316.43l-28.46-16.43c-0.88-0.51-1.59-1.86-1.59-3.03v-96.44c0-1.17 0.71-1.7 1.59-1.2l28.46 16.43c0.88 0.51 1.59 1.86 1.59 3.03v96.44c0 1.17-0.71 1.7-1.59 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m494.78 317.31c-0.32 0-0.65-0.09-0.98-0.28l-28.46-16.43c-1.08-0.63-1.93-2.22-1.93-3.63v-96.44c0-0.87 0.33-1.55 0.89-1.88c0.5-0.29 1.13-0.26 1.73 0.08l28.46 16.43c1.08 0.63 1.93 2.22 1.93 3.63v96.44c0 0.87-0.33 1.55-0.9 1.88c-0.23 0.13-0.48 0.2-0.75 0.2zm-29.72-117.48c-0.02 0-0.05 0-0.06 0.01c-0.08 0.05-0.2 0.27-0.2 0.68v96.44c0 0.91 0.58 2.05 1.24 2.43l28.46 16.43c0.15 0.09 0.28 0.12 0.35 0.08c0.08-0.05 0.2-0.27 0.2-0.68v-96.44c0-0.91-0.58-2.05-1.24-2.43l-28.46-16.43c-0.11-0.06-0.21-0.1-0.28-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m457.04 285.32l-3.77-2.18c-0.88-0.51-1.59-1.86-1.59-3.03v-86.75c0-1.17 0.71-1.7 1.59-1.2l3.77 2.18c0.88 0.51 1.59 1.86 1.59 3.03v86.75c0 1.17-0.71 1.7-1.59 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m457.67 286.2c-0.32 0-0.65-0.09-0.98-0.28l-3.77-2.18c-1.08-0.63-1.93-2.22-1.93-3.63v-86.75c0-0.87 0.33-1.55 0.89-1.88c0.5-0.29 1.13-0.26 1.73 0.08l3.77 2.18c1.08 0.63 1.93 2.22 1.93 3.63v86.75c0 0.87-0.33 1.55-0.89 1.88c-0.23 0.13-0.48 0.2-0.75 0.2zm-0.29-1.48c0.15 0.09 0.28 0.12 0.35 0.08c0.08-0.05 0.2-0.27 0.2-0.68v-86.75c0-0.91-0.58-2.05-1.24-2.43l-3.77-2.18c-0.15-0.08-0.28-0.12-0.34-0.08c-0.08 0.05-0.2 0.27-0.2 0.68v86.75c0 0.91 0.58 2.05 1.24 2.43l3.77 2.18z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m457.15 295.07l-4-2.31c-0.81-0.47-1.48-1.73-1.48-2.82c0-1.09 0.66-1.59 1.48-1.12l4 2.31c0.81 0.47 1.48 1.73 1.48 2.82c0 1.09-0.66 1.59-1.48 1.12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m457.74 295.94c-0.31 0-0.63-0.09-0.93-0.27l-4-2.31c-1.02-0.59-1.82-2.09-1.82-3.42c0-0.83 0.31-1.48 0.86-1.79c0.48-0.28 1.09-0.25 1.66 0.08l4 2.31c1.02 0.59 1.82 2.09 1.82 3.42c0 0.83-0.31 1.48-0.86 1.79c-0.22 0.13-0.47 0.19-0.72 0.19zm-5.17-6.59c-0.02 0-0.03 0-0.03 0.01c-0.04 0.02-0.16 0.19-0.16 0.59c0 0.84 0.53 1.87 1.13 2.22l4 2.31c0.15 0.09 0.25 0.09 0.27 0.08c0.04-0.03 0.16-0.19 0.16-0.59c0-0.84-0.53-1.87-1.13-2.22l-4-2.31c-0.11-0.06-0.19-0.08-0.24-0.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m444.4 246.43l-47.42-27.38c-0.88-0.51-1.59-1.86-1.59-3.03v-55.17c0-1.17 0.71-1.7 1.59-1.2l47.42 27.38c0.88 0.51 1.59 1.86 1.59 3.03v55.17c0 1.17-0.71 1.7-1.59 1.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s1",
    d: "m444.07 247.04l-0.03-0.02l-7.04-4.06l0.69-1.2l7.05 4.07l-0.67 1.21zm2.6-3.36h-1.39v-8.14h1.39v8.14zm-13.2-2.76l-7.05-4.07l0.69-1.2l7.05 4.07l-0.69 1.2zm-10.58-6.11l-7.05-4.07l0.69-1.2l7.05 4.07l-0.69 1.2zm23.78-3.35h-1.39v-8.14h1.39v8.14zm-34.35-2.76l-7.05-4.07l0.69-1.2l7.05 4.07l-0.69 1.2zm-10.58-6.11l-5.12-2.96c-0.67-0.39-1.29-1.17-1.64-2.09l1.3-0.49c0.24 0.62 0.63 1.15 1.03 1.39l5.12 2.95l-0.69 1.2zm44.93-3.35h-1.39v-8.14h1.39v8.14zm-50.59-5.99h-1.39v-8.14h1.39v8.14zm50.59-6.22h-1.39v-8.14h1.39v8.14zm-50.59-5.99h-1.39v-8.14h1.39v8.14zm50.59-6.22h-1.39v-4.77c0-0.86-0.51-1.92-1.14-2.37l0.8-1.13c1 0.71 1.73 2.18 1.72 3.5v4.77zm-50.59-5.99h-1.39v-8.14h1.39v8.14zm44.6-3.16l-7.05-4.07l0.69-1.2l7.05 4.07l-0.69 1.2zm-10.58-6.11l-7.05-4.07l0.69-1.2l7.05 4.07l-0.69 1.2zm-34.03-2.95h-1.39v-8.14h1.39v8.14zm23.45-3.16l-7.05-4.07l0.69-1.2l7.05 4.07l-0.69 1.2zm-10.58-6.11l-7.05-4.07l0.69-1.2l7.05 4.07l-0.69 1.2zm-12.87-2.95h-1.39v-3.57c0-2 1.47-2.46 2.62-1.8l1.75 1.01l-0.69 1.2l-1.75-1.01c-0.15-0.08-0.24-0.1-0.28-0.1c-0.15 0-0.26 0.3-0.26 0.7v3.57z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m444.4 265.31l-47.42-27.38c-0.88-0.51-1.59-1.86-1.59-3.03v-8.1c0-1.17 0.71-1.7 1.59-1.2l47.42 27.38c0.88 0.51 1.59 1.86 1.59 3.03v8.1c0 1.17-0.71 1.7-1.59 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m445.03 266.19c-0.32 0-0.65-0.09-0.98-0.28l-47.42-27.38c-1.08-0.63-1.93-2.22-1.93-3.63v-8.1c0-0.87 0.33-1.55 0.9-1.88c0.5-0.29 1.13-0.26 1.73 0.08l47.42 27.38c1.08 0.63 1.93 2.22 1.93 3.63v8.1c0 0.87-0.33 1.55-0.89 1.88c-0.23 0.13-0.49 0.2-0.75 0.2zm-0.29-1.48c0.15 0.09 0.28 0.12 0.35 0.08c0.07-0.04 0.2-0.23 0.2-0.68v-8.1c0-0.91-0.58-2.05-1.24-2.43l-47.42-27.38c-0.15-0.09-0.28-0.12-0.35-0.08c-0.08 0.05-0.2 0.27-0.2 0.68v8.1c0 0.91 0.58 2.05 1.24 2.43l47.42 27.38z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m444.4 287.71l-47.42-27.38c-0.88-0.51-1.59-1.86-1.59-3.03v-12.13c0-1.17 0.71-1.7 1.59-1.2l47.42 27.38c0.88 0.51 1.59 1.86 1.59 3.03v12.13c0 1.17-0.71 1.7-1.59 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m445.03 288.59c-0.32 0-0.65-0.09-0.98-0.28l-47.42-27.38c-1.08-0.63-1.93-2.22-1.93-3.63v-12.13c0-0.87 0.33-1.55 0.89-1.88c0.51-0.29 1.13-0.26 1.73 0.08l47.42 27.38c1.08 0.63 1.93 2.22 1.93 3.63v12.13c0 0.87-0.33 1.55-0.89 1.88c-0.23 0.13-0.49 0.2-0.75 0.2zm-0.29-1.48c0.15 0.09 0.28 0.12 0.35 0.08c0.07-0.04 0.2-0.23 0.2-0.68v-12.13c0-0.91-0.58-2.05-1.24-2.43l-47.42-27.38c-0.15-0.09-0.28-0.12-0.35-0.08c-0.07 0.04-0.2 0.23-0.2 0.68v12.13c0 0.91 0.58 2.05 1.24 2.43l47.42 27.38z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m542.7 228.88v119.67v-119.67z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s1",
    d: "m543.39 348.55h-1.39v-7.47h1.39v7.47zm0-11.63h-1.39v-8.31h1.39v8.31zm0-12.47h-1.39v-8.31h1.39v8.31zm0-12.47h-1.39v-8.31h1.39v8.31zm0-12.47h-1.39v-8.31h1.39v8.31zm0-12.47h-1.39v-8.31h1.39v8.31zm0-12.47h-1.39v-8.31h1.39v8.31zm0-12.47h-1.39v-8.31h1.39v8.31zm0-12.47h-1.39v-8.31h1.39v8.31zm0-12.47h-1.39v-8.31h1.39v8.31z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m329.81 100.49v130.36v-130.36z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s1",
    d: "m330.5 230.85h-1.39v-5.69h1.39v5.69zm0-9.85h-1.39v-8.31h1.39v8.31zm0-12.47h-1.39v-8.31h1.39v8.31zm0-12.47h-1.39v-8.31h1.39v8.31zm0-12.47h-1.39v-8.31h1.39v8.31zm0-12.47h-1.39v-8.31h1.39v8.31zm0-12.47h-1.39v-8.31h1.39v8.31zm0-12.47h-1.39v-8.31h1.39v8.31zm0-12.47h-1.39v-8.31h1.39v8.31zm0-12.47h-1.39v-8.31h1.39v8.31zm0-12.47h-1.39v-8.31h1.39v8.31z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m403.4 258.19c0 1.2-0.84 1.69-1.88 1.09c-1.04-0.6-1.88-2.06-1.88-3.26c0-1.2 0.84-1.69 1.88-1.09c1.04 0.6 1.88 2.06 1.88 3.26z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m508.87 275.47c0 1.2-0.84 1.69-1.88 1.09c-1.04-0.6-1.88-2.06-1.88-3.26c0-1.2 0.84-1.69 1.88-1.09c1.04 0.6 1.88 2.06 1.88 3.26z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m364.55 146.72c0 1.2-0.84 1.69-1.88 1.09c-1.04-0.6-1.88-2.06-1.88-3.26c0-1.2 0.84-1.69 1.88-1.09c1.04 0.6 1.88 2.06 1.88 3.26z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m471.45 208.45c0 1.2-0.84 1.69-1.88 1.09c-1.04-0.6-1.88-2.06-1.88-3.26c0-1.2 0.84-1.69 1.88-1.09c1.04 0.6 1.88 2.06 1.88 3.26z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m577.46 323.95v11.1c0 0.6-0.19 1.03-0.49 1.24l-7.41 4.4c-0.03 0.02-0.07 0.01-0.09-0.02l-7.38-12.36c-0.01-0.01-0.01-0.02-0.02-0.02l-14.66-8.47c-0.88-0.51-1.59-1.86-1.59-3.03v3.68c0-0.01 0-0.02-0.01-0.03l-6.88-11.53c-0.02-0.03-0.01-0.07 0.02-0.09l7.32-4.34c0.04-0.03 0.08-0.05 0.12-0.07h0c0.28-0.15 0.63-0.14 1.02 0.08l28.46 16.43c0.88 0.51 1.59 1.86 1.59 3.03z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m569.28 341.91l-0.56-0.76l-7.28-12.19l-14.47-8.36c-0.08-0.05-0.16-0.1-0.23-0.15v0.02h-0.9l-0.76 0.47l-7.37-12.35l0.8-0.55l7.44-4.41c0.59-0.32 1.28-0.29 1.92 0.08l28.46 16.43c1.16 0.67 2.04 2.31 2.04 3.81v11.1c0 0.87-0.31 1.57-0.86 1.97l-8.22 4.89zm-24.35-25.12h1.8c0 0.91 0.6 1.94 1.13 2.25l14.87 8.59l0.14 0.23l6.94 11.63l6.69-3.97c-0.02 0 0.04-0.14 0.04-0.46v-11.1c0-0.91-0.6-1.94-1.13-2.25l-28.46-16.43c-0.09-0.05-0.15-0.06-0.16-0.06h0l-6.66 3.96l4.79 8.02v-0.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m570.07 328.35c0.01-0.01 0.02-0.02 0.03-0.03l7.25-4.31c0.05-0.03 0.12 0.01 0.12 0.07v10.96c0 0.6-0.19 1.03-0.49 1.24l-7.34 4.36c-0.08-0.02-0.12-0.03-0.2-0.05l-7.34-12.29c-0.01-0.01-0.01-0.02-0.02-0.02l-1.15-0.66l-0.2-3.35c0-0.02 0-0.03 0.01-0.05l9.32 4.13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m569.78 341.61l-0.92-0.23l-7.42-12.43l-1.38-0.8l-0.25-4.11l0.56-0.97l9.62 4.26l7.34-4.36l0.99 0.52l0.04 0.59v10.96c0 0.87-0.31 1.57-0.86 1.97l-7.73 4.59zm-7.97-14.53l0.94 0.54l0.14 0.23l6.94 11.63l6.69-3.97c-0.02 0 0.04-0.14 0.04-0.46v-9.52l-5.83 3.46l-0.3 0.51l-8.72-3.86l0.09 1.44z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m568.49 340.63l-28.46-16.43c-0.88-0.51-1.59-1.86-1.59-3.03v-11.1c0-1.17 0.71-1.7 1.59-1.2l28.46 16.43c0.88 0.51 1.59 1.86 1.59 3.03v11.1c0 1.17-0.71 1.7-1.59 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m569.12 341.72c-0.35 0-0.73-0.1-1.08-0.31l-28.46-16.43c-1.16-0.67-2.04-2.31-2.04-3.81v-11.1c0-0.94 0.37-1.7 1-2.06c0.57-0.33 1.27-0.3 1.94 0.08l28.46 16.43c1.16 0.67 2.04 2.31 2.04 3.81v11.1c0 0.94-0.37 1.7-1 2.06c-0.26 0.15-0.55 0.23-0.85 0.23zm-29.72-32.14c0.03 0-0.06 0.16-0.06 0.49v11.1c0 0.91 0.6 1.94 1.13 2.25l28.46 16.43c0.1 0.06 0.16 0.07 0.18 0.07c-0.03-0.01 0.06-0.16 0.06-0.49v-11.1c0-0.91-0.6-1.94-1.13-2.25l-28.46-16.43c-0.1-0.06-0.16-0.07-0.18-0.07z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m544.74 312.42l-0.95-1.53l7.1-4.42l0.95 1.53l-7.1 4.42z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m571.09 335.38l-0.71-1.19l6.25-3.76l0.71 1.19l-6.25 3.76z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m367.35 164.61v5.61c0 0.24-0.1 0.49-0.31 0.75l-7.12 4.44c-0.13 0.08-0.31 0.04-0.39-0.1l-7.54-8.5c-0.02-0.04-0.06-0.08-0.1-0.1l-2.35 2.8c-0.52-0.3-0.94-1.1-0.94-1.8v-2.37c0-0.05-0.01-0.1-0.04-0.14l-6.85-7.34c-0.08-0.13-0.04-0.3 0.09-0.38l7.1-4.42c0.17-0.11 0.39-0.12 0.64 0.03l16.87 9.74c0.52 0.3 0.94 1.1 0.94 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m359.78 176.34c-0.09 0-0.19-0.01-0.28-0.03c-0.27-0.06-0.51-0.23-0.68-0.45l-6.9-7.78l-2.18 2.59l-0.65-0.38c-0.79-0.46-1.39-1.57-1.39-2.58v-2.12l-6.76-7.28c-0.33-0.55-0.15-1.27 0.39-1.61l7.09-4.42c0.44-0.29 1.04-0.29 1.56 0.01l16.87 9.74c0.79 0.46 1.39 1.56 1.39 2.58v5.61c0 0.66-0.43 1.21-0.51 1.32l-0.22 0.19l-7.12 4.44c-0.19 0.12-0.4 0.18-0.62 0.18zm-7.07-10.09l7.19 8.1l6.51-4.06c0.02-0.04 0.04-0.08 0.05-0.11l0-5.58c0-0.43-0.29-0.9-0.49-1.02l-16.75-9.67l-6.28 3.91l6.41 6.9c0.11 0.18 0.17 0.39 0.17 0.6v2.37c0 0.12 0.02 0.25 0.06 0.37l2.13-2.53l0.65 0.38c0.14 0.08 0.26 0.19 0.36 0.32z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m360.02 169.24c0.02-0.03 0.04-0.05 0.07-0.07l7.02-4.38c0.13-0.08 0.29 0.01 0.29 0.16v5.26c0 0.24-0.1 0.49-0.31 0.75l-6.95 4.33c-0.23 0.14-0.52 0.07-0.66-0.16l-4.97-4.19c0.02-0.2 0.04-0.35 0.05-0.47l5.45-1.24z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m359.9 176.27c-0.11 0-0.22-0.01-0.33-0.04c-0.3-0.07-0.56-0.24-0.75-0.48l-5.25-4.42l0.17-1.58l5.87-1.33l7.02-4.38c0.34-0.21 0.76-0.22 1.11-0.03c0.35 0.19 0.56 0.56 0.56 0.95v5.26c0 0.66-0.43 1.21-0.51 1.32l-0.22 0.19l-6.95 4.33c-0.22 0.14-0.47 0.21-0.72 0.21zm-3.84-5.2l3.9 3.29l6.5-4.05c0.02-0.04 0.04-0.08 0.05-0.11l0-3.96l-5.8 3.61l-0.11 0.19l-4.54 1.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m359.05 175.52l-16.87-9.74c-0.52-0.3-0.94-1.1-0.94-1.8v-5.61c0-0.69 0.42-1.01 0.94-0.71l16.87 9.74c0.52 0.3 0.94 1.1 0.94 1.8v5.61c0 0.69-0.42 1.01-0.94 0.71z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m359.43 176.53c-0.27 0-0.55-0.08-0.83-0.23l-16.87-9.74c-0.79-0.46-1.39-1.57-1.39-2.58v-5.61c0-0.69 0.28-1.26 0.78-1.54c0.45-0.26 1.01-0.24 1.51 0.05l16.87 9.74c0.79 0.46 1.39 1.56 1.39 2.58v5.61c0 0.69-0.28 1.25-0.78 1.54c-0.21 0.12-0.45 0.18-0.69 0.18zm0.07-1.79l-0.45 0.78l0.46-0.77c0 0-0.01 0-0.01 0zm-17.35-16.05l-0.01 5.29c0 0.42 0.29 0.9 0.49 1.02l16.45 9.49l0.01-5.29c0-0.43-0.29-0.9-0.49-1.02l-16.45-9.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m346.86 160.53l-0.95-1.53l7.1-4.42l0.95 1.53l-7.1 4.42z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m360.98 173.11l-0.71-1.19l6.25-3.76l0.71 1.19l-6.25 3.76z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m367.51 193.56v5.61c0 0.24-0.1 0.49-0.31 0.74l-7.12 4.44c-0.13 0.08-0.31 0.04-0.39-0.1l3.5-2.18c-0.02-0.04-0.06-0.08-0.1-0.1c-0.52-0.3-3.29 1.7-3.29 1v-2.37c0-0.05-0.01-0.1-0.04-0.14l-6.85-7.34c-0.08-0.13-0.04-0.3 0.09-0.38l7.1-4.42c0.17-0.11 0.39-0.12 0.64 0.03l5.84 3.42c0.52 0.3 0.94 1.1 0.94 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m359.93 205.28c-0.09 0-0.19-0.01-0.28-0.03c-0.31-0.08-0.57-0.27-0.73-0.54l-0.45-0.76l0.53-0.33l-0.04-0.03l-0.06-0.62v-2.12l-6.76-7.28c-0.33-0.55-0.15-1.27 0.39-1.61l7.1-4.42c0.44-0.29 1.03-0.3 1.56 0.01l5.84 3.42c0.79 0.46 1.39 1.56 1.39 2.57v5.61c0 0.66-0.43 1.21-0.52 1.32l-0.22 0.19l-7.12 4.44c-0.19 0.12-0.41 0.18-0.63 0.18zm-5.82-12.19l6.4 6.88c0.12 0.19 0.18 0.4 0.18 0.62v1.28c0.1-0.05 0.19-0.09 0.28-0.14c1.08-0.53 1.86-0.93 2.52-0.59l3.08-1.92c0.02-0.04 0.04-0.08 0.05-0.11l0-5.58c0-0.43-0.29-0.9-0.49-1.02l0 0l-5.72-3.35l-6.28 3.91z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m360.17 198.18c0.02-0.03 0.04-0.05 0.07-0.07l7.02-4.38c0.13-0.08 0.29 0.01 0.29 0.16v5.26c0 0.24-0.1 0.49-0.31 0.74l-6.95 4.33c-0.23 0.14-0.52 0.07-0.66-0.16l-4.97-4.19c0.02-0.2 0.04-0.35 0.05-0.47l5.45-1.24z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m360.05 205.21c-0.11 0-0.22-0.01-0.33-0.04c-0.3-0.07-0.56-0.24-0.75-0.48l-5.25-4.42l0.17-1.58l5.87-1.33l7.02-4.38c0.34-0.21 0.76-0.22 1.11-0.03c0.35 0.19 0.56 0.56 0.56 0.96v5.26c0 0.66-0.43 1.21-0.52 1.32l-0.22 0.19l-6.95 4.33c-0.22 0.14-0.47 0.21-0.73 0.21zm-3.84-5.2l3.9 3.29l6.5-4.05c0.02-0.04 0.04-0.08 0.05-0.11l0-3.96l-5.79 3.61l-0.11 0.19l-4.55 1.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m359.21 204.46l-5.84-3.42c-0.52-0.3-0.94-1.1-0.94-1.8v-5.61c0-0.69 0.42-1.01 0.94-0.71l5.84 3.42c0.52 0.3 0.94 1.1 0.94 1.8v5.61c0 0.69-0.42 1.01-0.94 0.71z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m359.58 205.47c-0.27 0-0.55-0.08-0.83-0.23l0 0l-5.84-3.42c-0.79-0.45-1.39-1.56-1.39-2.57v-5.61c0-0.69 0.28-1.26 0.78-1.54c0.45-0.26 1.01-0.24 1.52 0.05l5.84 3.42c0.79 0.45 1.39 1.56 1.39 2.57v5.61c0 0.69-0.28 1.25-0.78 1.54c-0.21 0.12-0.45 0.18-0.69 0.18zm0.08-1.79l-0.45 0.78l0.46-0.77c0 0 0 0-0.01 0zm-6.32-9.73l-0.01 5.29c0 0.43 0.29 0.9 0.49 1.02l5.41 3.17l0.01-5.29c0-0.43-0.29-0.9-0.49-1.02l-5.41-3.17z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m361.13 201.67l-0.71-1.19l6.25-3.76l0.71 1.19l-6.25 3.76z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m422.67 215.56v5.61c0 0.24-0.1 0.49-0.31 0.74l-7.12 4.44c-0.13 0.08-0.31 0.04-0.39-0.09l3.5-2.18c-0.02-0.04-0.06-0.08-0.1-0.1c-0.52-0.3-3.29 1.7-3.29 1v-2.37c0-0.05-0.01-0.1-0.04-0.14l-6.85-7.34c-0.08-0.13-0.04-0.3 0.09-0.38l7.1-4.42c0.17-0.11 0.39-0.12 0.64 0.03l5.84 3.42c0.52 0.3 0.94 1.1 0.94 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m415.09 227.29c-0.09 0-0.19-0.01-0.28-0.03c-0.31-0.08-0.57-0.27-0.73-0.54l-0.45-0.76l0.53-0.33l-0.04-0.03l-0.06-0.62v-2.12l-6.76-7.28c-0.33-0.55-0.15-1.27 0.39-1.61l7.1-4.42c0.44-0.29 1.03-0.3 1.56 0.01l5.84 3.42c0.79 0.46 1.39 1.56 1.39 2.57v5.61c0 0.66-0.43 1.21-0.52 1.32l-0.22 0.19l-7.12 4.44c-0.19 0.12-0.41 0.18-0.63 0.18zm-5.82-12.19l6.4 6.88c0.12 0.19 0.18 0.4 0.18 0.62v1.28c0.1-0.05 0.19-0.09 0.28-0.14c1.08-0.53 1.86-0.93 2.52-0.59l3.08-1.92c0.02-0.04 0.04-0.08 0.05-0.11l0-5.58c0-0.43-0.29-0.9-0.49-1.02l0 0l-5.72-3.35l-6.28 3.91z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m415.33 220.19c0.02-0.03 0.04-0.05 0.07-0.07l7.02-4.38c0.13-0.08 0.29 0.01 0.29 0.16v5.26c0 0.24-0.1 0.49-0.31 0.74l-6.95 4.33c-0.23 0.14-0.52 0.07-0.66-0.16l-4.97-4.19c0.02-0.2 0.04-0.35 0.05-0.47l5.45-1.24z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m415.21 227.21c-0.11 0-0.22-0.01-0.33-0.04c-0.3-0.07-0.56-0.24-0.75-0.48l-5.25-4.42l0.17-1.58l5.87-1.33l7.02-4.38c0.34-0.21 0.76-0.22 1.11-0.03c0.35 0.19 0.56 0.56 0.56 0.96v5.26c0 0.66-0.43 1.21-0.52 1.32l-0.22 0.19l-6.95 4.33c-0.22 0.14-0.47 0.21-0.73 0.21zm-3.84-5.2l3.9 3.29l6.5-4.05c0.02-0.04 0.04-0.08 0.05-0.11l0-3.96l-5.79 3.61l-0.11 0.19l-4.55 1.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m414.37 226.46l-5.84-3.42c-0.52-0.3-0.94-1.1-0.94-1.8v-5.61c0-0.69 0.42-1.01 0.94-0.71l5.84 3.42c0.52 0.3 0.94 1.1 0.94 1.8v5.61c0 0.69-0.42 1.01-0.94 0.71z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m414.74 227.47c-0.27 0-0.55-0.08-0.83-0.23l0 0l-5.84-3.42c-0.79-0.45-1.39-1.56-1.39-2.57v-5.61c0-0.69 0.28-1.26 0.78-1.54c0.45-0.26 1.01-0.24 1.52 0.05l5.84 3.42c0.79 0.45 1.39 1.56 1.39 2.57v5.61c0 0.69-0.28 1.25-0.78 1.54c-0.21 0.12-0.45 0.18-0.69 0.18zm0.08-1.79l-0.45 0.78l0.46-0.77c0 0 0 0-0.01 0zm-6.32-9.73l-0.01 5.29c0 0.43 0.29 0.9 0.49 1.02l5.41 3.17l0.01-5.29c0-0.43-0.29-0.9-0.49-1.02l-5.41-3.17z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m416.29 223.67l-0.71-1.19l6.25-3.76l0.71 1.19l-6.25 3.76z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s0",
    d: "m528.36 162.08l-0.46 0.77l0.45-0.78c0 0 0 0 0.01 0z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m545.6 250.25v5.61c0 0.24-0.1 0.49-0.31 0.75l-7.12 4.44c-0.13 0.08-0.31 0.04-0.39-0.1l3.5-2.18c-0.02-0.04-0.06-0.08-0.1-0.1c-0.52-0.3-3.29 1.7-3.29 1v-2.37c0-0.05-0.01-0.1-0.04-0.14l-6.85-7.34c-0.08-0.13-0.04-0.3 0.09-0.38l7.1-4.42c0.17-0.11 0.39-0.12 0.64 0.03l5.84 3.42c0.52 0.3 0.94 1.1 0.94 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m538.03 261.98c-0.09 0-0.19-0.01-0.28-0.03c-0.31-0.08-0.57-0.27-0.74-0.54l-0.45-0.76l0.52-0.33l-0.04-0.03l-0.06-0.62v-2.12l-6.76-7.28c-0.33-0.56-0.16-1.26 0.39-1.61l7.1-4.42c0.44-0.29 1.03-0.3 1.56 0.01l5.84 3.42c0.79 0.46 1.39 1.56 1.39 2.57v5.6c0 0.66-0.43 1.21-0.51 1.32l-0.22 0.19l-7.12 4.44c-0.19 0.12-0.41 0.18-0.62 0.18zm-5.82-12.19l6.41 6.91c0.11 0.18 0.16 0.39 0.16 0.6v1.28c0.1-0.05 0.19-0.09 0.28-0.14c1.08-0.53 1.86-0.93 2.52-0.59l3.08-1.92c0.02-0.04 0.04-0.08 0.05-0.11l0-5.58c0-0.43-0.29-0.9-0.49-1.02l0 0l-5.72-3.35l-6.28 3.91z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m538.27 254.88c0.02-0.03 0.04-0.05 0.07-0.07l7.02-4.38c0.13-0.08 0.29 0.01 0.29 0.16v5.26c0 0.24-0.1 0.49-0.31 0.75l-6.95 4.33c-0.23 0.14-0.52 0.07-0.66-0.16l-4.97-4.19c0.02-0.2 0.04-0.35 0.05-0.47l5.45-1.24z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m538.14 261.9c-0.11 0-0.22-0.01-0.33-0.04c-0.3-0.07-0.56-0.24-0.75-0.48l-5.25-4.42l0.17-1.58l5.87-1.33l7.02-4.38c0.34-0.21 0.76-0.22 1.11-0.03c0.35 0.19 0.56 0.56 0.56 0.96v5.26c0 0.66-0.43 1.21-0.51 1.32l-0.22 0.19l-6.95 4.33c-0.22 0.14-0.47 0.21-0.72 0.21zm-3.84-5.2l3.9 3.29l6.5-4.05c0.02-0.04 0.04-0.08 0.05-0.11l0-3.96l-5.79 3.61l-0.11 0.19l-4.55 1.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m537.3 261.15l-5.84-3.42c-0.52-0.3-0.94-1.1-0.94-1.8v-5.61c0-0.69 0.42-1.01 0.94-0.71l5.84 3.42c0.52 0.3 0.94 1.1 0.94 1.8v5.61c0 0.69-0.42 1.01-0.94 0.71z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m537.68 262.17c-0.27 0-0.55-0.08-0.83-0.23l0 0l-5.84-3.42c-0.79-0.45-1.39-1.56-1.39-2.57v-5.61c0-0.69 0.28-1.25 0.78-1.54c0.46-0.26 1.01-0.24 1.52 0.05l5.84 3.42c0.79 0.45 1.39 1.56 1.39 2.57v5.61c0 0.69-0.28 1.26-0.78 1.54c-0.21 0.12-0.45 0.18-0.69 0.18zm0.08-1.79l-0.45 0.78l0.46-0.77c0 0 0 0-0.01 0zm-6.32-9.73l-0.01 5.29c0 0.43 0.29 0.9 0.49 1.02l5.41 3.17l0.01-5.29c0-0.43-0.29-0.9-0.49-1.02l-5.42-3.17z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m539.22 258.36l-0.71-1.19l6.25-3.76l0.71 1.19l-6.25 3.76z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m438.34 196.28v55.17c0 0.6-0.19 1.03-0.5 1.24l-7 4.14c-0.17 0.1-0.39 0.04-0.49-0.13l-6.55-11.47c-0.03-0.05-0.08-0.1-0.13-0.13l-34.34-19.83c-0.88-0.51-1.59-1.86-1.59-3.03v-40.07c0-0.06-0.02-0.12-0.05-0.18l-6.58-11.52c-0.1-0.17-0.04-0.38 0.13-0.48l6.96-4.14c0.02-0.01 0.04-0.02 0.05-0.03l0 0c0.28-0.19 0.66-0.19 1.08 0.05l47.42 27.38c0.88 0.51 1.59 1.86 1.59 3.03z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m430.67 257.78c-0.11 0-0.21-0.01-0.32-0.04c-0.33-0.09-0.6-0.3-0.77-0.59l-6.48-11.35l-34.22-19.75c-1.16-0.67-2.04-2.31-2.04-3.81v-39.93l-6.51-11.4c-0.34-0.59-0.14-1.35 0.45-1.7l6.96-4.14c0.61-0.4 1.34-0.39 2.04 0.01l47.42 27.38c1.16 0.67 2.04 2.31 2.04 3.81v55.17c0 0.89-0.32 1.59-0.89 1.98l-7.05 4.17c-0.19 0.12-0.41 0.18-0.64 0.18zm-48.5-87.29l6.31 11.06c0.11 0.2 0.17 0.41 0.17 0.62v40.07c0 0.91 0.6 1.94 1.13 2.25l34.34 19.83c0.2 0.12 0.36 0.28 0.46 0.47l6.27 10.99l6.52-3.85c0 0 0 0 0 0c-0.02 0 0.06-0.15 0.06-0.47v-55.17c0-0.91-0.6-1.94-1.14-2.25l-47.42-27.38c-0.09-0.05-0.15-0.07-0.17-0.07l-6.54 3.9zm55.21 81.43c0 0 0 0 0 0l0 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m411.48 215.41l19.47-14.74c0 0 0.01 0 0.01-0.01l7.22-4.29c0.07-0.04 0.16 0.01 0.16 0.09v54.98c0 0.6-0.19 1.03-0.5 1.24l-6.91 4.08c-0.22 0.13-0.51 0.06-0.63-0.17l-6.48-11.35c-0.06-0.06-0.11-0.11-0.17-0.17l-7.14-4.12c-0.03-0.02-0.05-0.04-0.05-0.07c-2.4-12.18-4.83-24.42-5.02-25.38c-0.01-0.04 0.01-0.08 0.04-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m430.71 257.74c-0.12 0-0.23-0.02-0.35-0.05c-0.36-0.09-0.65-0.32-0.83-0.64l-6.43-11.25l-7.39-4.27l-0.12-0.48c-2.18-11.04-4.38-22.15-4.91-24.82l-0.22-1.09l0.48-0.44l19.47-14.74l7.77-4.62l0.57 0.26c0.31 0.18 0.51 0.51 0.51 0.87v54.98c0 0.89-0.32 1.59-0.89 1.98l-6.96 4.12c-0.21 0.13-0.45 0.19-0.69 0.19zm-13.43-17.38l7.33 4.44l6.26 10.97l6.52-3.85c0 0 0 0 0 0c-0.02 0 0.06-0.15 0.06-0.47v-53.59l-6.02 3.58l-19 14.39l0.01 0.05c0.52 2.64 2.69 13.55 4.85 24.48zm20.11 11.55c0 0 0 0 0 0l0 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m429.37 257.03l-47.42-27.38c-0.88-0.51-1.59-1.86-1.59-3.03v-55.17c0-1.17 0.71-1.7 1.59-1.2l47.42 27.38c0.88 0.51 1.59 1.86 1.59 3.03v55.17c0 1.17-0.71 1.7-1.59 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m430 258.12c-0.35 0-0.73-0.1-1.08-0.31h0l-47.42-27.38c-1.16-0.67-2.04-2.31-2.04-3.81v-55.17c0-0.94 0.36-1.7 1-2.06c0.57-0.33 1.28-0.3 1.94 0.08l47.42 27.38c1.16 0.67 2.04 2.31 2.04 3.81v55.17c0 0.94-0.36 1.7-1 2.06c-0.26 0.15-0.55 0.23-0.85 0.23zm-0.18-1.87c0.1 0.06 0.16 0.07 0.18 0.07h0c-0.03 0 0.05-0.16 0.05-0.49v-55.17c0-0.91-0.6-1.94-1.13-2.25l-47.42-27.38c-0.1-0.06-0.16-0.07-0.18-0.07c0.03 0.01-0.06 0.16-0.06 0.49v55.17c0 0.91 0.6 1.94 1.13 2.25l47.42 27.38h0z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m387.57 173.86l-0.95-1.53l7.1-4.42l0.95 1.53l-7.1 4.42z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m431.96 248.45l-0.71-1.19l6.25-3.76l0.71 1.19l-6.25 3.76z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m577.22 283.93v30.5c0 0.6-0.19 1.03-0.49 1.24l-7.41 4.4c-0.03 0.02-0.07 0.01-0.09-0.02l-7.38-12.36c-0.01-0.01-0.01-0.02-0.02-0.02l-14.66-8.47c-0.88-0.51-1.59-1.86-1.59-3.03v-15.73c0-0.01 0-0.02-0.01-0.03l-6.88-11.53c-0.02-0.03-0.01-0.07 0.02-0.09l7.32-4.34c0.04-0.03 0.08-0.05 0.12-0.07l0 0c0.28-0.15 0.63-0.14 1.02 0.08l28.46 16.43c0.88 0.51 1.59 1.86 1.59 3.03z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m569.46 321.04l-0.78-0.19l-0.23-0.35l-7.26-12.16l-14.47-8.36c-1.16-0.67-2.04-2.31-2.04-3.81v-15.5l-6.95-11.65l0.17-0.78l0.36-0.23l7.43-4.41c0.59-0.32 1.28-0.29 1.92 0.08l28.46 16.43c1.16 0.67 2.04 2.31 2.04 3.81v30.5c0 0.88-0.31 1.58-0.87 1.97l-7.79 4.63zm-29.56-51.9l6.58 11.02l0.01 0.28v15.73c0 0.91 0.6 1.94 1.13 2.25l14.87 8.59l0.14 0.23l6.94 11.63l6.69-3.97c-0.04 0.02 0.04-0.13 0.04-0.46v-30.5c0-0.91-0.6-1.94-1.13-2.25l-28.46-16.43c-0.09-0.05-0.15-0.06-0.16-0.06c0 0 0 0 0 0l-6.66 3.96z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m569.82 288.33c0.01-0.01 0.02-0.02 0.03-0.03l7.25-4.31c0.05-0.03 0.12 0.01 0.12 0.07v30.37c0 0.6-0.19 1.03-0.49 1.24l-7.34 4.36c-0.08-0.02-0.12-0.03-0.2-0.05l-7.34-12.29c-0.01-0.01-0.01-0.02-0.02-0.02l-1.15-0.66l-0.2-3.35c0-0.02 0-0.03 0.01-0.05l9.32-15.28z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m569.53 320.99l-0.92-0.24l-7.42-12.42l-1.38-0.8l-0.25-4.11l0.16-0.29l9.43-15.46l0.21-0.14l7.72-4.58l0.99 0.52l0.04 0.59v30.37c0 0.88-0.31 1.58-0.87 1.97l-7.72 4.59zm-7.97-14.53l0.94 0.54l0.14 0.23l6.94 11.63l6.69-3.97c-0.04 0.02 0.04-0.13 0.04-0.46v-28.92l-5.84 3.47l-9.08 14.88l0.16 2.61z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m568.25 320.02l-28.46-16.43c-0.88-0.51-1.59-1.86-1.59-3.03v-30.5c0-1.17 0.71-1.7 1.59-1.2l28.46 16.43c0.88 0.51 1.59 1.86 1.59 3.03v30.5c0 1.17-0.71 1.7-1.59 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m568.88 321.11c-0.35 0-0.73-0.1-1.08-0.31l-28.46-16.43c-1.16-0.67-2.04-2.31-2.04-3.81v-30.5c0-0.94 0.37-1.7 1-2.06c0.57-0.33 1.28-0.3 1.94 0.08l28.46 16.43c1.16 0.67 2.04 2.31 2.04 3.81v30.5c0 0.94-0.36 1.7-1 2.06c-0.26 0.15-0.55 0.23-0.86 0.23zm-0.18-1.87c0.1 0.06 0.16 0.07 0.18 0.07c-0.03-0.01 0.06-0.16 0.06-0.49v-30.5c0-0.91-0.6-1.94-1.13-2.25l-28.46-16.43c-0.1-0.06-0.16-0.07-0.18-0.07c0.03 0-0.06 0.16-0.06 0.49v30.5c0 0.91 0.6 1.94 1.13 2.25l28.46 16.43z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m544.49 272.4l-0.95-1.53l7.1-4.42l0.95 1.53l-7.1 4.42z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m570.84 314.77l-0.71-1.19l6.25-3.76l0.71 1.19l-6.25 3.76z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m368.2 139.37v18.08c0 0.24-0.1 0.49-0.31 0.74l-7.12 4.44c-0.13 0.08-0.31 0.04-0.39-0.09l-7.54-12.66c-0.02-0.04-0.06-0.08-0.1-0.1l-2.35-1.36c-0.52-0.3-0.94-1.1-0.94-1.8v-2.37c0-0.05-0.01-0.1-0.04-0.14l-6.85-11.5c-0.08-0.13-0.04-0.3 0.09-0.38l7.1-4.42c0.17-0.11 0.39-0.12 0.64 0.03l16.87 9.74c0.52 0.3 0.94 1.1 0.94 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m360.62 163.58c-0.09 0-0.18-0.01-0.27-0.03c-0.31-0.07-0.58-0.27-0.74-0.54l-7.45-12.52l-2.21-1.28c-0.79-0.46-1.39-1.56-1.39-2.58v-2.2l-6.76-11.35c-0.33-0.55-0.15-1.27 0.39-1.61l7.1-4.42c0.44-0.29 1.03-0.3 1.56 0.01l16.87 9.74c0.79 0.46 1.39 1.56 1.39 2.58v18.08c0 0.65-0.43 1.21-0.51 1.31l-0.22 0.2l-7.12 4.44c-0.19 0.12-0.41 0.18-0.63 0.18zm-16.97-30.9l6.54 10.98c0.11 0.18 0.17 0.39 0.17 0.6v2.37c0 0.43 0.29 0.9 0.49 1.02l2.35 1.36c0.18 0.1 0.32 0.25 0.43 0.42l7.21 12.11l6.42-4c0.02-0.04 0.04-0.08 0.05-0.11l0-18.05c0-0.43-0.29-0.9-0.49-1.02l-16.75-9.67l-6.41 3.99z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m360.87 144c0.02-0.03 0.04-0.05 0.07-0.07l7.02-4.38c0.13-0.08 0.29 0.01 0.29 0.16v17.73c0 0.24-0.1 0.49-0.31 0.74l-6.95 4.33c-0.23 0.14-0.52 0.07-0.66-0.16l-4.97-8.34c0.02-0.2 0.04-0.35 0.05-0.47l5.45-9.56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m360.74 163.5c-0.11 0-0.22-0.01-0.33-0.04c-0.36-0.09-0.67-0.31-0.86-0.63l-5.12-8.6l0.1-0.95l5.66-9.91l0.26-0.19l7.02-4.38c0.34-0.21 0.76-0.22 1.11-0.03c0.35 0.19 0.56 0.56 0.56 0.96v17.73c0 0.65-0.43 1.21-0.51 1.31l-0.22 0.2l-6.95 4.33c-0.22 0.14-0.47 0.21-0.73 0.21zm-4.45-9.67l4.59 7.71l6.42-4c0.02-0.04 0.04-0.08 0.05-0.11l0-16.43l-5.79 3.61l-5.26 9.22z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m359.9 162.75l-16.87-9.74c-0.52-0.3-0.94-1.1-0.94-1.8v-18.08c0-0.69 0.42-1.01 0.94-0.71l16.87 9.74c0.52 0.3 0.94 1.1 0.94 1.8v18.08c0 0.69-0.42 1.01-0.94 0.71z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m360.28 163.76c-0.27 0-0.56-0.08-0.83-0.23l-16.87-9.74c-0.79-0.46-1.39-1.56-1.39-2.58v-18.08c0-0.69 0.28-1.26 0.78-1.54c0.45-0.26 1.01-0.24 1.52 0.05l16.87 9.74c0.79 0.46 1.39 1.57 1.39 2.58v18.08c0 0.69-0.28 1.26-0.78 1.54c-0.21 0.12-0.45 0.18-0.69 0.18zm0.08-1.79l-0.45 0.78l0.46-0.77c0 0-0.01 0-0.01 0zm-17.35-28.52l-0.01 17.77c0 0.43 0.29 0.9 0.49 1.02l16.44 9.49l0.01-17.77c0-0.42-0.29-0.9-0.49-1.02l-16.44-9.49z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m347.7 135.29l-0.95-1.53l7.1-4.42l0.95 1.53l-7.1 4.42z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m361.82 157.57l-0.71-1.19l6.25-3.76l0.71 1.19l-6.25 3.76z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>",
    clipPath: "url(#cp3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m417.11 446.77l-0.52-0.9l61.88-35.67l0.52 0.9l-61.88 35.67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m419.94 448.27l-0.52-0.9l61.88-35.67l0.52 0.9l-61.88 35.67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m422.51 449.88l-0.52-0.9l61.88-35.67l0.52 0.9l-61.88 35.67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m425.39 451.36l-0.52-0.9l61.88-35.67l0.52 0.9l-61.88 35.67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m427.78 453.02l-0.52-0.9l61.88-35.67l0.52 0.9l-61.88 35.67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m430.61 454.53l-0.52-0.9l61.89-35.67l0.52 0.9l-61.88 35.67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m433.17 456.13l-0.52-0.9l61.88-35.67l0.52 0.9l-61.88 35.67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m436.06 457.61l-0.52-0.9l61.88-35.67l0.52 0.9l-61.88 35.67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m438.63 459.22l-0.52-0.9l61.88-35.67l0.52 0.9l-61.88 35.67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m441.51 460.72l-0.52-0.9l61.88-35.67l0.52 0.9l-61.88 35.67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m444.07 462.33l-0.52-0.9l61.88-35.67l0.52 0.9l-61.88 35.67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m446.96 463.81l-0.52-0.9l61.88-35.67l0.52 0.9l-61.88 35.67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m449.34 465.47l-0.52-0.9l61.88-35.67l0.52 0.9l-61.88 35.67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m452.17 466.98l-0.52-0.9l61.88-35.67l0.52 0.9l-61.88 35.67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m454.74 468.58l-0.52-0.9l61.88-35.67l0.52 0.9l-61.88 35.67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m457.62 470.06l-0.52-0.9l61.88-35.67l0.52 0.9l-61.89 35.67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m460.19 471.67l-0.52-0.9l61.88-35.67l0.52 0.9l-61.88 35.67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m406.11 440.65l-0.52-0.9l61.88-35.67l0.52 0.9l-61.88 35.67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m408.94 442.16l-0.52-0.9l61.88-35.67l0.52 0.9l-61.88 35.67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m411.51 443.77l-0.52-0.9l61.88-35.67l0.52 0.9l-61.88 35.67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m414.39 445.24l-0.52-0.9l61.88-35.67l0.52 0.9l-61.88 35.67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m416.96 446.85l-0.52-0.9l61.88-35.67l0.52 0.9l-61.88 35.67z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m454.81 294.04l7.78 30.16l-15.87 17.17c-2.39-14.36-4.16-23.73-5.31-28.11c-0.39-1.49-0.64-3.02-0.63-4.56c0.05-10.22 2.17-21.97 6.36-35.25l7.66 20.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m445.14 344.33l-0.3-1.81c-0.04-0.22-3.59-21.57-5.29-28.03c-0.45-1.71-0.67-3.28-0.66-4.8c0.07-15.29 6.34-35.32 6.41-35.52l0.79-2.5l8.57 23.06l7.93 30.72l-17.45 18.88zm1.11-67.04c-1.67 5.86-5.51 20.61-5.56 32.41c-0.01 1.36 0.19 2.77 0.6 4.33c1.44 5.49 4.12 21.03 5.02 26.38l14.29-15.46l-7.66-29.68l-6.69-17.98z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m475.01 437.68c4.77-1.04 8.47-1.24 11.11-0.6c1.7 0.41 2.7 1.23 3.3 2.03c0.73 0.99 0.43 2.4-0.56 3.12l-7.18 5.23c-0.68 0.5-1.46 0.83-2.29 0.98c-1.15 0.21-2.2 0.77-3.02 1.61l-1.51 1.56c-0.84 0.87-2.09 1.2-3.25 0.85l-3.77-1.12c-1.11-0.33-1.93-1.33-1.99-2.49c-0.16-3.18 0.34-6.06 1.52-8.62l7.64-2.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m472.54 453.51c-0.39 0-0.79-0.06-1.18-0.17l-3.77-1.12c-1.49-0.44-2.55-1.77-2.63-3.3c-0.25-4.94 1.52-8.88 1.6-9.05l0.16-0.35l8.01-2.69c0.4-0.09 7.5-1.62 11.61-0.62c1.66 0.4 2.94 1.2 3.81 2.36c0.48 0.64 0.67 1.44 0.55 2.25c-0.13 0.85-0.6 1.63-1.3 2.14l-7.18 5.23c-0.79 0.57-1.71 0.97-2.66 1.14c-0.97 0.18-1.85 0.65-2.53 1.35l-1.51 1.56c-0.79 0.82-1.87 1.26-2.97 1.26zm-4.49-12.54c-0.4 1.02-1.48 4.17-1.29 7.86c0.04 0.77 0.58 1.44 1.34 1.67l3.77 1.12c0.84 0.25 1.74 0.01 2.35-0.62l1.51-1.56c0.95-0.98 2.16-1.63 3.5-1.87c0.69-0.12 1.35-0.41 1.92-0.82l7.18-5.23c0.31-0.23 0.52-0.57 0.58-0.95c0.05-0.33-0.03-0.65-0.21-0.91c-0.61-0.82-1.55-1.39-2.79-1.69c-3.72-0.9-10.64 0.59-10.71 0.6l-7.15 2.41z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m452.05 426.27c1.54-0.06 3.13-0.01 4.75 0.16c2.44 0.25 5 0.83 5.49 2.18c0.66 1.8 0.31 3.32-1.04 4.57l-4.56 3.86c-1.74 1.47-3.21 3.38-4.43 5.15c-0.61 1-1.8 1.5-2.94 1.23l-4.49-1.02c-0.68-0.16-1.25-0.62-1.53-1.26c-0.49-1.1-0.63-2.36-0.27-3.51c0.5-1.61 1.33-5.04 2.49-10.3l6.52-1.06z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m449.93 444.39c-0.27 0-0.54-0.03-0.81-0.09l-4.49-1.03c-0.95-0.22-1.76-0.88-2.15-1.77c-0.6-1.36-0.71-2.83-0.31-4.14c0.73-2.35 2.45-10.15 2.47-10.23l0.13-0.6l7.12-1.16c0.21-0.01 2.52-0.1 4.99 0.15c3.66 0.37 5.7 1.28 6.25 2.77c1.18 3.23-1.18 5.45-1.28 5.54l-4.59 3.88c-1.82 1.54-3.31 3.58-4.26 4.97c-0.65 1.06-1.83 1.7-3.07 1.7zm-3.66-16.27c-0.42 1.9-1.74 7.72-2.38 9.78c-0.28 0.9-0.2 1.92 0.23 2.88c0.17 0.38 0.51 0.65 0.91 0.75l4.48 1.03c0.78 0.18 1.56-0.16 1.97-0.83c1.04-1.52 2.63-3.68 4.61-5.37l4.56-3.86c0.03-0.03 1.54-1.49 0.78-3.58c-0.2-0.56-1.56-1.27-4.74-1.6c-2.35-0.24-4.61-0.15-4.63-0.15l-5.81 0.95z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m487.71 355.2c-0.78 11.96-2.99 25.9-6.62 41.82c-0.28 5.61-1.05 10.73-2.31 15.36c-1.64 6-1.86 24.7-1.89 29.7c0 0.86-0.48 1.63-1.23 2.05c-3.54 1.98-6.74 0.74-8.29-0.15c-0.63-0.36-1.03-0.99-1.12-1.71c-0.59-4.78-2.95-24.54-2.3-31.36c0.74-7.79 3.05-13.68 2.28-19.84c-0.23-1.85-0.53-5.75-0.83-10.3c-0.09-1.4-0.12-2.84-0.79-4.05c-0.52 0.28-1.04 5.02-1.61 6.82c-0.63 1.99-0.98 4.05-1.05 6.14c-0.11 3.11-0.57 8.12-2.31 12.2c-2.32 5.44-5.99 28.85-6.46 32.39c-0.04 0.29-0.19 0.56-0.43 0.73c-3.61 2.64-7.27 0.88-8.59 0.06c-0.33-0.2-0.51-0.55-0.49-0.93c0.05-1.57 0.15-6.69-0.01-19.83c-0.21-16.63 3.58-21.47 4.42-29.04c0.56-5.05 0.07-17.07-1.47-36.07c14.51-5.86 22.29-5.24 23.33 1.84c5.84-4.5 14.36-9.97 17.84-6.82c1.27 1.15 0.18 7.65-0.04 11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m471.73 446.1c-2.05 0-3.75-0.73-4.81-1.33c-0.87-0.5-1.44-1.36-1.57-2.38c-0.7-5.69-2.95-24.76-2.31-31.56c0.29-3.01 0.8-5.7 1.29-8.29c0.78-4.12 1.46-7.68 1-11.36c-0.21-1.67-0.49-5.15-0.84-10.35c-0.21 1.13-0.42 2.25-0.65 2.97c-0.6 1.88-0.93 3.86-1.01 5.9c-0.12 3.44-0.63 8.41-2.38 12.52c-2.19 5.15-5.83 27.9-6.4 32.15c-0.07 0.54-0.36 1.03-0.79 1.34c-4.02 2.94-8.05 1.05-9.59 0.1c-0.6-0.37-0.94-1.02-0.92-1.73c0.05-1.59 0.15-6.69-0.02-19.79c-0.14-11.13 1.52-17.15 2.86-21.99c0.69-2.51 1.29-4.68 1.57-7.16c0.82-7.4-1.45-35.61-1.47-35.9l-0.05-0.66l0.61-0.25c0.6-0.24 14.9-5.93 21.41-2.2c1.36 0.78 2.3 1.9 2.8 3.34c8.89-6.65 14.91-8.65 17.9-5.94c1.22 1.11 0.99 4.29 0.5 9.02c-0.1 1-0.2 1.94-0.25 2.71c-1.13 17.31-6.28 40.38-6.62 41.89c-0.05 0.93-0.52 8.8-2.34 15.48c-1.59 5.83-1.82 24.03-1.86 29.47c-0.01 1.17-0.66 2.25-1.69 2.83c-1.54 0.87-3.03 1.18-4.37 1.18zm-6.78-70.6l0.43 0.77c0.71 1.28 0.8 2.68 0.88 4.04l0.02 0.39c0.34 5.17 0.62 8.61 0.83 10.25c0.49 3.95-0.24 7.82-1.02 11.91c-0.48 2.56-0.98 5.2-1.26 8.13c-0.64 6.78 1.8 27.15 2.3 31.17c0.06 0.45 0.3 0.82 0.68 1.04c1.42 0.81 4.27 1.91 7.4 0.15c0.47-0.26 0.77-0.75 0.77-1.27c0.04-5.49 0.27-23.89 1.92-29.93c1.85-6.77 2.28-15.09 2.28-15.17l0.02-0.16c0.05-0.24 5.44-24.02 6.6-41.68c0.05-0.79 0.15-1.75 0.26-2.78c0.23-2.21 0.7-6.81 0.07-7.5c-2.27-2.05-8.35 0.45-16.68 6.87l-1.22 0.94l-0.22-1.52c-0.23-1.58-0.97-2.71-2.26-3.45c-5.07-2.91-16.46 1.04-19.23 2.07c0.35 4.45 2.2 28.55 1.42 35.57c-0.29 2.63-0.94 4.97-1.62 7.44c-1.37 4.97-2.93 10.61-2.79 21.49c0.17 13.14 0.06 18.27 0.01 19.87c0 0.08 0.03 0.12 0.07 0.14c1.23 0.76 4.44 2.28 7.59-0.02c0.04-0.03 0.06-0.07 0.07-0.12c0.35-2.58 4.1-26.91 6.53-32.62c1.64-3.86 2.12-8.59 2.24-11.88c0.08-2.2 0.44-4.34 1.09-6.38c0.22-0.7 0.45-1.95 0.67-3.16c0.56-3.09 0.76-3.84 1.37-4.18l0.78-0.42z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m464.12 275.8c4.74-1.88 9.68-1.41 14.82 1.42c7.71 4.23 3.65 26.36 3.65 38.52c0 8.1 2.79 18.15 8.37 30.15c-1.42 3.36-4.02 6.08-7.3 7.67l-0.59 0.29c-2.71 1.31-5.67 1.99-8.68 1.99h0c-8.52 0-16.93-1.9-24.61-5.58l-6.63-3.34c-0.47-0.24-0.73-0.74-0.63-1.26c0.91-4.79 5.21-28.46 3.94-40.34c-1.42-13.26-2.53-27.78 0.79-33.62c2.21-3.89 5.08-4.75 8.62-2.56l8.26 6.67z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m474.38 356.72c-8.6 0-17.24-1.96-25-5.66l-6.64-3.35c-0.84-0.42-1.29-1.32-1.11-2.23c0.88-4.63 5.19-28.3 3.93-40.08c-1.52-14.23-2.47-28.22 0.9-34.16c1.15-2.02 2.65-3.28 4.46-3.74c2.82-0.72 5.32 0.79 5.42 0.86l0.09 0.07l7.88 6.35c1.82-0.58 8.19-2.14 15.08 1.64c6.34 3.48 5.42 17.12 4.6 29.15c-0.25 3.72-0.49 7.24-0.49 10.16c0 11.81 8.2 29.59 8.28 29.77l0.17 0.36l-0.16 0.37c-1.51 3.56-4.26 6.45-7.74 8.13l-0.6 0.29c-2.81 1.36-5.95 2.08-9.07 2.08zm-21.9-87.61c-0.37 0-0.75 0.04-1.14 0.14c-1.31 0.34-2.43 1.31-3.32 2.88c-3.13 5.51-2.1 19.82-0.68 33.08c1.29 12.02-3.06 35.93-3.95 40.6c-0.02 0.12 0.04 0.23 0.15 0.29l6.62 3.34c7.5 3.58 15.88 5.48 24.21 5.48c2.85 0 5.72-0.66 8.29-1.9l0.6-0.29c2.97-1.44 5.34-3.86 6.71-6.85c-1.23-2.71-8.28-18.77-8.28-30.15c0-2.98 0.24-6.53 0.49-10.28c0.74-10.92 1.66-24.52-3.67-27.45c-7.22-3.97-13.99-1.4-14.06-1.37l-0.49 0.19l-8.62-6.95c-0.24-0.13-1.43-0.76-2.87-0.76z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m461.58 260.45l1.3-8.09l7.52-7.84l9.64 0.65l1.14 4.57c0.65 7.19-0.27 12.47-2.78 15.85l-4.44 1.58c-0.08 0.03-0.14 0.11-0.14 0.2l-0.26 6.12c-8.46 2.48-13.3-1.04-14.91-2.57c-0.37-0.35-0.72-0.47-0.45-0.91c1.44-2.38 2.94-6.81 3.38-9.56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m467.92 275.25c-5.3 0-8.54-2.4-9.89-3.68c-0.06-0.06-0.12-0.11-0.18-0.15c-0.26-0.21-1.04-0.86-0.42-1.88c1.43-2.35 2.87-6.76 3.26-9.23l1.34-8.37l8-8.35l10.71 0.73l1.33 5.35c1 11-2.79 16.25-2.95 16.47l-0.16 0.22l-4.25 1.52l-0.27 6.3l-0.62 0.18c-2.19 0.64-4.15 0.9-5.89 0.9zm-8.77-5.09c0.04 0.03 0.08 0.07 0.11 0.1c1.53 1.45 5.84 4.52 13.42 2.53l0.24-5.46c0-0.43 0.29-0.85 0.73-1l4.16-1.48c0.64-1.04 3.28-5.92 2.47-14.95l-0.97-3.87l-8.57-0.58l-7.03 7.34l-1.25 7.82c-0.42 2.59-1.82 6.95-3.32 9.57z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m466.45 273.55c3.22 0.55 5.35 0.47 6.43-0.2c0.84-0.53 1.92-0.61 2.72-0.03c2.52 1.83 3.21 3.48 3.34 3.89c0.01 0.03-0.02 0.06-0.05 0.06l-1.79 0.14c-1.8 0.14-3.59 0.43-5.33 0.92c-11.21 3.14-20.03-5.12-17.54-7.91c0.56-0.63 1.18-0.66 1.69-0.91c1.29-0.64 2.84-0.21 3.82 0.84c0.84 0.91 2.83 2.53 6.71 3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m466.76 279.94c-6.33 0-11.32-3.2-13.09-6.03c-0.98-1.57-1.02-3.05-0.11-4.07c0.55-0.62 1.15-0.82 1.59-0.97c0.13-0.04 0.26-0.09 0.38-0.14c1.58-0.79 3.59-0.36 4.88 1.03l0 0c0.76 0.82 2.58 2.3 6.2 2.92c3.87 0.66 5.3 0.23 5.8-0.08c1.21-0.76 2.67-0.76 3.73 0.01c2.77 2.01 3.51 3.84 3.67 4.35l0.13 0.41l-0.49 0.76l-0.48 0.06l-1.78 0.14c-1.85 0.15-3.58 0.45-5.16 0.89c-1.82 0.51-3.59 0.73-5.26 0.73zm-9.53-9.82c-0.31 0-0.62 0.07-0.9 0.21c-0.19 0.09-0.39 0.17-0.59 0.24c-0.34 0.12-0.59 0.2-0.83 0.47c-0.48 0.54 0.05 1.52 0.29 1.92c2.02 3.24 8.82 6.62 16.34 4.52c1.68-0.47 3.53-0.79 5.5-0.95l0.52-0.04c-0.43-0.63-1.18-1.49-2.48-2.43c-0.46-0.33-1.13-0.31-1.71 0.06c-1.31 0.82-3.56 0.93-7.06 0.33c-4.14-0.71-6.3-2.48-7.22-3.47c-0.51-0.55-1.2-0.85-1.86-0.85z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m458.29 352.5c-4.73-6.54-3.17-19.3-3.11-19.84l1.79 0.23c-0.01 0.12-1.54 12.59 2.78 18.56l-1.46 1.06z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m509.18 277c-0.7 1.33-1.41 3.03-2.12 5.1l-6.95-2.09c-0.95-2.19-1.54-4.52-1.76-6.9l0.07-1.62c0.22-1.47 0.78-2.04 1.69-1.69c0.91 0.35 1.54 1.3 1.89 2.84l1.32 0.29l-0.76-0.16l-0.06-2.67c-0.01-0.58 0.03-1.16 0.15-1.73v0c0.22-1.15 0.7-2.24 1.39-3.19l0.63-0.87c1.53-0.88 2.04 0.32 3.24 2.54c1.37 2.53 2.32 8.16 1.27 10.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m507.62 283.21l-8.17-2.46l-0.17-0.38c-0.99-2.28-1.6-4.7-1.83-7.18l0.06-1.74c0.05-0.38 0.31-1.81 1.31-2.39c0.34-0.2 0.89-0.38 1.61-0.1c0.47 0.18 0.85 0.49 1.17 0.85c0.01-0.54 0.06-1.09 0.17-1.62c0.25-1.27 0.78-2.5 1.54-3.55l0.74-1.02l0.16-0.1c0.68-0.39 1.29-0.5 1.87-0.34c1.04 0.29 1.61 1.36 2.4 2.84l0.21 0.4c1.42 2.61 2.55 8.58 1.28 11.01c-1.01 1.91-2.06 4.94-2.07 4.97l-0.28 0.82zm-6.85-3.94l5.72 1.72c0.4-1.07 1.14-2.99 1.89-4.41c0.82-1.55 0.11-6.77-1.26-9.31l-0.22-0.4c-0.47-0.88-1-1.87-1.31-1.95c-0.04-0.01-0.15 0-0.32 0.08l-0.51 0.7c-0.61 0.84-1.03 1.82-1.23 2.84c-0.1 0.5-0.14 1.02-0.13 1.54l0.11 1.98l-0.06 0.28l0.01 0.42l-0.1 0l-0.23 1.06l-1.88-0.41l-0.13-0.56c-0.14-0.6-0.65-1.94-1.34-2.2c-0.19 0.04-0.41 0.52-0.48 0.98l-0.06 1.52c0.19 2.04 0.71 4.13 1.53 6.13z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m483.48 279.77c4.2 3.33 8.27 14.29 12.21 32.86c-0.03-7.04 0.39-12.48 1.26-16.31c1.33-5.82 2.35-10.95 2.74-14.15c0.08-0.66 0.75-1.08 1.38-0.87l4.55 1.52c1.05 0.35 1.73 1.38 1.64 2.48l-3.51 27.9c-0.11 1.37-0.42 2.72-0.92 4c-0.75 1.95-1.93 3.71-3.44 5.16l-0.8 0.76c-0.72 1.13-2.24 1.41-3.32 0.61c-2.61-1.94-4.98-4.21-6.91-6.84c-6.92-9.45-11.16-19.31-12.73-29.57c-1.26-5.51 1.54-12.55 7.84-7.55z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m496.66 325.08c-0.68 0-1.36-0.22-1.92-0.63c-2.83-2.11-5.22-4.47-7.09-7.03c-10.15-13.87-12.75-29.08-12.89-29.93c-0.77-3.43-0.14-7.98 2.58-9.69c1.3-0.82 3.52-1.26 6.71 1.27c4.53 3.59 8.73 17.9 10.93 26.59c0.17-3.19 0.49-6.85 1.1-9.54c1.43-6.24 2.37-11.1 2.72-14.06c0.07-0.58 0.39-1.1 0.89-1.42c0.5-0.32 1.11-0.39 1.67-0.2l4.55 1.52c1.45 0.48 2.38 1.89 2.25 3.41l-3.51 27.94c-0.11 1.42-0.44 2.85-0.97 4.21c-0.8 2.06-2.06 3.96-3.66 5.48l-0.72 0.69c-0.48 0.7-1.22 1.18-2.06 1.33c-0.19 0.04-0.39 0.05-0.58 0.05zm-17.1-46.11c-0.44 0-0.86 0.11-1.26 0.36c-1.72 1.08-2.51 4.58-1.78 7.8l0.01 0.06c0.02 0.15 2.44 15.34 12.57 29.17c1.77 2.41 4.03 4.65 6.72 6.65c0.32 0.23 0.7 0.33 1.09 0.25c0.39-0.07 0.72-0.29 0.93-0.63l0.14-0.17l0.8-0.76c1.41-1.34 2.52-3.02 3.22-4.83c0.47-1.2 0.75-2.46 0.86-3.74l3.51-27.94c0.05-0.66-0.37-1.3-1.03-1.52l-4.55-1.52l-0.2 0.12c-0.36 3.02-1.31 7.94-2.75 14.24c-1.28 5.58-1.24 16-1.24 16.11l0.04 8.8l-1.82-8.6c-0.06-0.28-5.91-27.59-11.89-32.34c-0.95-0.75-2.19-1.51-3.36-1.51z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m462.01 237.97c1.23-1.61 0.13-2.42-0.63-2.75c-0.19-0.08-0.19-0.36 0-0.43c6.77-2.65 15.21 0.29 18.6 6.01c3.16 5.32-1.46 10.03-2.36 10.87c-0.1 0.09-0.2 0.13-0.33 0.12c-0.69-0.04-3.74-0.2-6.03 2.63c-2.4 2.97-2 7.75-1.8 9.03c0.03 0.2-0.08 0.4-0.27 0.48c-1.52 0.61-7.97 2.64-12.74-4.61c-2.72-4.14-2.45-8.41-1.5-11.65c0.83-2.81 2.57-5.24 4.73-7.21c0.77-0.71 1.63-1.57 2.32-2.48z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m465.35 265.55c-2.86 0-6.6-1.1-9.65-5.73c-2.38-3.61-2.93-7.9-1.61-12.4c0.81-2.75 2.53-5.38 4.98-7.62h0c0.9-0.82 1.64-1.62 2.21-2.36c0.27-0.36 0.4-0.68 0.36-0.86c-0.04-0.17-0.29-0.37-0.63-0.52c-0.42-0.18-0.69-0.6-0.68-1.07c0.01-0.46 0.29-0.86 0.71-1.03c7.01-2.74 16.03 0.19 19.71 6.39c3.5 5.9-1.48 11.02-2.52 11.98c-0.28 0.26-0.62 0.38-0.99 0.36c-2.14-0.11-3.97 0.68-5.28 2.3c-2.4 2.97-1.64 8.11-1.61 8.33c0.09 0.62-0.25 1.22-0.83 1.45c-0.58 0.23-2.16 0.78-4.18 0.78zm-5.06-24.43c-2.21 2.01-3.76 4.37-4.47 6.8c-1.19 4.03-0.72 7.7 1.39 10.9c4.07 6.19 9.34 5.1 11.32 4.4c-0.17-1.44-0.5-6.23 2.04-9.37c1.62-2.01 3.93-3.06 6.58-2.97c1.09-1.06 4.73-5.12 2.06-9.62c-3.04-5.14-10.26-7.73-16.29-6.04c0.23 0.27 0.39 0.56 0.48 0.89c0.19 0.75-0.03 1.56-0.67 2.4c-0.63 0.83-1.45 1.71-2.43 2.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m470.69 241.72c-1.26-2.73-5.87-2.63-7.79-2.46l-0.16-1.79c2.86-0.25 7.9-0.13 9.58 3.5l-1.63 0.75z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m466.77 261.24c-5.24 0-6.05-4.44-6.06-4.49l1.77-0.31c0.07 0.38 0.84 3.69 5.81 2.86l0.3 1.78c-0.66 0.11-1.26 0.16-1.82 0.16z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m466.11 279.99c-5 0-7.62-1.87-9.79-3.42c-0.28-0.2-0.55-0.39-0.82-0.57l-0.26-0.19c-2-1.48-2.5-4.33-1.13-6.48l1.52 0.96c-0.86 1.36-0.56 3.15 0.68 4.07l0.21 0.15c0.28 0.19 0.56 0.39 0.85 0.6c2.39 1.71 5.09 3.64 11.17 2.94c6.86-0.79 9.1-1.69 9.12-1.7l0.7 1.66c-0.09 0.04-2.41 1.01-9.62 1.83c-0.95 0.11-1.82 0.16-2.63 0.16z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m482.11 308.48c-0.29-0.56-7.04-13.9-7.36-21.12c-0.1-2.27-0.03-4.12 0.22-5.5l1.77 0.32c-0.22 1.25-0.29 2.97-0.2 5.1c0.3 6.83 7.1 20.25 7.17 20.38l-1.6 0.82z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m494.75 310.66c-0.1-2.7-0.67-4.95-0.67-4.97l1.75-0.44c0.02 0.1 0.62 2.44 0.73 5.35l-1.8 0.07z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m464.4 379.14c-1.54-5.85-3.1-15.34-3.11-15.43l1.78-0.29c0.01 0.09 1.56 9.5 3.08 15.27l-1.74 0.46z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m457.59 329.13l-1.78-0.28c0.01-0.03 0.45-2.9 0-5.55l1.78-0.3c0.49 2.95 0.02 6 0 6.13z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m505.78 288.66l-6.08-1.76l0.5-1.73l6.08 1.76l-0.5 1.73z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m485.73 339.61c-2.33-3.67-2.88-7.18-2.9-7.33l1.78-0.27c0.01 0.03 0.53 3.3 2.64 6.63l-1.52 0.96z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m459.19 430.68c-0.94-2.18-4.92-1.76-4.97-1.76l-0.21-1.79c0.22-0.02 5.35-0.6 6.83 2.83l-1.65 0.71z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m485.54 441.55c-1.31-3.28-5.35-2.91-5.39-2.91l-0.18-1.79c1.87-0.19 5.79 0.41 7.24 4.03l-1.67 0.67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m482.65 370.26c-1.38 0-2.62-0.36-3.71-1.07c-3.95-2.6-4.23-8.95-4.24-9.22l1.8-0.07c0 0.06 0.27 5.71 3.44 7.79c1.52 1 3.54 1.03 6.02 0.07l0.65 1.68c-1.42 0.55-2.74 0.82-3.95 0.82z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m452.45 396.47c-4.91-1.38-6.19-5.81-6.24-5.99l1.73-0.49c0.04 0.15 1.08 3.64 5 4.75l-0.49 1.73z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m473.04 404.9c-7.76-0.69-7.95-6.19-7.95-6.25l1.8-0.04c0.01 0.16 0.22 3.96 6.31 4.5l-0.16 1.79z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m336.45 294.4c-0.03 0.65-0.35 1.29-1 1.66l-19.19 11.01c-1.61 0.93-3.6 0.93-5.21-0.01l-18.92-10.97c-0.6-0.35-0.91-0.93-0.97-1.53l0-0.03c-0.01-0.1-0.01-42.01-0.02-42.92c0-0.12 0.11-0.19 0.22-0.16l3.59 1c0.04 0.01 0.09 0.01 0.13-0.02l18.78-10.77c0.05-0.03 0.12-0.03 0.17 0l1.87 11.25c0.01 0.01 0.03 0.01 0.04 0.02l20.39-1.83c0.08 0.02 0.13 0.08 0.13 0.16c0 0.75-0.01 43.08-0.01 43.11l0 0.03z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m313.66 308.67c-1.06 0-2.12-0.28-3.07-0.82l-18.91-10.97c-0.8-0.47-1.32-1.27-1.42-2.22c-0.01-0.12-0.01-0.15-0.02-31.14c0-6.54 0-11.59 0-11.9c0-0.34 0.15-0.65 0.42-0.85c0.27-0.2 0.62-0.27 0.94-0.18l3.3 0.92l18.51-10.62c0.34-0.19 0.75-0.19 1.09 0.01l0.35 0.21l1.8 10.85l19.76-1.77l0.16 0.05c0.47 0.13 0.78 0.54 0.78 1.03l-0.02 43.25c-0.04 0.93-0.58 1.83-1.44 2.33l-19.19 11.01c-0.94 0.54-1.99 0.81-3.05 0.81zm-21.62-56.09c0 1.8 0 5.94 0 10.94c0 12.19 0.01 30.6 0.01 31c0.02 0.17 0.12 0.56 0.53 0.8l18.91 10.97c1.33 0.77 2.98 0.78 4.31 0.01l19.19-11.01c0.47-0.27 0.54-0.73 0.54-0.92h0l0.01-42.29l-19.7 1.77l-0.43-0.16l-0.35-0.21l-1.74-10.47l-18.13 10.4l-0.49-0.08l-2.67-0.74z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m336.46 251.27c0 0.75-0.01 43.08-0.01 43.11l0 0.03c-0.03 0.65-0.35 1.29-1 1.66l-19.19 11.01c-0.85 0.49-1.81 0.72-2.76 0.69l0.01-47.9l2.39-6.95c0.01 0.01 0.03 0.01 0.04 0.02l20.39-1.83c0.08 0.02 0.13 0.08 0.13 0.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m313.67 308.67c-0.06 0-0.12 0-0.19 0l-0.87-0.03l0.06-49.07l2.75-8.01l0.73 0.45l20.27-1.82l0.16 0.05c0.47 0.13 0.78 0.54 0.78 1.03l-0.02 43.25c-0.04 0.93-0.58 1.83-1.44 2.33l-19.19 11.01c-0.92 0.53-1.97 0.81-3.04 0.81zm0.75-48.65l-0.01 46.79c0.5-0.09 0.97-0.26 1.4-0.51l19.19-11.01c0.47-0.27 0.54-0.73 0.54-0.92l0.01-42.29l-19 1.7l-2.14 6.23z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m294.05 258.63l-0.01 38.48l-1.91-1.11c-0.6-0.35-0.91-0.93-0.97-1.53l0-0.03c-0.01-0.1-0.01-42.01-0.02-42.92c0-0.12 0.11-0.19 0.22-0.16l3.32 0.92c-0.23 0.65-0.44 1.23-0.63 1.74v4.61z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m294.94 298.67l-3.26-1.89c-0.8-0.47-1.32-1.28-1.42-2.21c-0.01-0.12-0.01-0.15-0.02-31.14c0-6.54 0-11.59 0-11.9c0-0.34 0.16-0.65 0.42-0.86c0.27-0.2 0.62-0.27 0.94-0.18l4.25 1.18l-0.33 0.91c-0.26 0.72-0.48 1.33-0.58 1.6l-0.01 44.49zm-2.9-46.19c0 1.8 0 5.94 0 10.94c0 12.19 0.01 30.6 0.01 31c0.02 0.17 0.12 0.56 0.53 0.8l0.55 0.32l0-41.69l0.06-0.15c0 0 0.12-0.32 0.3-0.82l-1.46-0.41z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m311.14 264.02l-19-11.02c-1.34-0.78-1.33-2.71 0-3.48l19.28-11.06c1.56-0.9 3.48-0.9 5.04 0.01l19 11.02c1.34 0.78 1.33 2.71 0 3.48l-19.28 11.06c-1.56 0.9-3.48 0.9-5.04-0.01z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m313.67 265.6c-1.03 0-2.06-0.27-2.98-0.8l-19-11.02c-0.91-0.53-1.45-1.47-1.45-2.52c0-1.05 0.55-1.99 1.46-2.52l19.28-11.06c1.83-1.06 4.11-1.05 5.94 0.01l19 11.02c0.91 0.53 1.45 1.47 1.45 2.52c0 1.05-0.55 1.99-1.46 2.52l-19.28 11.06c-0.91 0.53-1.94 0.79-2.96 0.79zm0.27-26.92c-0.71 0-1.43 0.18-2.06 0.55l-19.28 11.06c-0.5 0.29-0.55 0.77-0.55 0.96c0 0.19 0.05 0.67 0.55 0.96l19 11.02c1.28 0.74 2.86 0.74 4.14 0.01l19.28-11.06c0.5-0.29 0.55-0.77 0.55-0.96c0-0.19-0.05-0.67-0.55-0.96l-19-11.02c-0.64-0.37-1.36-0.56-2.07-0.56z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m337.16 272.36h-1.39v-11.2h1.39v11.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m295.6 286.43l-10.68-6.04c-0.44-0.25-0.79-0.93-0.79-1.52v-20.36c0-0.58 0.36-0.85 0.79-0.6l10.68 6.04c0.44 0.25 0.79 0.93 0.79 1.52v20.36c0 0.58-0.36 0.85-0.79 0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m295.92 287.43c-0.25 0-0.51-0.07-0.76-0.21l-10.68-6.04c-0.73-0.42-1.25-1.39-1.25-2.3v-20.36c0-0.64 0.27-1.16 0.73-1.42c0.43-0.25 0.95-0.23 1.42 0.04l10.67 6.04c0.73 0.42 1.25 1.39 1.25 2.3v20.36c0 0.64-0.27 1.16-0.73 1.42c-0.2 0.12-0.42 0.17-0.65 0.17zm0.13-1.78l-0.44 0.78l0.45-0.78c0 0-0.01 0-0.01 0zm-11.01-26.63l0 19.86c0 0.31 0.23 0.67 0.34 0.74l10.12 5.72l0-19.86c0-0.31-0.23-0.67-0.34-0.74l-10.12-5.72z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m292.05 268.33c0 0.69-0.48 0.97-1.08 0.63c-0.6-0.35-1.08-1.18-1.08-1.88c0-0.69 0.48-0.97 1.08-0.63c0.6 0.35 1.08 1.18 1.08 1.88z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m304.48 235.86l12.25 7.22l-12.3 6.94l-12.37-7.12l12.42-7.04z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m304.42 251.06l-14.18-8.17l14.25-8.07l14.04 8.28l-14.11 7.96zm-10.55-8.15l10.56 6.08l10.5-5.92l-10.46-6.16l-10.6 6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m304.88 245.92l9.91 5.84l-5.86 3.39l-10.01-5.76l5.96-3.47z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m308.93 256.19l-11.8-6.8l7.76-4.52l11.69 6.89l-7.64 4.43zm-8.21-6.81l8.21 4.73l4.08-2.36l-8.13-4.79l-4.16 2.42z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "illustration"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>",
    clipPath: "url(#cp4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m796.67 481.75l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m800.36 483.72l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m803.71 485.81l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m807.47 487.74l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m810.57 489.9l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m814.26 491.87l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m817.61 493.96l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m821.37 495.89l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m824.72 497.98l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m828.47 499.94l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m831.81 502.04l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m835.57 503.97l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m838.68 506.13l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m842.37 508.09l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m845.71 510.19l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m849.47 512.11l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m852.82 514.21l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m782.33 473.78l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m786.02 475.74l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m789.37 477.84l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m793.13 479.77l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m796.48 481.86l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m825.91 461.83l-10.52-6.15c-0.5-0.29-0.73-0.68-0.71-1.09v0c0-0.02 0-0.05 0-0.07l0.09-9.79c0-0.23 0.19-0.42 0.42-0.42l16.05-0.13c0.07 0 0.15-0.02 0.21-0.06l15.69-8.87c1.22-0.71 3.07-0.79 4.13-0.19l-5.34-2.93c0.07 0.04 0.14 0.06 0.22 0.06l15.98-0.13c0.24 0 0.43 0.19 0.43 0.43l-0.07 9.84c-0.03 0.45-0.37 0.91-1 1.28l-31.47 18.05c-1.22 0.71-3.07 0.79-4.13 0.19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m827.7 463.33c-0.86 0-1.68-0.18-2.33-0.56l-0.01 0l-10.52-6.15c-0.84-0.48-1.3-1.24-1.25-2.09l0.09-9.81c0.01-0.82 0.69-1.5 1.51-1.5l15.88-0.13l15.54-8.78c0.17-0.1 0.35-0.19 0.53-0.27l-1.71-0.94c-0.01-0.01-0.03-0.01-0.04-0.02l1.07-1.9c-0.1-0.05-0.2-0.08-0.31-0.08l15.97-0.13c0.01 0 0.01 0 0.02 0c0.4 0 0.78 0.16 1.06 0.44c0.29 0.29 0.45 0.68 0.45 1.09l-0.07 9.84c-0.07 0.91-0.61 1.67-1.54 2.21l-31.48 18.06c-0.84 0.49-1.88 0.74-2.88 0.74zm-1.25-2.45c0.65 0.37 2.09 0.37 3.04-0.18l31.48-18.06c0.34-0.2 0.44-0.37 0.45-0.42l0.06-9.08l-11.25 0.09l1.5 0.82c0.03 0.02 0.06 0.03 0.09 0.05l-1.07 1.9l-0.06-0.03c-0.67-0.35-2.07-0.34-3 0.2l-15.7 8.87c-0.22 0.13-0.49 0.2-0.75 0.2l-15.39 0.13l-0.08 9.14c0 0.09 0.04 0.15 0.16 0.21l10.52 6.15z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m848 432.05c0.02-0.01 4.7-0.01 14.02 0c0.31 0 0.56 0.25 0.56 0.56l-0.07 9.71c-0.03 0.45-0.37 0.91-1 1.28l-31.28 17.94c-0.09 0.05-0.19-0.01-0.19-0.11l0.09-10.16c0-0.01 0.01-0.01 0.01-0.02c-0.82-2.15 5.13-8.54 17.85-19.19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m830.23 462.79l-0.67-0.32c-0.38-0.22-0.61-0.63-0.6-1.07l0.09-10.11c-0.48-3.76 11.13-14.11 18.25-20.07l0.16-0.14l0.2-0.06c0.2-0.06 0.2-0.06 14.35-0.05c0 0 0 0 0.01 0c0.44 0 0.85 0.17 1.16 0.49c0.31 0.32 0.48 0.73 0.48 1.18l-0.07 9.7c-0.07 0.91-0.61 1.67-1.54 2.21l-31.83 18.26zm0.99-11.27l-0.07 8.24l29.82-17.11c0.34-0.2 0.44-0.37 0.45-0.42l0.06-9.09c-3.67 0-11.31 0-13.09 0c-8.45 7.1-17.36 15.83-17.22 17.77l0.15 0.4l-0.11 0.21z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m861.61 433.2l-31.47 18.05c-1.22 0.71-3.07 0.79-4.13 0.19l-10.52-6.15c-1.06-0.61-0.93-1.68 0.29-2.39l31.47-18.05c1.22-0.71 3.07-0.79 4.13-0.19l10.52 6.15c1.06 0.61 0.93 1.68-0.29 2.39z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m827.79 452.93c-0.86 0-1.68-0.18-2.33-0.55l-10.53-6.15c-0.79-0.45-1.26-1.17-1.26-1.97c0-0.89 0.56-1.73 1.55-2.3l31.48-18.06c1.56-0.91 3.81-0.99 5.22-0.19l10.52 6.15c0.8 0.46 1.26 1.18 1.26 1.97c0 0.89-0.56 1.73-1.55 2.3l-31.48 18.06c-0.84 0.49-1.88 0.74-2.88 0.74zm-11.93-8.69c0.02 0 0.07 0.04 0.16 0.1l10.53 6.15c0.64 0.37 2.08 0.37 3.04-0.19l31.48-18.06c0.3-0.18 0.42-0.34 0.45-0.4c-0.02 0.01-0.07-0.04-0.16-0.09l-0.01 0l-10.52-6.15c-0.64-0.37-2.08-0.37-3.03 0.19l-31.48 18.06c-0.3 0.17-0.42 0.34-0.45 0.4c0 0 0 0 0 0z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m822.36 459.08l-2.18-0.07l0.3-10.11l2.18 0.07l-0.3 10.11z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m854.37 447.57l-1.68-0.03l0.13-8.82l1.68 0.03l-0.13 8.82z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m622.26 396.11l-0.63-1.09l334.11-191.58l0.63 1.09l-334.11 191.58z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m625.95 398.08l-0.63-1.09l334.11-191.58l0.63 1.09l-334.11 191.58z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m629.3 400.18l-0.63-1.09l334.11-191.58l0.63 1.09l-334.11 191.58z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m633.06 402.1l-0.63-1.09l334.11-191.58l0.63 1.09l-334.11 191.58z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m636.16 404.26l-0.63-1.09l334.11-191.58l0.63 1.09l-334.11 191.58z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m639.85 406.23l-0.63-1.09l334.11-191.58l0.63 1.09l-334.11 191.58z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m643.2 408.33l-0.63-1.09l334.11-191.58l0.63 1.09l-334.11 191.58z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m646.96 410.25l-0.63-1.09l334.11-191.58l0.63 1.09l-334.11 191.58z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m650.31 412.35l-0.63-1.09l334.11-191.58l0.63 1.09l-334.11 191.58z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m654.06 414.31l-0.63-1.09l334.11-191.58l0.63 1.09l-334.11 191.58z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m657.4 416.4l-0.63-1.09l334.11-191.58l0.63 1.09l-334.11 191.58z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m661.17 418.33l-0.63-1.09l334.11-191.58l0.63 1.09l-334.11 191.58z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m664.27 420.49l-0.63-1.09l334.11-191.58l0.63 1.09l-334.11 191.58z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m667.96 422.46l-0.63-1.09l334.11-191.58l0.63 1.09l-334.11 191.58z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m671.3 424.55l-0.63-1.09l334.11-191.58l0.63 1.09l-334.11 191.58z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m675.07 426.48l-0.63-1.09l334.11-191.58l0.63 1.09l-334.11 191.58z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m607.92 388.14l-0.63-1.09l334.11-191.58l0.63 1.09l-334.11 191.58z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m611.61 390.11l-0.63-1.09l334.11-191.58l0.63 1.09l-334.11 191.58z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m614.96 392.2l-0.63-1.09l334.11-191.58l0.63 1.09l-334.11 191.58z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m618.72 394.13l-0.63-1.09l334.11-191.58l0.63 1.09l-334.11 191.58z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m622.07 396.23l-0.63-1.09l334.11-191.58l0.63 1.09l-334.11 191.58z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m590.96 377.9l-0.63-1.09l334.11-191.58l0.63 1.09l-334.11 191.58z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m594.3 379.99l-0.63-1.09l334.11-191.58l0.63 1.09l-334.11 191.58z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m598.06 381.92l-0.63-1.09l334.11-191.58l0.63 1.09l-334.11 191.58z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m601.17 384.08l-0.63-1.09l334.11-191.58l0.63 1.09l-334.11 191.58z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m604.86 386.05l-0.63-1.09l334.11-191.58l0.63 1.09l-334.11 191.58z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m589.34 358.55l-0.63-1.09l317.7-182.17l0.63 1.09l-317.7 182.17z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m587.95 363.42l-0.63-1.09l322.78-185.08l0.63 1.09l-322.78 185.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m587.51 367.69l-0.63-1.09l326.56-187.25l0.63 1.09l-326.56 187.25z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m587.56 371.75l-0.63-1.09l330.28-189.38l0.63 1.09l-330.28 189.38z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m588.87 375.02l-0.63-1.09l332.32-190.55l0.63 1.09l-332.32 190.55z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m689.41 434.62l-0.63-1.09l334.11-191.58l0.63 1.09l-334.11 191.58z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m693.1 436.59l-0.63-1.09l334.11-191.58l0.63 1.09l-334.11 191.58z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m696.44 438.68l-0.63-1.09l334.11-191.58l0.63 1.09l-334.11 191.58z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m700.2 440.61l-0.63-1.09l334.11-191.58l0.63 1.09l-334.11 191.58z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m703.31 442.77l-0.63-1.09l334.11-191.58l0.63 1.09l-334.11 191.58z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m707 444.73l-0.63-1.09l334.11-191.58l0.63 1.09l-334.11 191.58z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m710.34 446.83l-0.63-1.09l334.11-191.58l0.63 1.09l-334.11 191.58z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m714.11 448.76l-0.63-1.09l334.11-191.58l0.63 1.09l-334.11 191.58z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m717.45 450.85l-0.63-1.09l334.11-191.58l0.63 1.09l-334.11 191.58z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m722.3 452.18l-0.63-1.09l327.26-187.65l0.63 1.09l-327.26 187.65z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m727.14 453.42l-0.63-1.09l326.11-186.99l0.63 1.09l-326.11 186.99z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m731.67 454.91l-0.63-1.09l322.11-184.7l0.63 1.09l-322.11 184.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m736.55 456.05l-0.63-1.09l317.59-182.11l0.63 1.09l-317.59 182.11z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m743.67 456.05l-0.63-1.09l309.13-177.26l0.63 1.09l-309.13 177.26z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m752.66 454.91l-0.63-1.09l298.91-171.39l0.63 1.09l-298.91 171.39z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m764.54 452.18l-0.63-1.09l284.56-163.17l0.63 1.09l-284.56 163.17z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m678.76 428.61l-0.63-1.09l334.11-191.58l0.63 1.09l-334.11 191.58z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m682.1 430.71l-0.63-1.09l334.11-191.58l0.63 1.09l-334.11 191.58z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m685.86 432.64l-0.63-1.09l334.11-191.58l0.63 1.09l-334.11 191.58z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m689.21 434.73l-0.63-1.09l334.11-191.58l0.63 1.09l-334.11 191.58z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m1051.8 261.92c-2.03 3.04-5.23 5.96-9.61 8.49l-273.14 157.64c-14.78 8.53-37.13 9.45-49.92 2.06l-119.6-69.07c-5.41-3.12-8.21-7.23-8.57-11.58l-0.02-0.01c-0.89-4.78-0.66-9.91 0.72-15.4l7.96 0.45l0.01 0.03c1.08-0.79 2.22-1.57 3.49-2.31l273.14-157.64c14.78-8.53 37.13-9.45 49.92-2.06l119.6 69.08l9.09-0.48c2.32 6.56 1.48 13.21-2.51 19.96c-0.03 0.06-0.07 0.1-0.1 0.15c-0.13 0.21-0.28 0.42-0.42 0.64c-0.02 0.02-0.03 0.04-0.05 0.06z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m718.43 431.31l-119.6-69.08c-5.55-3.2-8.74-7.49-9.23-12.41l-0.02-0.12c-1.38-7.38 0.65-15.64 0.74-15.99l0.28-1.11l8.65 0.49c1.12-0.81 2.14-1.47 3.18-2.07l273.14-157.64c15.14-8.73 38.15-9.66 51.31-2.06l119.24 68.87l6.72-1.71l3.04 0.35c2.61 8.27 1.8 15.98-2.43 23.12c-0.11 0.17-0.22 0.35-0.34 0.52l-0.16 0.24c-2.25 3.35-5.63 6.35-10.06 8.91l-273.14 157.65c-8.26 4.77-18.86 7.21-28.93 7.21c-8.38 0-16.4-1.69-22.38-5.15zm333.38-169.41l-1-0.99c0.09-0.14 0.19-0.28 0.36-0.56c4.51-7.62 3.3-15.17 2.67-17.81l-8.39 0.44l-119.96-69.28c-12.39-7.16-34.17-6.23-48.54 2.06l-273.14 157.64c-1.08 0.62-2.15 1.33-3.37 2.22l-1.58 1.13l-0.29-0.94l-5.81-0.33c-0.46 2.33-1.37 7.94-0.57 13.06l0.15 0.79c0.34 4.08 3.06 7.71 7.88 10.49l119.6 69.08c12.39 7.16 34.17 6.23 48.54-2.06l273.14-157.65c4.06-2.34 7.14-5.05 9.15-8.06l0.02-0.04l1.14 0.79z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1042.69 258.41l-273.14 157.64c-14.78 8.53-37.13 9.45-49.92 2.06l-119.6-69.07c-12.79-7.39-11.19-20.29 3.59-28.82l273.14-157.64c14.78-8.53 37.13-9.45 49.92-2.06l119.6 69.08c12.8 7.39 11.19 20.29-3.59 28.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m718.93 419.32l-119.6-69.08c-6.02-3.47-9.33-8.35-9.33-13.72c0-6.39 4.71-12.76 12.92-17.5l273.14-157.64c15.14-8.73 38.16-9.66 51.31-2.06l119.6 69.08c6.02 3.47 9.33 8.35 9.33 13.72c0 6.39-4.71 12.77-12.92 17.5l-273.14 157.64c-8.26 4.76-18.86 7.21-28.93 7.21c-8.38 0-16.4-1.69-22.38-5.15zm158.51-255.54l-273.14 157.64c-7.33 4.23-11.53 9.74-11.53 15.1c0 4.34 2.82 8.36 7.95 11.32l119.6 69.08c12.39 7.15 34.17 6.23 48.54-2.06l273.14-157.64c7.33-4.23 11.53-9.74 11.53-15.11c0-4.34-2.82-8.36-7.94-11.32l-119.6-69.07c-5.6-3.23-13.11-4.82-20.99-4.82c-9.56 0-19.67 2.33-27.55 6.88z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m744.47 424.02l1.6-0.02l0.11 10.37l-1.6 0.02l-0.11-10.37z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m597.86 348.27l1.52 0.48c-0.02 0.05-1.6 5.2 0.05 10.59l-1.53 0.47c-1.79-5.85-0.12-11.3-0.05-11.53z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m602.64 351.05l1.52 0.48c-0.02 0.05-1.6 5.2 0.05 10.59l-1.53 0.47c-1.79-5.85-0.12-11.3-0.05-11.53z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m1040.7 270.64c0.99-4.3 0.72-10.91 0.72-10.98l1.6-0.07c0.01 0.28 0.28 6.9-0.76 11.4l-1.56-0.36z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m1045.95 267.6c0.99-4.3 0.72-10.91 0.72-10.98l1.6-0.07c0.01 0.28 0.28 6.9-0.76 11.4l-1.56-0.36z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m962.22 313.28c-0.68-0.39-1.06-1.13-1.06-2.08v-0.4c0-1.77 1.36-3.94 3.09-4.94l16.76-9.67c1.04-0.6 2.07-0.68 2.84-0.24c0.68 0.39 1.06 1.13 1.06 2.08v0.4c0 1.77-1.36 3.94-3.09 4.94l-16.76 9.67c-0.6 0.35-1.2 0.52-1.75 0.52c-0.4 0-0.77-0.09-1.09-0.28zm19.6-15.71l-16.76 9.67c-1.24 0.72-2.29 2.35-2.29 3.56v0.4c0 0.2 0.03 0.56 0.26 0.69c0.19 0.1 0.63 0.11 1.24-0.25l16.76-9.67c1.24-0.72 2.29-2.34 2.29-3.55v-0.4c0-0.2-0.03-0.56-0.26-0.69c-0.07-0.04-0.17-0.06-0.29-0.06c-0.23 0-0.55 0.08-0.95 0.31z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m935.33 328.8c-0.68-0.39-1.06-1.13-1.06-2.08v-0.4c0-1.77 1.36-3.94 3.09-4.94l16.76-9.67c1.04-0.6 2.07-0.68 2.84-0.24c0.68 0.39 1.06 1.13 1.06 2.08v0.4c0 1.77-1.36 3.94-3.09 4.94l-16.76 9.67c-0.6 0.35-1.2 0.52-1.75 0.52c-0.4 0-0.76-0.09-1.09-0.28zm19.59-15.71l-16.76 9.67c-1.24 0.72-2.29 2.35-2.29 3.56v0.4c0 0.2 0.03 0.56 0.26 0.69c0.19 0.1 0.62 0.11 1.24-0.25l16.76-9.67c1.24-0.72 2.3-2.35 2.3-3.56v-0.4c0-0.2-0.03-0.56-0.26-0.69c-0.07-0.04-0.17-0.06-0.29-0.06c-0.23 0-0.55 0.08-0.95 0.31z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m993.93 294.98c-0.68-0.39-1.06-1.13-1.06-2.08v-0.4c0-1.77 1.36-3.94 3.09-4.94l9.42-5.44c1.04-0.6 2.07-0.69 2.84-0.24c0.68 0.39 1.06 1.13 1.06 2.08l0 0.4c0 1.77-1.36 3.94-3.09 4.94l-9.43 5.44c-0.6 0.35-1.2 0.52-1.75 0.52c-0.4 0-0.77-0.09-1.09-0.28zm12.26-11.47l-9.43 5.44c-1.24 0.72-2.3 2.35-2.3 3.56v0.4c0 0.2 0.03 0.56 0.26 0.69c0.19 0.1 0.62 0.11 1.24-0.25l9.43-5.44c1.24-0.72 2.29-2.35 2.29-3.55l0-0.4c0-0.2-0.03-0.56-0.26-0.69c-0.07-0.04-0.17-0.06-0.29-0.06c-0.23 0-0.55 0.08-0.94 0.31z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m998.46 292.83l-2.09 1.21c-1.49 0.86-2.69 0.35-2.69-1.14l0-0.4c0-1.49 1.21-3.39 2.69-4.25l2.09-1.21c1.49-0.86 2.69-0.35 2.69 1.14v0.4c0 1.49-1.21 3.39-2.69 4.25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m993.93 294.98c-0.68-0.39-1.06-1.13-1.06-2.08v-0.4c0-1.77 1.36-3.94 3.09-4.94l2.09-1.21c1.04-0.6 2.07-0.68 2.84-0.24c0.68 0.39 1.06 1.13 1.06 2.08v0.4c0 1.77-1.36 3.94-3.1 4.94l-2.09 1.21c-0.6 0.35-1.2 0.52-1.75 0.52c-0.4 0-0.77-0.09-1.09-0.28zm6.42-6.8c0-0.2-0.03-0.56-0.26-0.69c-0.19-0.1-0.62-0.11-1.24 0.25l-2.09 1.21c-1.24 0.72-2.3 2.35-2.3 3.56v0.4c0 0.2 0.03 0.56 0.26 0.69c0.19 0.1 0.62 0.11 1.24-0.25l2.09-1.21c1.24-0.72 2.3-2.35 2.3-3.56v-0.4z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m738.72 434.72l0.14-10.71l1.6 0.02l-0.14 10.71l-1.6-0.02z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m719.13 429.81l0.14-10.71l1.6 0.02l-0.14 10.71l-1.6-0.02z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m759.48 421.18l1.6-0.02l0.11 10.37l-1.6 0.02l-0.11-10.37z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m783.83 408.02l1.6-0.02l0.11 10.37l-1.6 0.02l-0.11-10.37z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m606.05 328.71l276.4-158.94c11.84-6.81 31.2-6.78 43.02 0.08l24.61 14.27c5.68 3.29 8.81 9.96 7.09 16.3c-0.11 0.4-0.24 0.81-0.38 1.22c-0.03 0.08-0.08 0.26-0.15 0.54c-0.29 1.41 0.47 2.88 2.35 3.96c1.88 1.08 4.42 1.52 6.87 1.36c0.49-0.04 0.8-0.07 0.93-0.09c0.11-0.01 0.22-0.03 0.33-0.04c12.71-1.47 25.54 1.43 36.61 7.85l36.56 21.19c6.43 3.73 6.42 9.81-0.02 13.52l-276.4 158.93c-11.84 6.81-31.2 6.78-43.02-0.08l-114.81-66.55c-6.43-3.73-6.42-9.81 0.02-13.52z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s4",
    d: "m720.24 409.81l-114.81-66.56c-3.49-2.03-5.41-4.8-5.41-7.8c0.01-3 1.94-5.77 5.44-7.78l276.4-158.93c12.2-7.02 32.04-6.98 44.21 0.08l24.61 14.27c6.32 3.67 9.47 10.92 7.64 17.64c-0.12 0.43-0.25 0.87-0.42 1.33c-0.04 0.11-0.1 0.36-0.1 0.36c-0.19 0.95 0.46 1.93 1.78 2.69c1.6 0.92 3.85 1.35 6.17 1.2c0.45-0.04 0.74-0.07 0.87-0.08l0.35-0.04c12.65-1.46 25.91 1.38 37.34 8l36.56 21.19c3.49 2.02 5.41 4.79 5.41 7.8c-0.01 3-1.94 5.77-5.44 7.78l-276.4 158.94c-6.08 3.49-14.04 5.24-22.02 5.24c-8.04 0-16.08-1.77-22.19-5.32zm247.01-201.27l-0.31 0.04c-0.22 0.03-1 0.1-1.01 0.1c-2.81 0.19-5.55-0.36-7.54-1.51c-2.23-1.29-3.32-3.24-2.91-5.28c0.09-0.36 0.16-0.58 0.19-0.66c0.14-0.38 0.25-0.75 0.35-1.12c1.54-5.68-1.15-11.84-6.54-14.96l-24.61-14.27c-11.52-6.68-30.29-6.71-41.84-0.07l-276.4 158.94c-2.74 1.57-4.24 3.6-4.25 5.72c0 2.12 1.5 4.16 4.23 5.74l114.81 66.56c11.52 6.68 30.29 6.72 41.84 0.07l276.4-158.94c2.74-1.57 4.24-3.61 4.25-5.72c0-2.12-1.5-4.16-4.23-5.74l-36.56-21.19c-9.11-5.28-19.41-8.06-29.58-8.06c-2.11 0-4.21 0.12-6.29 0.36z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m972.27 197.77c2.46 1.42 2.46 3.73 0 5.15c-2.46 1.42-6.46 1.42-8.92 0c-2.46-1.42-2.46-3.73 0-5.15c2.46-1.42 6.46-1.42 8.92 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m969.09 199.61c0.71 0.41 0.71 1.07 0 1.48c-0.71 0.41-1.85 0.41-2.56 0c-0.71-0.41-0.71-1.07 0-1.48c0.71-0.41 1.85-0.41 2.56 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m899.67 176.76c-1.87 1.52-0.3 3.68 0 4.05c0.02 0.02-0.02 0.04-0.05 0.03c-0.65-0.17-4.38-1.09-7.01-0.01c-0.04 0.02-0.08-0.01-0.05-0.03c1.87-1.52 0.32-3.66 0.02-4.03c-0.01-0.02 0.02-0.04 0.05-0.03c0.64 0.17 4.36 1.07 6.99-0.01c0.04-0.02 0.08 0.01 0.05 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m909.78 182.61c-1.87 1.52-0.3 3.68 0 4.05c0.02 0.02-0.02 0.04-0.05 0.03c-0.65-0.17-4.38-1.09-7.01-0.01c-0.04 0.02-0.08-0.01-0.05-0.03c1.87-1.52 0.32-3.66 0.02-4.03c-0.01-0.02 0.02-0.04 0.05-0.03c0.64 0.17 4.36 1.07 6.99-0.01c0.04-0.02 0.08 0.01 0.05 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m919.89 188.46c-1.87 1.52-0.3 3.68 0 4.05c0.01 0.02-0.02 0.04-0.05 0.03c-0.65-0.17-4.38-1.08-7.01-0.01c-0.04 0.01-0.08-0.01-0.05-0.03c1.87-1.52 0.32-3.66 0.02-4.03c-0.01-0.02 0.02-0.04 0.05-0.03c0.64 0.17 4.36 1.07 6.99-0.01c0.04-0.02 0.08 0.01 0.05 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m930 194.3c-1.87 1.52-0.3 3.68 0 4.05c0.02 0.02-0.02 0.04-0.05 0.03c-0.65-0.17-4.38-1.08-7.01-0.01c-0.04 0.02-0.08-0.01-0.05-0.03c1.87-1.52 0.32-3.66 0.02-4.03c-0.02-0.02 0.02-0.04 0.05-0.03c0.64 0.17 4.36 1.07 6.99-0.01c0.04-0.02 0.08 0.01 0.05 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m940.11 200.15c-1.87 1.52-0.3 3.68 0 4.05c0.02 0.02-0.02 0.04-0.05 0.03c-0.65-0.17-4.38-1.09-7.01-0.01c-0.04 0.01-0.08-0.01-0.05-0.03c1.87-1.52 0.32-3.66 0.02-4.03c-0.02-0.02 0.02-0.04 0.05-0.03c0.64 0.17 4.36 1.07 6.99-0.01c0.04-0.01 0.08 0.01 0.05 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m970.44 217.7c-1.87 1.52-0.3 3.68 0 4.05c0.02 0.02-0.02 0.04-0.05 0.03c-0.65-0.17-4.38-1.08-7.01-0.01c-0.04 0.02-0.08-0.01-0.05-0.03c1.87-1.52 0.32-3.66 0.02-4.03c-0.02-0.02 0.02-0.04 0.05-0.03c0.64 0.17 4.36 1.07 6.99-0.01c0.04-0.02 0.08 0.01 0.05 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m980.55 223.55c-1.87 1.52-0.3 3.68 0 4.05c0.02 0.02-0.02 0.04-0.05 0.03c-0.65-0.17-4.38-1.08-7.01-0.01c-0.04 0.02-0.08-0.01-0.05-0.03c1.87-1.52 0.32-3.66 0.02-4.03c-0.02-0.02 0.02-0.04 0.05-0.03c0.64 0.17 4.36 1.07 6.99-0.01c0.04-0.01 0.08 0.01 0.05 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m919.94 176.75c-1.87 1.52-0.3 3.68 0 4.05c0.01 0.02-0.02 0.04-0.05 0.03c-0.65-0.17-4.38-1.08-7.01-0.01c-0.04 0.02-0.08-0.01-0.05-0.03c1.87-1.52 0.32-3.66 0.02-4.03c-0.01-0.02 0.02-0.04 0.05-0.03c0.64 0.17 4.36 1.07 6.99-0.01c0.04-0.02 0.08 0.01 0.05 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m930.05 182.6c-1.87 1.52-0.3 3.68 0 4.05c0.02 0.02-0.02 0.04-0.05 0.03c-0.65-0.17-4.38-1.09-7.01-0.01c-0.04 0.01-0.08-0.01-0.05-0.03c1.87-1.52 0.32-3.66 0.02-4.03c-0.02-0.02 0.02-0.04 0.05-0.03c0.64 0.17 4.36 1.07 6.99-0.01c0.04-0.01 0.08 0.01 0.05 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m940.16 188.45c-1.87 1.52-0.3 3.68 0 4.05c0.02 0.02-0.02 0.04-0.05 0.03c-0.65-0.17-4.38-1.08-7.01-0.01c-0.04 0.02-0.08-0.01-0.05-0.03c1.87-1.52 0.32-3.66 0.02-4.03c-0.02-0.02 0.02-0.04 0.05-0.03c0.64 0.17 4.36 1.07 6.99-0.01c0.04-0.02 0.08 0.01 0.05 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m990.71 217.69c-1.87 1.52-0.3 3.68 0 4.05c0.02 0.02-0.02 0.04-0.05 0.03c-0.65-0.17-4.38-1.08-7.01-0.01c-0.04 0.02-0.08-0.01-0.05-0.03c1.87-1.52 0.32-3.66 0.02-4.03c-0.02-0.02 0.02-0.04 0.05-0.03c0.64 0.17 4.36 1.07 6.99-0.01c0.04-0.01 0.08 0.01 0.05 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m990.66 229.39c-1.87 1.52-0.3 3.68 0 4.05c0.02 0.02-0.02 0.04-0.05 0.03c-0.65-0.17-4.38-1.09-7.01-0.01c-0.04 0.01-0.08-0.01-0.05-0.03c1.87-1.52 0.32-3.66 0.02-4.03c-0.02-0.02 0.02-0.04 0.05-0.03c0.64 0.17 4.36 1.07 6.99-0.01c0.04-0.02 0.08 0.01 0.05 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m1000.76 235.24c-1.87 1.52-0.3 3.68 0 4.05c0.02 0.02-0.02 0.04-0.05 0.03c-0.65-0.17-4.38-1.09-7.01-0.01c-0.04 0.02-0.08-0.01-0.05-0.03c1.87-1.52 0.32-3.66 0.02-4.03c-0.01-0.02 0.02-0.04 0.05-0.03c0.64 0.17 4.36 1.07 6.99-0.01c0.04-0.02 0.08 0.01 0.05 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m1010.87 241.09c-1.87 1.52-0.3 3.68 0 4.05c0.02 0.02-0.02 0.04-0.05 0.03c-0.65-0.17-4.38-1.08-7.01-0.01c-0.04 0.02-0.08-0.01-0.05-0.03c1.87-1.52 0.32-3.66 0.02-4.03c-0.01-0.02 0.02-0.04 0.05-0.03c0.64 0.17 4.36 1.07 6.99-0.01c0.04-0.02 0.08 0.01 0.05 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m1020.98 246.94c-1.87 1.52-0.3 3.68 0 4.05c0.02 0.02-0.02 0.04-0.05 0.03c-0.65-0.17-4.38-1.08-7.01-0.01c-0.04 0.02-0.08-0.01-0.05-0.03c1.87-1.52 0.32-3.66 0.02-4.03c-0.01-0.02 0.02-0.04 0.05-0.03c0.64 0.17 4.36 1.07 6.99-0.01c0.04-0.01 0.08 0.01 0.05 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m1000.82 223.54c-1.87 1.52-0.3 3.68 0 4.05c0.02 0.02-0.02 0.04-0.05 0.03c-0.65-0.17-4.38-1.09-7.01-0.01c-0.04 0.01-0.08-0.01-0.05-0.03c1.87-1.52 0.32-3.66 0.02-4.03c-0.01-0.02 0.02-0.04 0.05-0.03c0.64 0.17 4.36 1.07 6.99-0.01c0.04-0.02 0.08 0.01 0.05 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m1010.93 229.39c-1.87 1.52-0.3 3.68 0 4.05c0.02 0.02-0.02 0.04-0.05 0.03c-0.65-0.17-4.38-1.08-7.01-0.01c-0.04 0.02-0.08-0.01-0.05-0.03c1.87-1.52 0.32-3.66 0.02-4.03c-0.01-0.02 0.02-0.04 0.05-0.03c0.64 0.17 4.36 1.07 6.99-0.01c0.04-0.02 0.08 0.01 0.05 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m1021.04 235.24c-1.87 1.52-0.3 3.68 0 4.05c0.01 0.02-0.02 0.04-0.05 0.03c-0.65-0.17-4.38-1.09-7.01-0.01c-0.04 0.02-0.08-0.01-0.05-0.03c1.87-1.52 0.32-3.66 0.02-4.03c-0.02-0.02 0.02-0.04 0.05-0.03c0.64 0.17 4.36 1.07 6.99-0.01c0.04-0.02 0.08 0.01 0.05 0.03z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m681.42 404.8c-0.27 0-0.55-0.08-0.83-0.24c-0.89-0.52-1.59-1.72-1.59-2.75c0-0.57 0.22-1.03 0.61-1.26c0.39-0.22 0.9-0.19 1.4 0.1c0.89 0.52 1.59 1.72 1.59 2.76c0 0.57-0.22 1.03-0.61 1.26c-0.17 0.1-0.36 0.15-0.57 0.15zm-1.24-3.57c-0.06 0-0.11 0.01-0.15 0.04c-0.12 0.07-0.19 0.27-0.19 0.53c0 0.73 0.54 1.66 1.17 2.03c0.23 0.13 0.44 0.17 0.56 0.1c0.12-0.07 0.19-0.27 0.19-0.53c0-0.73-0.54-1.66-1.17-2.03c-0.15-0.09-0.29-0.13-0.41-0.13z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m687.79 408.48c-0.27 0-0.55-0.08-0.83-0.24c-0.89-0.52-1.59-1.72-1.59-2.75c0-0.57 0.22-1.03 0.61-1.26c0.39-0.23 0.9-0.19 1.4 0.1c0.89 0.52 1.59 1.72 1.59 2.75c0 0.57-0.22 1.03-0.61 1.26c-0.17 0.1-0.36 0.15-0.57 0.15zm-1.24-3.56c-0.06 0-0.11 0.01-0.15 0.04c-0.12 0.07-0.19 0.27-0.19 0.53c0 0.73 0.54 1.66 1.17 2.03c0.23 0.13 0.44 0.17 0.56 0.1c0.12-0.07 0.19-0.27 0.19-0.53c0-0.73-0.54-1.66-1.17-2.03c-0.15-0.09-0.29-0.13-0.41-0.13z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m694.16 412.16c-0.27 0-0.55-0.08-0.83-0.24c-0.89-0.52-1.59-1.73-1.59-2.76c0-0.57 0.22-1.03 0.61-1.26c0.39-0.23 0.9-0.19 1.4 0.1c0.89 0.52 1.59 1.72 1.59 2.75c0 0.57-0.22 1.03-0.62 1.26c-0.17 0.1-0.36 0.15-0.57 0.15zm-1.24-3.56c-0.06 0-0.11 0.01-0.15 0.04c-0.12 0.07-0.19 0.27-0.19 0.53c0 0.73 0.54 1.66 1.17 2.03c0.23 0.13 0.44 0.17 0.56 0.1c0.12-0.07 0.2-0.27 0.2-0.53c0-0.73-0.54-1.66-1.17-2.03c-0.15-0.09-0.29-0.13-0.41-0.13z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m700.54 415.84c-0.26 0-0.55-0.08-0.83-0.24c-0.89-0.52-1.59-1.72-1.59-2.76c0-0.57 0.22-1.03 0.61-1.26c0.39-0.22 0.9-0.19 1.39 0.1c0.89 0.52 1.59 1.73 1.59 2.76c0 0.57-0.22 1.03-0.61 1.26c-0.17 0.1-0.36 0.15-0.57 0.15zm-1.24-3.57c-0.06 0-0.11 0.01-0.15 0.04c-0.12 0.07-0.19 0.27-0.19 0.53c0 0.73 0.54 1.66 1.17 2.03c0.23 0.13 0.44 0.17 0.56 0.1c0.12-0.07 0.19-0.27 0.19-0.53c0-0.73-0.54-1.66-1.17-2.03c-0.15-0.09-0.29-0.13-0.41-0.13z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m706.91 419.52c-0.26 0-0.55-0.08-0.83-0.24c-0.89-0.52-1.59-1.72-1.59-2.75c0-0.57 0.22-1.03 0.61-1.26c0.39-0.22 0.9-0.19 1.39 0.1c0.89 0.52 1.59 1.73 1.59 2.76c0 0.57-0.22 1.03-0.61 1.26c-0.17 0.1-0.36 0.15-0.57 0.15zm-1.24-3.57c-0.06 0-0.11 0.01-0.15 0.04c-0.12 0.07-0.19 0.27-0.19 0.53c0 0.73 0.54 1.66 1.17 2.03c0.23 0.13 0.44 0.17 0.56 0.1c0.12-0.07 0.19-0.27 0.19-0.53c0-0.73-0.54-1.66-1.17-2.03c-0.15-0.09-0.29-0.13-0.41-0.13z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m614.14 366.02c-0.26 0-0.55-0.08-0.83-0.24c-0.89-0.52-1.59-1.72-1.59-2.76c0-0.57 0.22-1.03 0.61-1.26c0.39-0.23 0.9-0.19 1.4 0.1c0.89 0.52 1.59 1.72 1.59 2.76c0 0.57-0.22 1.03-0.61 1.26c-0.17 0.1-0.36 0.15-0.57 0.15zm-1.24-3.57c-0.06 0-0.11 0.01-0.15 0.04c-0.12 0.07-0.19 0.27-0.19 0.53c0 0.73 0.54 1.66 1.17 2.03c0.23 0.13 0.44 0.17 0.56 0.1c0.12-0.07 0.19-0.27 0.19-0.53c0-0.73-0.54-1.66-1.17-2.03c-0.15-0.09-0.29-0.13-0.41-0.13z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m620.51 369.7c-0.26 0-0.55-0.08-0.83-0.24c-0.89-0.52-1.59-1.72-1.59-2.76c0-0.57 0.22-1.03 0.61-1.26c0.39-0.23 0.9-0.19 1.4 0.1c0.89 0.52 1.59 1.73 1.59 2.76c0 0.57-0.22 1.03-0.61 1.26c-0.17 0.1-0.36 0.15-0.57 0.15zm-1.24-3.57c-0.06 0-0.11 0.01-0.15 0.04c-0.12 0.07-0.19 0.27-0.19 0.53c0 0.73 0.54 1.66 1.17 2.03c0.23 0.13 0.44 0.17 0.56 0.1c0.12-0.07 0.19-0.27 0.19-0.53c0-0.73-0.54-1.66-1.17-2.03c-0.15-0.09-0.29-0.13-0.41-0.13z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m626.88 373.38c-0.26 0-0.55-0.08-0.83-0.24c-0.89-0.52-1.59-1.73-1.59-2.75c0-0.57 0.22-1.03 0.61-1.26c0.39-0.23 0.9-0.19 1.4 0.1c0.89 0.52 1.59 1.73 1.59 2.75c0 0.57-0.22 1.03-0.61 1.26c-0.17 0.1-0.36 0.15-0.57 0.15zm-1.24-3.56c-0.06 0-0.11 0.01-0.15 0.04c-0.12 0.07-0.19 0.27-0.19 0.53c0 0.73 0.54 1.66 1.17 2.03c0.23 0.13 0.43 0.17 0.56 0.1c0.12-0.07 0.19-0.27 0.19-0.53c0-0.73-0.54-1.66-1.17-2.03c-0.15-0.09-0.29-0.13-0.41-0.13z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m633.26 377.06c-0.26 0-0.55-0.08-0.83-0.24c-0.89-0.52-1.59-1.72-1.59-2.75c0-0.57 0.22-1.03 0.61-1.26c0.39-0.23 0.9-0.19 1.39 0.1c0.89 0.52 1.59 1.72 1.59 2.75c0 0.57-0.22 1.03-0.61 1.26c-0.17 0.1-0.36 0.15-0.57 0.15zm-1.24-3.56c-0.06 0-0.11 0.01-0.15 0.04c-0.12 0.07-0.19 0.27-0.19 0.53c0 0.73 0.54 1.66 1.17 2.03c0.23 0.13 0.43 0.17 0.56 0.1c0.12-0.07 0.19-0.27 0.19-0.53c0-0.73-0.54-1.66-1.17-2.03c-0.15-0.09-0.29-0.13-0.41-0.13z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m639.63 380.74c-0.26 0-0.55-0.08-0.83-0.24c-0.89-0.52-1.59-1.73-1.59-2.76c0-0.57 0.22-1.03 0.61-1.26c0.39-0.23 0.9-0.19 1.4 0.1c0.89 0.52 1.59 1.72 1.59 2.76c0 0.57-0.22 1.03-0.61 1.26c-0.17 0.1-0.36 0.15-0.57 0.15zm-1.24-3.57c-0.06 0-0.11 0.01-0.15 0.04c-0.12 0.07-0.19 0.27-0.19 0.53c0 0.73 0.54 1.66 1.17 2.03c0.23 0.13 0.43 0.17 0.56 0.1c0.12-0.07 0.19-0.27 0.19-0.53c0-0.73-0.54-1.66-1.17-2.03c-0.15-0.09-0.29-0.13-0.41-0.13z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m668.18 397.81c-0.55 0-1.13-0.17-1.7-0.5l-13.46-7.77c-1.59-0.91-2.78-2.84-2.78-4.48v-0.32c0-0.96 0.42-1.76 1.14-2.17c0.81-0.46 1.85-0.39 2.87 0.19l13.46 7.77c1.59 0.92 2.78 2.84 2.78 4.48v0.32c0 0.98-0.41 1.75-1.14 2.18c-0.35 0.2-0.74 0.3-1.16 0.3zm-15.63-14.37c-0.22 0-0.42 0.05-0.59 0.15c-0.46 0.26-0.55 0.78-0.55 1.16v0.32c0 1.21 0.98 2.77 2.19 3.46l13.46 7.77c0.64 0.37 1.27 0.44 1.69 0.2c0.46-0.27 0.56-0.78 0.56-1.16v-0.32c0-1.21-0.98-2.76-2.19-3.46l-13.46-7.77c-0.39-0.22-0.77-0.34-1.11-0.34z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m820.34 254.72l-22.2-12.82c-3.39-1.96-2.97-5.38 0.95-7.65l20.3-11.72c3.92-2.26 9.85-2.51 13.24-0.55l22.2 12.82c3.39 1.96 2.97 5.38-0.95 7.65l-20.3 11.72c-3.92 2.26-9.85 2.51-13.24 0.55z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s1",
    d: "m826.09 256.88c-0.37 0-0.74-0.01-1.11-0.04l0.11-1.67c2.83 0.2 5.88-0.46 8.07-1.73l0.72-0.42l0.84 1.45l-0.72 0.42c-2.18 1.26-5.07 1.98-7.91 1.98zm-6.09-1.39l-8.47-4.89l0.84-1.45l8.39 4.85l-0.76 1.49zm18.92-3.43l-0.84-1.45l8.39-4.85l0.84 1.45l-8.39 4.85zm-31.59-3.88l-8.39-4.85l0.84-1.45l8.39 4.85l-0.84 1.45zm44.18-3.39l-0.84-1.45l2.79-1.61c1.8-1.04 2.82-2.35 2.82-3.6c0-0.2-0.03-0.4-0.08-0.59l1.61-0.45c0.09 0.34 0.14 0.68 0.14 1.03c0 1.87-1.34 3.71-3.66 5.05l-2.79 1.61zm-56.37-5.21c-0.09-0.33-0.13-0.66-0.13-0.99c0-1.87 1.34-3.71 3.66-5.05l2.81-1.63l0.84 1.45l-2.81 1.62c-1.8 1.04-2.82 2.35-2.82 3.6c0 0.19 0.02 0.38 0.07 0.57l-1.62 0.43zm58.03-4.76l-8.39-4.85l0.84-1.45l8.39 4.85l-0.84 1.45zm-46.64-3.88l-0.84-1.45l8.39-4.85l0.84 1.45l-8.39 4.85zm34.05-3.39l-8.37-4.83l0.77-1.49l0.08 0.05l8.35 4.82l-0.84 1.45zm-21.46-3.88l-0.84-1.45l0.69-0.4c2.48-1.43 5.88-2.17 9.06-1.94l-0.12 1.67c-2.85-0.2-5.9 0.45-8.1 1.73l-0.69 0.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m861.34 278.39l-22.2-12.82c-3.39-1.96-2.97-5.38 0.95-7.65l20.3-11.72c3.92-2.26 9.85-2.51 13.24-0.55l22.2 12.82c3.39 1.96 2.97 5.38-0.95 7.65l-20.3 11.72c-3.92 2.26-9.85 2.51-13.24 0.55z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m867.1 280.56c-2.3 0-4.5-0.48-6.18-1.45l-22.2-12.82c-1.75-1.01-2.71-2.45-2.71-4.05c0-1.87 1.33-3.71 3.66-5.05l20.29-11.72c4.22-2.43 10.4-2.67 14.08-0.55l22.2 12.81c1.75 1.01 2.71 2.45 2.71 4.05c0 1.87-1.33 3.71-3.66 5.05l-20.29 11.72c-2.29 1.32-5.16 2-7.9 2zm0.77-35.4c-2.45 0-5.05 0.6-7.07 1.77l-20.29 11.72c-1.79 1.04-2.82 2.35-2.82 3.6c0 1.25 1.02 2.1 1.87 2.59l22.2 12.82c3.16 1.82 8.72 1.58 12.4-0.55l20.29-11.72c1.79-1.04 2.82-2.35 2.82-3.6c0-1.25-1.02-2.1-1.87-2.6l-22.2-12.81c-1.42-0.82-3.33-1.22-5.33-1.22z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m902.33 302.06l-22.2-12.82c-3.39-1.96-2.97-5.38 0.95-7.65l20.3-11.72c3.92-2.26 9.85-2.51 13.24-0.55l22.2 12.82c3.39 1.96 2.97 5.38-0.95 7.65l-20.3 11.72c-3.92 2.26-9.85 2.51-13.24 0.55z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m908.1 304.23c-2.3 0-4.5-0.48-6.18-1.45l-22.2-12.81c-1.75-1.01-2.71-2.45-2.71-4.05c0-1.87 1.33-3.71 3.66-5.05l20.3-11.72c4.21-2.43 10.4-2.67 14.08-0.55l22.2 12.82c1.75 1.01 2.71 2.45 2.71 4.05c0 1.87-1.33 3.71-3.66 5.05l-20.29 11.72c-2.29 1.32-5.16 2-7.9 2zm-5.35-2.9c3.16 1.82 8.73 1.58 12.4-0.55l20.29-11.72c1.79-1.04 2.82-2.35 2.82-3.6c0-1.25-1.02-2.1-1.87-2.59l-22.2-12.82c-3.16-1.82-8.72-1.58-12.4 0.55l-20.3 11.72c-1.79 1.04-2.82 2.35-2.82 3.6c0 1.25 1.02 2.1 1.87 2.6l22.2 12.82z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m779.15 325.84l-63.19-36.48c-3.39-1.96-2.97-5.38 0.95-7.65l61.39-35.44c3.92-2.26 9.85-2.51 13.24-0.55l63.19 36.48c3.39 1.96 2.97 5.38-0.95 7.65l-61.39 35.44c-3.92 2.26-9.85 2.51-13.24 0.55z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m784.92 328.01c-2.3 0-4.5-0.48-6.19-1.45l-63.19-36.48c-1.75-1.01-2.71-2.45-2.71-4.05c0-1.87 1.33-3.71 3.66-5.05l61.39-35.44c4.21-2.43 10.4-2.67 14.08-0.55l63.19 36.48c1.75 1.01 2.71 2.45 2.71 4.05c0 1.87-1.33 3.71-3.66 5.05l-61.39 35.44c-2.29 1.32-5.16 2-7.89 2zm-5.35-2.9c3.16 1.82 8.72 1.57 12.4-0.55l61.39-35.44c1.79-1.04 2.82-2.35 2.82-3.6c0-1.25-1.02-2.1-1.87-2.59l-63.19-36.48c-3.16-1.82-8.72-1.58-12.4 0.55l-61.39 35.44c-1.79 1.04-2.82 2.35-2.82 3.6c0 1.25 1.02 2.1 1.87 2.59l63.19 36.49z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m861.24 325.78l-22.2-12.82c-3.39-1.96-2.97-5.38 0.95-7.65l20.3-11.72c3.92-2.26 9.85-2.51 13.24-0.55l22.2 12.82c3.39 1.96 2.97 5.38-0.95 7.65l-20.3 11.72c-3.92 2.26-9.85 2.51-13.24 0.55z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s1",
    d: "m866.99 327.94c-0.37 0-0.74-0.01-1.11-0.04l0.12-1.67c2.83 0.2 5.88-0.46 8.07-1.72l0.72-0.42l0.84 1.45l-0.72 0.42c-2.18 1.26-5.07 1.99-7.91 1.99zm-6.12-1.41l0.42-0.72l-0.46 0.7l-8.41-4.86l0.84-1.45l8.39 4.85l-0.78 1.48zm18.95-3.42l-0.84-1.45l8.39-4.85l0.84 1.45l-8.39 4.85zm-31.59-3.88l-8.39-4.85l0.84-1.45l8.39 4.85l-0.84 1.45zm44.18-3.39l-0.84-1.45l2.79-1.61c1.8-1.04 2.82-2.35 2.82-3.6c0-0.2-0.03-0.4-0.08-0.59l1.61-0.45c0.09 0.34 0.14 0.68 0.14 1.04c0 1.87-1.34 3.71-3.66 5.05l-2.79 1.61zm-56.37-5.21c-0.09-0.33-0.13-0.66-0.13-0.99c0-1.87 1.34-3.71 3.66-5.05l2.81-1.62l0.84 1.45l-2.81 1.63c-1.8 1.04-2.82 2.35-2.82 3.6c0 0.19 0.02 0.38 0.07 0.57l-1.62 0.43zm58.03-4.76l-8.39-4.85l0.84-1.45l8.39 4.85l-0.84 1.45zm-46.64-3.88l-0.84-1.45l8.39-4.85l0.84 1.45l-8.39 4.85zm34.05-3.39l-8.37-4.83l0.81-1.47l-0.42 0.72l0.43-0.72l8.39 4.84l-0.84 1.45zm-21.46-3.88l-0.84-1.45l0.69-0.4c2.48-1.43 5.89-2.17 9.06-1.94l-0.12 1.67c-2.84-0.2-5.9 0.45-8.1 1.72l-0.69 0.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m814.42 302.25l-0.83-1.45l4.36-2.5l0.83 1.45l-4.36 2.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s1",
    d: "m823.5 297.06l-0.83-1.45l9.43-5.39l0.83 1.45l-9.43 5.39zm14.15-8.09l-0.83-1.45l1.17-0.67c0.63-0.36 1.01-1.01 1.01-1.74c0-0.72-0.37-1.37-1-1.73l-3.07-1.79l0.84-1.45l3.07 1.79c1.14 0.67 1.83 1.86 1.83 3.18c0 1.34-0.69 2.53-1.85 3.2l-1.17 0.67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m830.22 278.83l-4.34-2.53l0.84-1.45l4.34 2.53l-0.84 1.45z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m964.07 266.6l-104.51-60.34c-3.31-1.91-2.89-5.24 0.93-7.45c3.82-2.2 9.59-2.44 12.9-0.53l104.51 60.34c3.31 1.91 2.89 5.24-0.93 7.45c-3.82 2.2-9.59 2.44-12.9 0.53z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m969.69 268.74c-2.24 0-4.39-0.46-6.03-1.41l-104.51-60.34c-1.71-0.99-2.65-2.39-2.65-3.96c0-1.83 1.3-3.62 3.58-4.94c4.11-2.37 10.15-2.61 13.73-0.53l104.51 60.34c1.71 0.99 2.65 2.39 2.65 3.96c0 1.83-1.3 3.63-3.58 4.94c-2.23 1.29-5.03 1.95-7.7 1.95zm-101.9-70.92c-2.38 0-4.91 0.58-6.88 1.72c-1.74 1-2.74 2.27-2.74 3.49c0 1.21 0.99 2.03 1.81 2.51l104.51 60.34c3.07 1.77 8.48 1.53 12.06-0.53c1.74-1 2.74-2.28 2.74-3.49c0-1.21-0.99-2.03-1.81-2.51l-104.51-60.34c-1.38-0.8-3.23-1.19-5.18-1.19z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m752.01 389.03l-104.51-60.34c-3.31-1.91-2.89-5.24 0.93-7.45c3.82-2.2 9.59-2.44 12.9-0.53l104.51 60.34c3.31 1.91 2.89 5.24-0.93 7.45c-3.82 2.2-9.59 2.44-12.9 0.53z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m757.63 391.17c-2.24 0-4.39-0.46-6.03-1.41l-104.51-60.34c-1.71-0.99-2.65-2.39-2.65-3.96c0-1.82 1.3-3.62 3.58-4.94c4.11-2.37 10.14-2.61 13.73-0.53l104.51 60.34c1.71 0.99 2.65 2.39 2.65 3.96c0 1.83-1.3 3.62-3.58 4.94c-2.23 1.29-5.03 1.95-7.7 1.95zm-5.2-2.86c3.07 1.77 8.48 1.53 12.06-0.54c1.74-1 2.74-2.27 2.74-3.49c0-1.21-0.99-2.03-1.81-2.51l-104.51-60.34c-3.07-1.77-8.48-1.53-12.06 0.53c-1.74 1.01-2.74 2.28-2.74 3.49c0 1.21 0.99 2.03 1.81 2.51l104.51 60.34z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m902.76 254.66l-63.51-36.67c-3.31-1.91-2.89-5.24 0.93-7.45c3.82-2.2 9.59-2.44 12.9-0.53l63.51 36.67c3.31 1.91 2.89 5.24-0.93 7.45c-3.82 2.2-9.59 2.44-12.9 0.53z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m908.37 256.8c-2.24 0-4.39-0.47-6.03-1.41l-63.51-36.67c-1.71-0.99-2.65-2.39-2.65-3.96c0-1.82 1.3-3.62 3.58-4.94c4.11-2.37 10.14-2.61 13.73-0.53l63.51 36.67c1.71 0.99 2.65 2.39 2.65 3.96c0 1.83-1.3 3.63-3.58 4.94c-2.23 1.29-5.03 1.95-7.7 1.95zm-5.2-2.86c3.07 1.77 8.48 1.53 12.06-0.53c1.74-1 2.74-2.27 2.74-3.49c0-1.21-0.99-2.03-1.81-2.51l-63.51-36.67c-3.07-1.77-8.48-1.53-12.06 0.53c-1.74 1-2.74 2.28-2.74 3.49c0 1.21 0.99 2.03 1.81 2.51l63.51 36.67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m943.75 278.33l-22.52-13c-3.31-1.91-2.89-5.24 0.93-7.45c3.82-2.2 9.59-2.44 12.9-0.53l22.52 13c3.31 1.91 2.89 5.24-0.93 7.45c-3.82 2.2-9.59 2.44-12.9 0.53z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s1",
    d: "m949.35 280.45c-0.38 0-0.76-0.01-1.14-0.04l0.12-1.67c2.78 0.2 5.75-0.44 7.89-1.68c0.18-0.1 0.35-0.21 0.51-0.32l0.93 1.39c-0.19 0.13-0.39 0.25-0.6 0.37c-2.13 1.23-4.94 1.94-7.72 1.94zm-5.97-1.37l0.43-0.72l-0.44 0.71l-8.12-4.69l0.84-1.45l8.08 4.67l-0.79 1.48zm17.25-5.27l-1.67-0.09c0-1.34-0.98-2.17-1.81-2.64l-4.36-2.52l0.84-1.45l4.36 2.52c1.71 0.99 2.65 2.39 2.65 3.96l-0.01 0.23zm-29.43-1.76l-8.08-4.67l0.84-1.45l8.08 4.67l-0.84 1.45zm17.55-5.83l-8.08-4.67l0.84-1.45l8.08 4.67l-0.84 1.45zm-29.71-1.66c-0.58-0.74-0.88-1.6-0.88-2.47c0-1.83 1.3-3.63 3.58-4.94c0.51-0.29 1.06-0.56 1.64-0.8l0.63 1.55c-0.51 0.2-0.99 0.44-1.43 0.69c-1.74 1-2.74 2.28-2.74 3.49c0 0.5 0.18 0.99 0.53 1.44l-1.32 1.03zm17.58-5.34l-1.99-1.15c-1.56-0.9-3.9-1.32-6.34-1.13l-0.13-1.67c2.76-0.21 5.45 0.28 7.31 1.35l1.99 1.15l-0.84 1.45z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m820.15 349.51l-22.2-12.82c-3.39-1.96-2.97-5.38 0.95-7.65l20.3-11.72c3.92-2.26 9.85-2.51 13.24-0.55l22.2 12.82c3.39 1.96 2.97 5.38-0.95 7.65l-20.3 11.72c-3.92 2.26-9.85 2.51-13.24 0.55z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m825.92 351.68c-2.3 0-4.5-0.48-6.19-1.45l-22.2-12.82c-1.75-1.01-2.71-2.44-2.71-4.05c0-1.87 1.33-3.71 3.66-5.05l20.29-11.72c4.21-2.44 10.4-2.68 14.08-0.55l22.2 12.82c1.75 1.01 2.71 2.45 2.71 4.05c0 1.87-1.33 3.71-3.66 5.05l-20.29 11.72c-2.29 1.32-5.16 2-7.89 2zm0.77-35.4c-2.45 0-5.05 0.6-7.07 1.77l-20.29 11.72c-1.79 1.04-2.82 2.35-2.82 3.6c0 1.25 1.02 2.1 1.87 2.6l22.2 12.82c3.16 1.82 8.72 1.58 12.4-0.55l20.29-11.72c1.79-1.04 2.82-2.35 2.82-3.6c0-1.25-1.02-2.1-1.87-2.6l-22.2-12.82c-1.42-0.82-3.33-1.22-5.33-1.22z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m697.06 325.89l-22.2-12.82c-3.39-1.96-2.97-5.38 0.95-7.65l20.3-11.72c3.92-2.26 9.85-2.51 13.24-0.55l22.2 12.82c3.39 1.96 2.97 5.38-0.95 7.65l-20.3 11.72c-3.92 2.26-9.85 2.51-13.24 0.55z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s1",
    d: "m702.81 328.06c-0.37 0-0.75-0.01-1.11-0.04l0.12-1.67c2.84 0.2 5.88-0.46 8.07-1.72l0.72-0.42l0.84 1.45l-0.72 0.42c-2.18 1.26-5.07 1.99-7.91 1.99zm-6.1-1.4l-0.03-0.02l-8.43-4.87l0.84-1.45l8.39 4.85l-0.76 1.49zm18.92-3.43l-0.84-1.45l8.39-4.85l0.84 1.45l-8.39 4.85zm-31.59-3.88l-8.39-4.85l0.84-1.45l8.39 4.85l-0.84 1.45zm44.18-3.39l-0.84-1.45l2.79-1.61c1.8-1.04 2.82-2.35 2.82-3.6c0-0.2-0.03-0.39-0.08-0.59l1.62-0.44c0.09 0.34 0.14 0.68 0.14 1.03c0 1.87-1.34 3.71-3.66 5.05l-2.79 1.61zm-56.37-5.22c-0.09-0.33-0.13-0.66-0.13-0.99c0-1.86 1.33-3.71 3.66-5.05l2.82-1.63l0.84 1.45l-2.82 1.63c-1.79 1.04-2.82 2.35-2.82 3.6c0 0.19 0.02 0.38 0.07 0.56l-1.62 0.43zm58.03-4.76l-8.39-4.85l0.84-1.45l8.39 4.85l-0.84 1.45zm-46.64-3.88l-0.84-1.45l8.39-4.85l0.84 1.45l-8.39 4.85zm34.05-3.39l-8.37-4.83l0.82-1.46l-0.43 0.72l0.43-0.72l8.38 4.84l-0.84 1.45zm-21.46-3.88l-0.84-1.45l0.69-0.4c2.48-1.43 5.89-2.17 9.06-1.94l-0.12 1.67c-2.85-0.2-5.91 0.45-8.1 1.72l-0.69 0.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m779.06 373.23l-63.19-36.48c-3.39-1.96-2.97-5.38 0.95-7.65l20.3-11.72c3.92-2.26 9.85-2.51 13.24-0.55l63.19 36.48c3.39 1.96 2.97 5.38-0.95 7.65l-20.3 11.72c-3.92 2.26-9.85 2.51-13.24 0.55z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m784.82 375.41c-2.3 0-4.5-0.48-6.18-1.45l-63.19-36.48c-1.75-1.01-2.71-2.45-2.71-4.05c0-1.87 1.34-3.71 3.66-5.05l20.29-11.72c4.21-2.44 10.4-2.68 14.08-0.55l63.19 36.48c1.75 1.01 2.71 2.45 2.71 4.05c0 1.87-1.34 3.71-3.66 5.05l-20.29 11.72c-2.29 1.32-5.16 2-7.9 2zm-5.35-2.9c3.16 1.82 8.73 1.58 12.4-0.55l20.29-11.72c1.79-1.04 2.82-2.35 2.82-3.6c0-1.25-1.02-2.1-1.87-2.6l-63.19-36.48c-3.16-1.82-8.72-1.57-12.4 0.55l-20.29 11.72c-1.79 1.04-2.82 2.35-2.82 3.6c0 1.25 1.02 2.1 1.87 2.6l63.19 36.48z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s1",
    d: "m775.17 379.26l-8.71-5.03l0.84-1.45l8.71 5.03l-0.84 1.45zm-13.06-7.54l-8.71-5.03l0.84-1.45l8.71 5.03l-0.84 1.45zm-13.06-7.54l-8.71-5.03l0.84-1.45l8.71 5.03l-0.84 1.45zm-13.06-7.54l-8.71-5.03l0.84-1.45l8.71 5.03l-0.84 1.45zm-13.06-7.54l-8.71-5.03l0.84-1.45l8.71 5.03l-0.84 1.45zm-13.06-7.54l-8.71-5.03l0.84-1.45l8.71 5.03l-0.84 1.45zm-13.06-7.54l-8.71-5.03l0.84-1.45l8.71 5.03l-0.84 1.45zm-13.06-7.54l-8.71-5.03l0.84-1.45l8.71 5.03l-0.84 1.45zm-13.06-7.54l-8.71-5.03l0.84-1.45l8.71 5.03l-0.84 1.45z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>",
    clipPath: "url(#cp5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m1003.96 439.78l-74.87-43.15l0.63-1.09l74.87 43.15l-0.63 1.09z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m1000.54 441.61l-74.87-43.15l0.63-1.09l74.87 43.15l-0.63 1.09z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m997.43 443.55l-74.87-43.15l0.63-1.09l74.87 43.15l-0.63 1.09z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m993.94 445.34l-74.87-43.15l0.63-1.09l74.87 43.15l-0.63 1.09z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m991.06 447.35l-74.87-43.15l0.63-1.09l74.87 43.15l-0.63 1.09z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m987.63 449.17l-74.87-43.15l0.63-1.09l74.87 43.15l-0.63 1.09z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m984.53 451.12l-74.87-43.15l0.63-1.09l74.87 43.15l-0.63 1.09z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m981.04 452.91l-74.87-43.15l0.63-1.09l74.87 43.15l-0.63 1.09z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m977.93 454.85l-74.87-43.15l0.63-1.09l74.87 43.15l-0.63 1.09z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m974.45 456.67l-74.87-43.15l0.63-1.09l74.87 43.15l-0.63 1.09z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m971.34 458.62l-74.87-43.15l0.63-1.09l74.87 43.15l-0.63 1.09z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m967.85 460.4l-74.87-43.15l0.63-1.09l74.87 43.15l-0.63 1.09z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m964.97 462.41l-74.87-43.15l0.63-1.09l74.87 43.15l-0.63 1.09z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m961.55 464.23l-74.87-43.15l0.63-1.09l74.87 43.15l-0.63 1.09z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m958.44 466.18l-74.87-43.15l0.63-1.09l74.87 43.15l-0.63 1.09z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m954.95 467.97l-74.87-43.15l0.63-1.09l74.87 43.15l-0.63 1.09z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m951.84 469.91l-74.87-43.15l0.63-1.09l74.87 43.15l-0.63 1.09z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m947.38 471.04l-74.87-43.15l0.63-1.09l74.87 43.15l-0.63 1.09z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m943.89 472.82l-74.86-43.15l0.63-1.09l74.87 43.15l-0.63 1.09z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m941.01 474.83l-74.87-43.15l0.63-1.09l74.87 43.15l-0.63 1.09z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m937.58 476.66l-74.87-43.15l0.63-1.09l74.87 43.15l-0.63 1.09z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m934.48 478.6l-74.87-43.15l0.63-1.09l74.87 43.15l-0.63 1.09z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m930.99 480.39l-74.86-43.15l0.63-1.09l74.87 43.15l-0.63 1.09z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m927.88 482.33l-74.87-43.15l0.63-1.09l74.87 43.15l-0.63 1.09z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m1017.27 432.39l-74.86-43.15l0.63-1.09l74.87 43.15l-0.63 1.09z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m1013.85 434.21l-74.87-43.15l0.63-1.09l74.87 43.15l-0.63 1.09z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m1010.74 436.16l-74.87-43.15l0.63-1.09l74.87 43.15l-0.63 1.09z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m1007.25 437.94l-74.87-43.15l0.63-1.09l74.87 43.15l-0.63 1.09z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m1004.14 439.89l-74.87-43.15l0.63-1.09l74.87 43.15l-0.63 1.09z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m907.8 297.33c1.66 2.3 4.99 11.01 5.73 12.95c0.09 0.25 0.05 0.51-0.1 0.72l-3.45 4.7c-0.27 0.37-0.8 0.42-1.14 0.12l-3.83-3.41c-5.45-6.14-9.29-11.94-11.52-17.39c0 0 1.05-4.26 3.14-12.78c3.03-12.31 12.4-30.73 13.09-32.08c0.01-0.01 0.02 0 0.02 0.01c-3.26 14.07-0.5 33.48-0.48 33.64c-1.91 3.48-3.54 6.13-4.88 7.95c0.77 1.61 1.91 3.46 3.43 5.55z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m909.34 317.11c-0.46 0-0.9-0.17-1.24-0.47l-3.83-3.41c-8.29-9.34-11.66-17.45-11.8-17.79l-0.13-0.33l3.23-13.12c3.03-12.32 12.15-30.3 13.18-32.31l0.43-0.85l1.82 0.64l-0.2 0.96c-3.2 13.82-0.49 33.05-0.46 33.25l0.05 0.36l-0.18 0.32c-2.17 3.94-3.84 6.47-4.57 7.52c0.46 0.87 1.49 2.68 3.04 4.82c1.71 2.35 4.92 10.7 5.87 13.21c0.22 0.59 0.13 1.24-0.25 1.75l-3.45 4.7c-0.31 0.42-0.79 0.7-1.31 0.75c-0.07 0.01-0.13 0.01-0.19 0.01zm-14.73-22.18c0.71 1.58 4.14 8.81 11.19 16.76l3.48 3.09l3.15-4.29c-1.89-4.99-4.31-10.85-5.53-12.53c-2.31-3.19-3.48-5.62-3.53-5.72l-0.28-0.59l0.39-0.53c0.02-0.03 1.93-2.64 4.63-7.52c-0.3-2.28-1.81-14.77-0.62-26.45c-3.19 6.75-7.88 17.4-9.83 25.35l-3.05 12.42z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m904.09 292.83c-1.46-0.38-3.06-0.09-3.08-0.09l-0.42-2.14c0.09-0.02 2.08-0.39 4.04 0.12l-0.55 2.11z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m911.2 436.06c3.92 0.98 6.33 2.62 7.25 4.93c0.62 1.56 0.47 4.22 0.12 6.67c-0.49 3.45-2.72 6.41-5.87 7.9c-2.28 1.09-9.27 5.13-12.52 6.58c-7.36 3.3-10.7-3.95-8.43-5.82c2.27-1.87 10.2-9.34 11.75-13.16c1.32-3.25 2.54-5.11 3.65-5.59l4.04-1.52z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m896.6 464.08c-2.75 0-4.73-1.46-5.75-3.11c-1.27-2.04-1.18-4.35 0.21-5.5c2.59-2.13 10.03-9.28 11.43-12.73c2.04-5.04 3.89-6.03 4.24-6.18l4.4-1.65l0.33 0.08c0.26 0.07 6.44 1.64 8 5.58c0.59 1.5 0.65 3.93 0.18 7.22c-0.55 3.8-2.97 7.06-6.48 8.73c-0.92 0.44-2.73 1.43-4.64 2.47c-2.8 1.53-5.96 3.26-7.89 4.12c-1.48 0.66-2.83 0.94-4.03 0.94zm11.02-25.51c-0.19 0.12-1.51 1.09-3.1 5c-1.7 4.18-9.9 11.8-12.07 13.59c-0.45 0.37-0.45 1.53 0.26 2.66c1.05 1.69 3.45 2.93 7.03 1.32c1.85-0.83 4.98-2.54 7.74-4.05c2.02-1.11 3.77-2.06 4.75-2.53c2.85-1.36 4.81-4 5.25-7.07c0.41-2.83 0.39-5-0.05-6.12c-0.89-2.25-4.5-3.7-6.18-4.18l-3.64 1.37z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m908.06 437.07l7.28 1.13c-0.7 4.36-2.54 7.49-5.51 9.37c-4.46 2.83-6.81 0.86-5.57-1.41c1.03-1.9 2.04-4.62 3.03-8.16l0.78-0.93z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m905.94 450.07c-0.91 0-1.69-0.27-2.28-0.82c-0.95-0.89-1.09-2.27-0.36-3.61c1.47-2.71 2.92-7.88 2.94-7.93l0.06-0.22l1.32-1.59l8.98 1.39l-0.18 1.08c-0.05 0.29-1.19 7.06-6 10.12c-1.65 1.05-3.2 1.58-4.48 1.58zm2.33-11.55c-0.31 1.07-1.63 5.54-3.06 8.16c-0.18 0.33-0.29 0.76-0.07 0.98c0.41 0.38 1.84 0.43 4.1-1.01c2.97-1.88 4.29-5.7 4.78-7.56l-5.52-0.85l-0.23 0.28z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m974.04 382.34c4.22-1.09 7.2 0.61 8.97 2.24c1.26 1.16 1.15 6.41 0.15 7.8c-0.04 5.9-2.01 11.2-5.9 15.92c-5.84 7.08-12.78 2.52-9.81-4.04c1.98-4.37 2.21-9.3 0.69-14.79c-0.95-3.5 1.02-5.88 5.91-7.14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m971.06 412.95c-1.09 0-2.08-0.29-2.89-0.8c-2.13-1.33-3.49-4.42-1.72-8.34c2.78-6.12 0.65-13.97 0.63-14.04l0-0.01c-0.03-0.09-0.6-2.29 0.71-4.54c1.09-1.87 3.1-3.2 5.97-3.94c4.7-1.22 8.02 0.68 9.98 2.5c1.68 1.55 1.53 6.89 0.49 8.91c-0.07 1.67-0.67 9.67-6.15 16.31c-2.33 2.83-4.88 3.95-7.03 3.95zm-1.88-23.75c0.12 0.43 2.34 8.72-0.75 15.52c-1.23 2.71-0.44 4.76 0.89 5.59c1.6 1 4.41 0.55 7.09-2.7c5.51-6.68 5.65-15.16 5.65-15.24l0-0.34l0.2-0.28c0.77-1.07 0.76-5.66 0-6.37c-1.56-1.45-4.21-2.95-7.96-1.99c-2.29 0.59-3.85 1.58-4.64 2.93c-0.84 1.44-0.5 2.84-0.49 2.88z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m974.04 382.34c2.2 1.93 3.05 4.28 2.53 7.03c-0.21 1.12-0.52 2.03-0.86 2.77c-0.74 1.59-4.47 4.36-5.73 3.14l-1.85-5.79l5.91-7.14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m970.82 396.67c-0.78 0-1.29-0.31-1.6-0.61l-0.2-0.19l-2.12-6.62l7-8.47l0.84 0.74c0.15 0.14 3.76 3.36 2.89 8.05c-0.21 1.1-0.52 2.12-0.94 3.03c-0.69 1.5-3.26 3.64-5.26 4.01c-0.22 0.04-0.43 0.06-0.62 0.06zm0.06-2.15c0.76 0 3.28-1.64 3.84-2.84c0.34-0.74 0.61-1.59 0.78-2.51c0.42-2.26-0.64-4.14-1.43-5.16l-4.72 5.71l1.54 4.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m927.66 317.19l14.3 6.84c-4.99 23.58-5.71 35.74-2.14 36.5c5.35 1.14 10.17 4.2 17.91 9.57c5.16 3.58 13.46 9.82 15.88 11.64c0.42 0.32 0.62 0.85 0.52 1.37l-0.25 1.32c-0.38 2-1.68 3.71-3.51 4.61l-0.78 0.39c-0.34 0.17-0.74 0.19-1.1 0.05l-21.69-8.15l-13.72-3.63l-7.94-6.36c-10.4-15.2-14.41-30.59-12.02-46.18l14.54-7.97z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m968.98 390.66c-0.3 0-0.59-0.05-0.87-0.16l-21.69-8.15l-13.84-3.65l-8.33-6.74c-15.66-22.89-12.23-46.72-12.2-46.96l0.08-0.53l15.5-8.5l15.58 7.45l-0.18 0.84c-3.87 18.27-5.26 34.73-2.98 35.21c5.73 1.22 10.97 4.65 18.3 9.74c5.2 3.61 13.5 9.85 15.92 11.67c0.75 0.57 1.11 1.5 0.94 2.44l-0.25 1.32c-0.44 2.33-1.98 4.34-4.1 5.38l-0.78 0.38c-0.34 0.17-0.72 0.26-1.1 0.26zm-35.4-13.95l13.5 3.57l21.8 8.18c0.08 0.03 0.16 0.02 0.24-0.01l0.78-0.38c1.52-0.75 2.61-2.18 2.92-3.84l0.25-1.32c0.02-0.11-0.02-0.22-0.11-0.29c-2.41-1.82-10.68-8.03-15.85-11.62c-7.12-4.94-12.19-8.26-17.51-9.4c-5.65-1.2-1.25-25.59 1.12-36.96l-13.02-6.23l-13.56 7.43c-0.39 3.54-1.98 24.49 11.81 44.75l7.63 6.11z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m953.92 332.13c0.12 11.55-10.8 29.72-18.35 36.63c-5.03 4.61-9.31 12.01-12.85 22.2c1.72 10.47 1.3 18.99-1.28 25.56c-3.23 8.23-5.05 18.21-5.56 21.27c-0.1 0.58-0.49 1.07-1.04 1.28l-0.39 0.15c-2.09 0.81-4.41 0.79-6.49-0.05c-0.66-0.26-1.07-0.9-1.04-1.61c0.33-7.12 2.06-44.73 2.25-52.88c0.14-6 5.28-23.37 15.43-52.09c19.46-8 29.23-8.16 29.31-0.46z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m911.28 440.9c-1.26 0-2.52-0.24-3.72-0.72c-1.08-0.44-1.78-1.51-1.72-2.67c0.48-10.44 2.07-45.12 2.25-52.85c0.21-9.08 14.86-50.66 15.49-52.43l0.16-0.46l0.45-0.19c2.19-0.9 21.59-8.67 28.4-4.16c1.56 1.03 2.39 2.66 2.42 4.7c0.13 12.09-11.17 30.54-18.7 37.44c-6.73 6.17-11.74 19.51-12.47 21.51c0.34 2.25 2.3 16.45-1.38 25.85c-3.2 8.15-5.02 18.18-5.5 21.05c-0.16 0.96-0.82 1.77-1.73 2.12l-0.39 0.15c-1.15 0.44-2.36 0.67-3.57 0.67zm14.19-107.49c-1.63 4.66-15.01 43.05-15.2 51.29c-0.18 7.76-1.77 42.45-2.25 52.9c-0.01 0.24 0.13 0.45 0.36 0.55c1.83 0.74 3.85 0.75 5.69 0.04l0.39-0.15c0.19-0.07 0.33-0.24 0.36-0.44c0.49-2.93 2.35-13.14 5.62-21.49c3.71-9.46 1.24-24.83 1.21-24.98l-0.04-0.27l0.09-0.26c0.22-0.63 5.49-15.63 13.14-22.65c7.33-6.72 18.11-24.71 17.99-35.81c-0.01-1.34-0.47-2.26-1.44-2.9c-4.82-3.2-19.92 1.77-25.92 4.17z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m958.77 273.27c-2.42 17.97-2.65 32.77-0.7 44.41c1.96 11.64-9.57 14.94-34.57 9.91c-0.62-1.91-1.28-4.42-1.97-7.54l-0.47 0.08c-1.65 4.32-3.18 6.06-4.61 5.22c-1.42-0.84-4.22-2.56-8.38-5.17c1.02-24.39 0.88-39.24-0.42-44.55c-1.96-7.96-0.7-28.74 1.54-31.69c1.49-1.97 7.14-3.71 16.94-5.24l10.36 4.79l6.79-1.04c11.02 4.12 17.95 8.84 20.79 14.18c2.84 5.34 1.07 10.87-5.31 16.62z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m939.82 335.3c-8.18 0-15.96-1.53-16.53-1.65l-0.63-0.13l-0.2-0.61c-0.03-0.1-0.63-1.97-1.41-5.13c-0.79 1.5-1.94 3.22-3.25 3.68c-0.65 0.22-1.31 0.17-1.9-0.18c-2.13-1.25-8.15-5.02-8.41-5.18l-0.54-0.34l0.03-0.63c0.01-0.36 1.51-36.52-0.39-44.24c-1.95-7.92-0.81-29.25 1.73-32.6c2.38-3.14 15.11-5.26 17.64-5.65l0.32-0.05l10.37 4.79l6.75-1.03l0.27 0.1c0.69 0.26 16.97 6.42 21.37 14.69c4.2 7.91-3.55 16.03-5.24 17.66c-0.42 3.34-3.34 27.73-0.65 43.7c0.58 3.44-0.24 6.25-2.43 8.37c-3.57 3.46-10.36 4.44-16.9 4.44zm-15.47-3.66c3.87 0.7 24.29 4.02 30.85-2.34c1.67-1.61 2.25-3.72 1.8-6.44c-2.93-17.42 0.65-44.46 0.69-44.73l0.05-0.4l0.3-0.27c0.09-0.08 8.88-8.15 5.07-15.3c-3.73-7.01-17.85-12.75-19.94-13.57l-6.83 1.04l-10.36-4.79c-5.92 0.95-14.58 3.01-15.91 4.77c-1.81 2.39-3.39 22.44-1.35 30.77c1.85 7.53 0.68 39.16 0.48 44.22c1.56 0.97 6.08 3.79 7.82 4.81c0 0 0.01 0 0.01 0c0.58 0 2.04-2.08 3.03-4.67l0.22-0.58l2.1-0.37l0.23 1.02c0.74 3.33 1.44 5.75 1.76 6.83z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m936.82 240.48c0.01 1.83 0.57 4.09 1.69 6.79c-1.18 1.92-2.84 3.68-4.97 5.3c-3.57 2.69-8.36 3.14-12.49 1.41c1.49-4.66 2.09-8.43 1.82-11.31c-0.28-2.89 4.37-3.61 13.95-2.18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m926.13 256.09c-1.85 0-3.72-0.37-5.5-1.11l-0.92-0.39l0.3-0.95c0.02-0.07 2.16-6.82 1.77-10.87c-0.08-0.87 0.21-1.66 0.86-2.27c2.8-2.66 12.43-1.37 14.33-1.09l0.92 0.14l0.01 0.93c0 0.07 0.06 2.64 1.61 6.38l0.21 0.51l-0.29 0.47c-0.08 0.13-1.91 3.08-5.24 5.6c-2.32 1.75-5.16 2.65-8.06 2.65zm-3.74-2.78c3.62 1.19 7.56 0.6 10.49-1.61c2.27-1.71 3.79-3.69 4.4-4.56c-1-2.57-1.36-4.59-1.49-5.7c-4.28-0.55-10.25-0.7-11.66 0.63c-0.16 0.15-0.21 0.28-0.19 0.49c0.34 3.55-0.96 8.62-1.57 10.75z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m937.33 243.72c4.88 0.83 7.65 2.95 8.3 6.37c-3.3 6.77-9.43 10.63-18.39 11.56l-1.02-6.66c2.61 0.04 5.36-0.96 8.24-2.98c2.6-1.83 3.89-5.13 2.91-8.16l-0.04-0.12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m926.32 262.84l-1.37-8.96l1.29 0.02h0c0.07 0 3.67-0.02 7.6-2.79c2.27-1.6 3.3-4.45 2.5-6.94l-0.55-1.71l1.73 0.18c0.33 0.06 8.08 1.43 9.19 7.24l0.07 0.36l-0.16 0.33c-0.21 0.44-5.37 10.72-19.26 12.16l-1.03 0.11zm1.16-6.86l0.68 4.46c10.74-1.53 15.39-8.83 16.32-10.5c-0.74-2.73-3.8-4.11-5.73-4.73c0.25 2.91-1.12 5.9-3.66 7.68c-3.1 2.18-6.01 2.87-7.61 3.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m923.88 254.8l-3.81 5.67c-3.45-2.63-4.32-6.47-2.59-11.51l5.48 0.77c-0.9 1.84-0.6 3.53 0.92 5.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m920.33 262.03l-0.92-0.7c-0.06-0.04-5.77-4.52-2.96-12.73l0.29-0.85l7.86 1.1l-0.66 1.35c-0.04 0.08-0.97 2.11 0.72 3.83l0.62 0.63l-4.95 7.36zm-2.08-11.86c-1.18 4.38 0.54 7.27 1.65 8.6l2.61-3.89c-1.13-1.54-1.15-3.14-0.95-4.24l-3.31-0.46z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m929.57 219.62l6.56 8.52l1.82 2.39c0.87-0.33 1.84 0.05 2.26 0.88c0.61 1.23 0.8 2.67 0.32 3.95c-0.61 1.64-1.71 2.63-3.29 2.97c0 1.35-0.48 2.66-1.36 3.68l-1.99 2.32c-5.38 5.06-11.93 5.72-14.64 5.76c-0.77 0.01-1.46-0.44-1.77-1.13l-0.79-1.76c-1.41-3.13-2.42-6.44-2.81-9.84c-0.63-5.57-0.11-10.23 1.59-13.96l14.1-3.77z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m919.23 251.18c-1.18 0-2.25-0.69-2.74-1.78l-0.79-1.76c-1.55-3.44-2.52-6.86-2.9-10.17c-0.98-8.56 1.57-14.3 1.68-14.54l0.21-0.47l15.3-4.09l8.42 10.95c1.13-0.08 2.24 0.53 2.78 1.6c0.79 1.58 0.92 3.34 0.37 4.82c-0.76 2.02-2.3 2.97-3.26 3.38c-0.16 1.32-0.7 2.58-1.58 3.6l-1.99 2.32c-5.77 5.44-12.73 6.1-15.45 6.14c-0.01 0-0.03 0-0.04 0zm-2.95-26.88c-0.55 1.47-2.07 6.33-1.31 12.93c0.35 3.08 1.27 6.29 2.72 9.52l0.79 1.76c0.14 0.3 0.43 0.49 0.75 0.49c0 0 0.01 0 0.01 0c2.47-0.03 8.78-0.64 13.91-5.46l1.91-2.23c0.71-0.83 1.1-1.89 1.1-2.98v-0.88l0.86-0.18c0.07-0.01 1.8-0.44 2.49-2.28c0.34-0.92 0.24-2.04-0.28-3.08c-0.17-0.33-0.55-0.48-0.9-0.35l-0.76 0.29l-8.43-10.98l-12.87 3.44z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m927.96 211.47c0.59-0.04 1.22-0.07 1.89-0.1c10.33-0.42 13.83 10.33 13.83 14.94c0 3.07-0.98 5.31-2.94 6.7l0-0.03c-0.1-1.7-1.82-2.82-3.42-2.22l-1.81 0.69c-0.03 0.01-0.07-0.01-0.07-0.05c-0.34-4.11-5.78-3.83-16.05-3.7c-6.89 0.09-10.43-3.26-10.61-10.05c2.93 1.4 5.27 0.38 6.88-0.98c3.5-2.97 7.74-4.92 12.32-5.21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m939.75 235.07l-0.1-1.99c-0.03-0.49-0.27-0.89-0.65-1.15c-0.39-0.25-0.86-0.3-1.29-0.14l-2.32 0.88l-0.96-0.58l-0.08-0.58c-0.23-2.8-4.33-2.86-13.57-2.72l-1.38 0.02c-0.08 0-0.15 0-0.23 0c-11.05 0-11.48-11-11.49-11.12l-0.05-1.78l1.61 0.77c2.04 0.97 3.9 0.7 5.71-0.82c3.87-3.28 8.35-5.17 12.95-5.47c0.6-0.04 1.24-0.07 1.92-0.1c3.78-0.16 7.02 1.05 9.65 3.57c3.65 3.5 5.31 8.92 5.31 12.46c0 5.11-3.26 7.49-3.39 7.59l-1.62 1.16zm-1.53-5.55c0.68 0 1.36 0.2 1.96 0.59c0.39 0.25 0.71 0.56 0.97 0.92c0.68-0.94 1.44-2.48 1.44-4.7c0-2.59-1.24-7.62-4.64-10.89c-2.18-2.09-4.91-3.09-8.05-2.96c-0.66 0.03-1.28 0.06-1.87 0.1c-4.13 0.26-8.17 1.98-11.68 4.95v0c-1.93 1.64-4.06 2.23-6.27 1.75c0.55 2.6 2.47 7.37 9.1 7.37c0.06 0 0.13 0 0.19 0l1.38-0.02c8.94-0.13 14.26-0.21 15.51 3.4l0.68-0.26c0.42-0.16 0.86-0.24 1.29-0.24z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m921.55 325.12c-1.66-26.09 0.07-59.28 0.09-59.62l2.18 0.12c-0.02 0.33-1.74 33.4-0.09 59.36l-2.17 0.14z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m931.84 374.49l-1.41-0.9c0.05-0.08 1.25-1.94 2.59-3.38l0.59-0.63c1.82-1.93 6.08-6.45 7.61-8.68l1.38 0.95c-1.61 2.33-5.93 6.92-7.78 8.88l-0.58 0.62c-1.24 1.33-2.39 3.12-2.4 3.14z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m918.37 353.65l-1.59-0.53l6.46-19.17l1.59 0.53l-6.46 19.17z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m914.67 345.77l-1.73-10.94l1.66-0.26l1.73 10.94l-1.66 0.26z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m949.84 348.14c-3.33-0.65-5.65-2.13-6.9-4.41c-2.11-3.84-0.33-8.46-0.26-8.66l1.56 0.61c-0.02 0.04-1.56 4.11 0.17 7.25c1 1.82 2.93 3.01 5.75 3.56l-0.32 1.65z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m922.09 391.51c-1.53-1.78-2.8-2.44-2.81-2.45l0.75-1.5c0.06 0.03 1.57 0.8 3.33 2.86l-1.27 1.09z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m912.24 436.25c-3.58 0-5.61-2.02-5.73-2.13l1.2-1.17l-0.6 0.59l0.6-0.59c0.13 0.13 3.15 3.05 8.45 0.75l0.67 1.54c-1.73 0.75-3.26 1.02-4.59 1.02z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m966.41 388.36l-0.78-1.48c0.16-0.09 3.9-2.12 4.56-7.18l1.66 0.22c-0.77 5.96-5.25 8.35-5.44 8.45z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m936.94 228.38l-1.6-0.48c0.75-2.48 0.64-4.44-0.31-5.83c-1.32-1.92-4.03-2.5-6.06-2.65c-5.65-0.41-5.9-3.93-5.91-4.08l1.67-0.09l-0.84 0.05l0.84-0.06c0.01 0.09 0.26 2.22 4.36 2.52c2.4 0.17 5.62 0.9 7.32 3.37c1.26 1.83 1.44 4.27 0.54 7.27z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m940.16 229.47l-1.08-1.28c1.87-1.57 0.93-4.81 0.92-4.85l1.61-0.48c0.05 0.18 1.25 4.34-1.45 6.61z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m904.92 454.04c-4 0-6.49-3.34-6.59-3.49l1.76-1.29l-0.88 0.64l0.88-0.65c0.02 0.03 1.96 2.6 4.84 2.6v2.18z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m971.41 400.53c-1.83 0-3.21-0.56-3.31-0.6l0.83-2.01c0.03 0.01 3.18 1.27 5.76-0.58l1.27 1.77c-1.54 1.1-3.17 1.42-4.55 1.42z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m971.71 404.87c-2.97 0-4.35-1.68-4.43-1.78l1.69-1.37c0.07 0.08 1.77 1.97 5.94 0.25l0.83 2.01c-1.58 0.65-2.92 0.89-4.03 0.89z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m901.54 456.15c-3.38-0.32-5.55-3.26-5.64-3.38l1.76-1.28c0.02 0.02 1.7 2.27 4.09 2.5l-0.21 2.17z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m941.79 254.56c-1.57-3.03-5.17-4.68-5.2-4.7l0.9-1.99c0.17 0.08 4.33 1.99 6.24 5.68l-1.93 1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m936.14 238.93c-0.19-1.47-0.98-2.3-0.99-2.31l1.55-1.53c0.13 0.13 1.32 1.38 1.6 3.57l-2.16 0.28z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m927.23 321.02c-0.03 0.79-0.43 1.56-1.2 2.01l-23.22 13.32c-1.95 1.13-4.36 1.12-6.31-0.01l-22.88-13.27c-0.72-0.42-1.1-1.12-1.18-1.85l0-0.04c-0.01-0.12-0.02-10.57-0.02-11.68c0-0.14 0.13-0.23 0.27-0.2l4.34 1.21c0.05 0.02 0.11 0.01 0.16-0.02l22.71-13.03c0.07-0.04 0.15-0.04 0.21 0l2.26 13.61c0.02 0.01 0.03 0.02 0.05 0.02l24.67-2.21c0.09 0.03 0.15 0.1 0.15 0.19c0 0.9-0.01 11.87-0.01 11.9l-0.01 0.04z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m899.66 338.28c-1.28 0-2.57-0.33-3.71-1l-22.88-13.27c-0.97-0.57-1.6-1.54-1.71-2.68c-0.01-0.14-0.02-0.18-0.03-8.74l0-3.09c0-0.41 0.19-0.79 0.51-1.03c0.32-0.24 0.74-0.32 1.14-0.21l3.98 1.11l22.4-12.85c0.4-0.23 0.9-0.23 1.3 0.01l0.44 0.26l2.18 13.14l23.91-2.14l0.2 0.06c0.56 0.16 0.94 0.66 0.94 1.24c0 0.12-0.01 11.87-0.01 11.96l-0.01 0.12c-0.04 1.12-0.69 2.21-1.74 2.82l-23.22 13.32c-1.14 0.66-2.41 0.99-3.69 0.99zm-26.16-27.61l0 1.92c0 3.37 0.01 8.26 0.01 8.55c0.03 0.22 0.15 0.7 0.64 0.99l22.88 13.27c1.61 0.94 3.61 0.94 5.22 0.01l23.22-13.32c0.57-0.33 0.65-0.89 0.66-1.11l0-0.04c0-0.58 0.01-8.08 0.01-10.88l-23.83 2.14l-0.48-0.17l-0.46-0.26l-2.11-12.69l-21.95 12.59l-0.61-0.12l-3.2-0.89z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m927.24 309.08c0 0.9-0.01 11.87-0.01 11.9l-0.01 0.04c-0.03 0.79-0.43 1.56-1.2 2.01l-23.22 13.32c-1.03 0.6-2.18 0.87-3.33 0.83l0.01-17.7l2.89-8.41c0.02 0.01 0.03 0.02 0.05 0.02l24.67-2.21c0.09 0.03 0.15 0.1 0.15 0.19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m899.67 338.28c-0.08 0-0.15 0-0.23 0l-1.06-0.03l0.07-19.11l3.35-9.74l0.89 0.59l24.5-2.2l0.19 0.05c0.56 0.15 0.96 0.66 0.96 1.24c0 0.82-0.01 9.89-0.01 11.62l-0.01 0.46c-0.04 1.12-0.69 2.21-1.74 2.82l-23.22 13.32c-1.11 0.64-2.38 0.98-3.68 0.98zm0.9-18.61l-0.01 16.36c0.6-0.1 1.17-0.31 1.7-0.61l23.22-13.32c0.57-0.33 0.65-0.89 0.66-1.11l0-0.28c0-1.45 0.01-8.05 0.01-10.64l-22.99 2.06l-2.59 7.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m875.93 317.99l-0.01 6.31l-2.31-1.34c-0.72-0.42-1.1-1.12-1.18-1.85l0-0.04c-0.01-0.12-0.02-10.57-0.02-11.68c0-0.14 0.13-0.23 0.27-0.2l4.01 1.12c-0.28 0.79-0.54 1.49-0.76 2.1v5.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m877.01 326.19l-3.94-2.29c-0.97-0.56-1.6-1.54-1.71-2.68c-0.01-0.14-0.02-0.18-0.03-8.74l0-3.09c0-0.41 0.19-0.79 0.51-1.03c0.32-0.24 0.74-0.32 1.14-0.21l5.14 1.43l-0.39 1.1c-0.31 0.87-0.58 1.6-0.7 1.93l-0.01 13.58zm-3.51-15.64l0 1.92c0 3.37 0.01 8.26 0.01 8.55c0.03 0.22 0.15 0.7 0.64 0.98l0.67 0.39l0.07-10.37c0 0 0.15-0.39 0.36-0.99l-1.77-0.49z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m896.61 324.52l-22.99-13.33c-1.62-0.94-1.61-3.28 0.01-4.22l23.32-13.38c1.89-1.09 4.21-1.09 6.1 0.01l22.99 13.33c1.62 0.94 1.61 3.28-0.01 4.22l-23.32 13.38c-1.89 1.09-4.21 1.09-6.1-0.01z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m899.67 326.43c-1.25 0-2.49-0.32-3.6-0.97l-22.99-13.33c-1.1-0.64-1.76-1.78-1.75-3.05c0-1.27 0.66-2.41 1.76-3.05l23.32-13.38c2.22-1.28 4.97-1.27 7.18 0.01l22.99 13.33c1.1 0.64 1.76 1.78 1.75 3.05c0 1.27-0.66 2.41-1.76 3.05l-23.32 13.38c-1.1 0.64-2.34 0.96-3.58 0.96zm0.32-32.56c-0.86 0-1.73 0.22-2.5 0.67l-23.32 13.38c-0.6 0.35-0.67 0.93-0.67 1.16c0 0.23 0.06 0.81 0.67 1.17l22.99 13.33c1.54 0.89 3.46 0.9 5 0.01l23.32-13.38c0.6-0.35 0.67-0.93 0.67-1.16c0-0.23-0.06-0.81-0.67-1.17l-22.99-13.33c-0.77-0.45-1.64-0.68-2.51-0.68z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m923.89 299.16c-0.03 0.79-0.43 1.56-1.2 2.01l-23.22 13.32c-1.95 1.13-4.36 1.12-6.31-0.01l-22.88-13.27c-0.72-0.42-1.1-1.12-1.18-1.85l0-0.04c-0.01-0.12-0.02-10.57-0.02-11.68c0-0.14 0.13-0.23 0.27-0.2l4.34 1.21c0.05 0.02 0.11 0.01 0.16-0.02l22.71-13.03c0.07-0.04 0.15-0.04 0.21 0l2.26 13.61c0.02 0.01 0.03 0.02 0.05 0.02l24.67-2.21c0.09 0.03 0.15 0.1 0.15 0.19c0 0.9-0.01 11.87-0.01 11.9l0 0.04z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m896.33 316.42c-1.28 0-2.57-0.33-3.71-1l-22.88-13.27c-0.97-0.57-1.6-1.54-1.72-2.68c-0.01-0.14-0.02-0.19-0.02-8.74l0-3.09c0-0.41 0.19-0.79 0.51-1.04c0.32-0.24 0.74-0.32 1.14-0.21l3.98 1.11l22.4-12.85c0.39-0.23 0.9-0.23 1.3 0.01l0.44 0.26l2.18 13.14l23.9-2.14l0.19 0.05c0.57 0.16 0.95 0.66 0.95 1.24l-0.02 12.08c-0.04 1.13-0.7 2.22-1.74 2.82l-23.22 13.32c-1.14 0.66-2.41 0.99-3.69 0.99zm-26.16-27.61l0 1.92c0 3.37 0.01 8.26 0.01 8.55c0.03 0.22 0.15 0.7 0.64 0.99l22.88 13.27c1.61 0.94 3.61 0.94 5.21 0.01l23.22-13.32c0.57-0.33 0.65-0.89 0.66-1.11h0l0.01-10.91l-23.83 2.14l-0.52-0.19l-0.43-0.26l-2.1-12.66l-21.94 12.59l-0.6-0.1l-3.23-0.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m923.9 287.23c0 0.9-0.01 11.87-0.01 11.9l0 0.04c-0.03 0.79-0.43 1.56-1.2 2.01l-23.22 13.32c-1.03 0.6-2.18 0.87-3.33 0.83l0.01-17.7l2.89-8.41c0.02 0.01 0.03 0.02 0.05 0.02l24.67-2.21c0.09 0.03 0.15 0.1 0.15 0.19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m896.33 316.42c-0.08 0-0.15 0-0.23 0l-1.06-0.03l0.07-19.11l3.33-9.69l0.89 0.54l24.52-2.2l0.19 0.05c0.57 0.16 0.95 0.66 0.95 1.24l-0.02 12.08c-0.04 1.13-0.7 2.21-1.74 2.82l-23.22 13.32c-1.11 0.64-2.38 0.98-3.68 0.98zm0.9-18.61l-0.01 16.36c0.6-0.1 1.17-0.31 1.7-0.61l23.22-13.32c0.57-0.33 0.65-0.89 0.66-1.11l0.01-10.91l-22.99 2.06l-2.59 7.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m872.6 296.13l-0.01 6.31l-2.31-1.34c-0.72-0.42-1.1-1.12-1.18-1.85l0-0.04c-0.01-0.12-0.02-10.57-0.02-11.68c0-0.14 0.13-0.23 0.27-0.2l4.01 1.12c-0.28 0.79-0.54 1.49-0.76 2.1v5.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m873.68 304.34l-3.94-2.29c-0.97-0.56-1.59-1.54-1.71-2.68c-0.01-0.14-0.02-0.19-0.02-8.74l0-3.09c0-0.41 0.19-0.79 0.51-1.04c0.32-0.24 0.75-0.32 1.14-0.21l5.14 1.43l-0.39 1.1c-0.31 0.87-0.58 1.61-0.7 1.93l-0.01 13.58zm-3.51-15.64l0 1.92c0 3.37 0.01 8.26 0.01 8.55c0.03 0.22 0.15 0.7 0.64 0.98l0.67 0.39l0.07-10.37c0.1-0.26 0.22-0.59 0.36-0.99l-1.77-0.49z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m893.28 302.66l-22.99-13.33c-1.62-0.94-1.61-3.28 0.01-4.22l23.32-13.38c1.89-1.09 4.21-1.09 6.1 0.01l22.99 13.33c1.62 0.94 1.61 3.28-0.01 4.22l-23.32 13.38c-1.89 1.09-4.21 1.09-6.1-0.01z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m896.33 304.57c-1.25 0-2.49-0.32-3.6-0.97l-22.99-13.33c-1.1-0.64-1.76-1.78-1.75-3.05c0-1.27 0.66-2.41 1.76-3.05l23.32-13.38c2.22-1.28 4.97-1.28 7.19 0.01l22.99 13.33c1.1 0.64 1.76 1.78 1.75 3.05c0 1.27-0.66 2.41-1.76 3.05l-23.32 13.38c-1.1 0.64-2.34 0.96-3.58 0.96zm0.32-32.56c-0.86 0-1.73 0.22-2.5 0.67l-23.32 13.38c-0.6 0.35-0.67 0.93-0.67 1.16c0 0.23 0.06 0.81 0.67 1.17l22.99 13.33c1.54 0.89 3.46 0.9 5 0.01l23.32-13.38c0.6-0.35 0.67-0.93 0.67-1.16c0-0.23-0.06-0.81-0.67-1.17l-22.99-13.33c-0.77-0.45-1.64-0.68-2.51-0.68z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m913.22 331.89l-0.9-1.41l8.04-5.16l0.9 1.41l-8.04 5.16z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m881.68 268.72l14.82 8.73l-14.88 8.4l-14.96-8.62l15.03-8.51z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m881.61 287.11l-17.15-9.88l17.24-9.76l16.99 10.01l-17.07 9.63zm-12.76-9.86l12.77 7.36l12.7-7.17l-12.65-7.46l-12.82 7.27z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m939.72 321.54c-2.47 1.68-5.39 2.55-8.38 2.51c-1.89-0.02-4.16-0.12-6.51-0.38c-3.7-0.4-10.39-6.59-0.42-7.84l4.81-0.58l0.35-0.44l-1.95-1.83l-0.02-0.71l2.31-0.58c2.64-0.25 4.74 1.12 6.31 4.11c1.57 2.99 2.73 4.9 3.5 5.73z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m931.54 325.14c-0.07 0-0.14 0-0.2 0c-2.34-0.03-4.56-0.16-6.62-0.38c-2.6-0.28-6.6-3-6.62-5.83c-0.01-1.55 1.05-3.53 6.18-4.17l3.22-0.39l-0.95-0.89l-0.06-2.04l3.16-0.79c0.36-0.04 4.88-0.41 7.54 4.66c2.21 4.22 3.33 5.49 3.34 5.5l0.83 0.92l-1.02 0.71c-2.59 1.77-5.63 2.7-8.8 2.7zm-2.31-12.14l1.83 1.72l-1.26 1.57l-5.25 0.64c-2.64 0.33-4.28 1.09-4.27 1.99c0.01 1.34 2.72 3.47 4.68 3.69c1.99 0.21 4.14 0.34 6.41 0.37c2.42 0.07 4.72-0.56 6.78-1.72c-0.61-0.88-1.56-2.41-2.88-4.93c-1.82-3.47-4.69-3.53-5.18-3.53l-0.85 0.21z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m945.21 315.41l-4.4 5.94l-3.56 1.47c-1.77-2.23-2.4-4.7-1.89-7.4l3.77-1.75l6.08 1.75z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m936.9 324.13l-0.51-0.64c-2.94-3.7-2.14-8.1-2.1-8.28l0.1-0.55l4.65-2.15l7.98 2.29l-5.52 7.44l-4.6 1.89zm-0.53-7.99c-0.07 1-0.05 3.26 1.26 5.33l2.49-1.02l3.28-4.43l-4.18-1.2l-2.85 1.32z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m955.13 260.46c0.01-0.01 0.02-0.02 0.04-0.03c2.71-1.66 6.8-1.57 8.34 1.21c3.48 6.32 15.01 28.38 18.61 39.11c0.38 1.12-0.08 2.35-1.09 2.96c-6.17 3.8-27.85 16.68-40.22 17.63c-1.02-0.74-1.58-3.31-1.68-7.68c7.35-4.33 12.1-7.33 14.24-9.01c3.21-2.51 8-5.36 12.75-5.92c-9.03-12.79-13.87-21.88-14.53-27.28c-0.65-5.4 0.52-9.07 3.53-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m940.49 322.46l-0.32-0.23c-0.46-0.34-1.99-1.95-2.12-8.54l-0.01-0.64l0.55-0.32c0.11-0.06 11.01-6.49 14.13-8.93c2.3-1.8 6.66-4.78 11.55-5.85c-3.18-4.64-12.88-19.3-13.74-26.36c-1.05-8.68 3.81-11.91 4.02-12.04l0.07-0.04c1.89-1.16 4.33-1.55 6.36-1.02c1.56 0.41 2.77 1.32 3.49 2.63c2.8 5.08 14.92 28.04 18.69 39.28c0.54 1.6-0.1 3.34-1.55 4.24c-6.37 3.93-28.14 16.82-40.71 17.79l-0.4 0.03zm-0.25-8.19c0.14 3.7 0.75 5.32 1.08 5.93c12.18-1.28 32.98-13.61 39.14-17.41c0.58-0.36 0.84-1.06 0.63-1.69c-3.72-11.09-15.75-33.88-18.53-38.93c-0.54-0.98-1.46-1.4-2.14-1.58c-1.45-0.38-3.29-0.08-4.67 0.77l-0.61-0.9l0.6 0.91c-0.16 0.11-3.92 2.71-3.04 9.96c0.93 7.73 14.2 26.59 14.34 26.78l1.06 1.5l-1.82 0.21c-5.23 0.62-10.28 4.19-12.21 5.7c-2.85 2.23-11.5 7.39-13.81 8.76z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m970.06 301.67c-1.47-1.51-4.04-1.84-4.07-1.85l0.26-2.16c0.14 0.02 3.35 0.42 5.36 2.49l-1.56 1.52z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m750.51 309.42l-84.32-48.45c-0.5-0.29-0.73-0.68-0.71-1.09v0c0-0.02 0-0.05 0-0.07l0.09-9.79c0-0.23 0.19-0.42 0.42-0.42l16.05-0.13c0.07 0 0.15-0.02 0.21-0.06l63.64-37.04c1.22-0.71 3.07-0.79 4.13-0.19l68.46 39.37c0.07 0.04 0.14 0.06 0.22 0.06l15.98-0.13c0.24 0 0.43 0.19 0.43 0.43l-0.07 9.84c-0.03 0.45-0.37 0.91-1 1.28l-79.42 46.22c-1.22 0.71-3.07 0.79-4.13 0.19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m752.3 310.92c-0.86 0-1.68-0.18-2.33-0.55l0 0l-84.32-48.45c-0.84-0.48-1.3-1.25-1.25-2.1l0.09-9.81c0.01-0.82 0.68-1.5 1.5-1.5l15.88-0.13l63.48-36.95c1.57-0.91 3.82-1 5.22-0.19l68.31 39.28l15.8-0.13c0.01 0 0.01 0 0.02 0c0.4 0 0.78 0.16 1.07 0.44c0.29 0.29 0.45 0.67 0.45 1.08l-0.07 9.84c-0.07 0.91-0.61 1.67-1.54 2.21l-79.42 46.22c-0.85 0.49-1.89 0.74-2.89 0.74zm-1.25-2.45c0.65 0.38 2.09 0.38 3.04-0.18l79.42-46.23c0.35-0.2 0.45-0.38 0.46-0.42l0.06-9.08l-15.31 0.13c-0.34 0-0.54-0.07-0.77-0.2l-68.46-39.37c-0.65-0.37-2.09-0.37-3.04 0.18l-63.64 37.04c-0.22 0.13-0.48 0.2-0.75 0.21l-15.41 0.13l-0.09 9.14c0 0.09 0.05 0.15 0.16 0.21l84.32 48.45l0 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m731.55 253.88c1.12-0.39 37.14-17.95 51.33-22.84c0.04-0.01 0.07-0.01 0.11 0.01l35.48 20.48c0.1 0.02 0.19 0.05 0.28 0.07l15.82-0.13c0.31 0 0.56 0.25 0.56 0.56l-0.07 9.71c-0.03 0.45-0.37 0.91-1 1.28l-79.22 46.11c-0.09 0.05-0.19-0.01-0.19-0.11l0.09-10.16c0 0 0-0.01 0-0.01l-23.27-44.85c0.01-0.05 0.03-0.09 0.08-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m754.84 310.39l-0.68-0.32c-0.37-0.22-0.61-0.62-0.61-1.05l0.09-9.92l-23.3-44.91l0.13-1l0.71-0.33c0.3-0.11 2.43-1.12 5.13-2.4c10.5-4.97 35.09-16.61 46.21-20.44l0.47-0.16l0.54 0.26l35.36 20.41l15.67-0.13c0.38 0.01 0.87 0.17 1.18 0.48c0.31 0.32 0.48 0.73 0.48 1.18l-0.07 9.7c-0.07 0.91-0.61 1.67-1.54 2.21l-79.77 46.43zm0.98-11.36l-0.07 8.31l77.76-45.26c0.35-0.2 0.45-0.38 0.46-0.42l0.06-9.08l-15.42 0.13l-0.69-0.22l-35.1-20.26c-11.21 3.94-35.24 15.32-45.58 20.21c-2.15 1.02-3.5 1.65-4.31 2.03l22.98 44.29l-0.09 0.28z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m834.15 252.62l-79.42 46.23c-1.22 0.71-3.07 0.79-4.13 0.19l-84.32-48.45c-1.06-0.61-0.93-1.68 0.29-2.39l79.42-46.23c1.22-0.71 3.07-0.79 4.13-0.19l84.32 48.45c1.06 0.61 0.93 1.68-0.29 2.39z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m752.39 300.53c-0.85 0-1.68-0.18-2.33-0.55l-84.32-48.45c-0.8-0.46-1.26-1.18-1.26-1.97c0-0.89 0.56-1.72 1.55-2.3l79.42-46.23c1.57-0.91 3.81-0.99 5.22-0.19l84.32 48.45c0.8 0.46 1.26 1.18 1.26 1.98c0 0.89-0.56 1.72-1.55 2.3l-79.42 46.22c-0.85 0.49-1.89 0.74-2.89 0.74zm-85.72-50.99c0.02 0 0.07 0.04 0.16 0.1l84.32 48.45c0.65 0.37 2.09 0.37 3.04-0.18l79.42-46.23c0.31-0.18 0.43-0.34 0.46-0.41c-0.02 0.01-0.07-0.04-0.17-0.1l0 0l-84.32-48.45c-0.64-0.37-2.09-0.37-3.04 0.18l-79.42 46.23c-0.31 0.18-0.43 0.34-0.46 0.41c0 0 0 0 0 0h0z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m673.16 264.38l-2.18-0.07l0.3-10.11l2.18 0.07l-0.3 10.11z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m809.61 276.41h-1.68v-7.59h1.68v7.59z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m839.74 203.44l-31.84-18.49c-0.5-0.29-0.73-0.68-0.71-1.09v0c0-0.03 0-0.05 0-0.07l0.09-9.79c0-0.23 0.19-0.42 0.42-0.42l16.05-0.13c0.07 0 0.15-0.02 0.21-0.06l15.69-8.87c1.22-0.71 3.07-0.79 4.13-0.19l15.99 9.41c0.07 0.04 0.14 0.06 0.22 0.06l15.98-0.13c0.24 0 0.43 0.19 0.43 0.43l-0.07 9.84c-0.03 0.45-0.37 0.91-1 1.27l-31.47 18.05c-1.22 0.71-3.07 0.79-4.13 0.19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m841.53 204.94c-0.86 0-1.68-0.18-2.33-0.55l0 0l-31.84-18.49c-0.84-0.48-1.3-1.24-1.25-2.09l0.09-9.82c0.01-0.82 0.68-1.5 1.5-1.5l15.89-0.13l15.54-8.79c1.56-0.91 3.8-0.99 5.21-0.18l15.84 9.32l15.8-0.13c0 0 0.01 0 0.01 0c0.41 0 0.79 0.16 1.08 0.44c0.29 0.29 0.45 0.67 0.45 1.08l-0.07 9.84c-0.07 0.91-0.61 1.67-1.54 2.21l-31.48 18.06c-0.84 0.49-1.88 0.74-2.88 0.74zm-1.25-2.44c0.65 0.37 2.09 0.37 3.04-0.18l31.48-18.06c0.34-0.2 0.44-0.37 0.46-0.42l0.06-9.08l-15.31 0.13c-0.28 0-0.54-0.07-0.77-0.2l-16-9.42c-0.64-0.36-2.08-0.37-3.03 0.19l-15.7 8.87c-0.22 0.13-0.48 0.2-0.74 0.2l-15.41 0.13l-0.09 9.14c0 0.09 0.04 0.15 0.16 0.21l31.85 18.49z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m861.82 173.66c0.02-0.01 4.7-0.01 14.02 0c0.31 0 0.56 0.25 0.56 0.56l-0.07 9.71c-0.03 0.45-0.37 0.91-1 1.27l-31.28 17.94c-0.09 0.05-0.19-0.01-0.19-0.11l0.09-10.16c0-0.01 0.01-0.01 0.01-0.02c-0.82-2.15 5.13-8.54 17.85-19.19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m844.06 204.4l-0.67-0.32c-0.38-0.22-0.61-0.63-0.6-1.07l0.09-10.11c-0.48-3.76 11.13-14.11 18.25-20.07l0.35-0.2c0.21-0.07 0.2-0.07 14.37-0.06c0.47-0.02 0.85 0.17 1.17 0.48c0.32 0.32 0.49 0.73 0.48 1.18l-0.07 9.7c-0.07 0.91-0.61 1.67-1.54 2.21l-31.83 18.26zm0.99-11.16l-0.07 8.12l29.82-17.11c0.34-0.2 0.44-0.37 0.46-0.42l0.06-9.09c-3.67 0-11.31-0.01-13.09 0c-8.45 7.1-17.36 15.83-17.22 17.77l0.2 0.53l-0.16 0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m875.43 174.81l-31.47 18.05c-1.22 0.71-3.07 0.79-4.13 0.19l-31.84-18.49c-1.06-0.61-0.93-1.68 0.29-2.39l31.47-18.05c1.22-0.71 3.07-0.79 4.13-0.19l31.84 18.49c1.06 0.61 0.93 1.68-0.29 2.39z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m841.62 194.55c-0.86 0-1.68-0.18-2.33-0.55l-31.85-18.49c-0.8-0.46-1.26-1.18-1.26-1.97c0-0.89 0.56-1.72 1.55-2.3l31.48-18.06c1.56-0.91 3.81-0.99 5.22-0.19l31.85 18.49c0.8 0.46 1.26 1.18 1.26 1.98c0 0.89-0.56 1.72-1.55 2.3l-31.48 18.06c-0.84 0.49-1.88 0.74-2.88 0.74zm-33.25-21.03c0.02 0 0.07 0.04 0.16 0.1l31.85 18.49c0.64 0.37 2.08 0.37 3.04-0.18l31.48-18.06c0.3-0.18 0.42-0.34 0.45-0.4c-0.02 0.02-0.07-0.04-0.17-0.1l0 0l-31.84-18.49c-0.64-0.37-2.08-0.37-3.04 0.18l-31.48 18.06c-0.3 0.18-0.42 0.34-0.45 0.4c0 0 0 0 0 0z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m814.86 188.35l-2.18-0.07l0.3-10.11l2.18 0.07l-0.3 10.11z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m868.2 189.18l-1.68-0.02l0.13-8.82l1.68 0.02l-0.13 8.82z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m841.4 181.73l-5.91-0.91l0.71-1.54c-0.55-0.21-1.02-0.43-1.45-0.67c-0.53-0.3-1-0.66-1.45-1.09l-2.58 0.4l-1.86-4l2.79-0.43c0.1-0.71 0.4-1.4 0.87-2.04l-2.09-1.21l4.74-2.74l1.82 1.05c1.39-0.45 2.94-0.69 4.52-0.72l0.67-1.45l5.91 0.91l-0.72 1.54c0.55 0.21 1.02 0.43 1.45 0.67v0c0.53 0.3 1 0.66 1.45 1.09l2.58-0.4l1.86 4l-2.79 0.43c-0.1 0.71-0.4 1.4-0.87 2.04l2.09 1.21l-4.74 2.74l-1.82-1.05c-1.39 0.45-2.94 0.69-4.52 0.72l-0.67 1.45zm-3.46-2.23l2.46 0.38l0.6-1.28l0.54 0.01c1.72 0.03 3.4-0.23 4.86-0.75l0.36-0.13l1.65 0.95l1.39-0.8l-1.45-0.84l0.82-0.77c0.77-0.72 1.16-1.52 1.12-2.32l-0.04-0.75l2-0.31l-0.39-0.84l-2.2 0.34l-0.3-0.32c-0.43-0.46-0.87-0.81-1.38-1.11c-0.53-0.31-1.17-0.57-2.01-0.83l-0.91-0.28l0.57-1.23l-2.46-0.38l-0.6 1.29l-0.55-0.01c-1.72-0.05-3.4 0.23-4.86 0.75l-0.36 0.13l-1.65-0.95l-1.39 0.8l1.45 0.84l-0.82 0.77c-0.77 0.72-1.16 1.52-1.12 2.32l0.04 0.75l-2 0.31l0.39 0.84l2.2-0.34l0.3 0.32c0.43 0.46 0.87 0.81 1.38 1.11c0.53 0.31 1.17 0.57 2.01 0.84l0.91 0.28l-0.57 1.23zm3.85-2.38c-1.49 0-2.98-0.44-3.91-1.32c-0.52-0.49-0.81-1.11-0.81-1.75c0-0.64 0.29-1.26 0.81-1.75c1.86-1.76 5.95-1.76 7.82 0c0.52 0.49 0.81 1.11 0.81 1.75c0 0.63-0.29 1.26-0.81 1.75c-0.93 0.88-2.42 1.32-3.91 1.32zm0-4.45c-1.08 0-2.15 0.29-2.76 0.86c-0.13 0.12-0.28 0.31-0.28 0.53c0 0.22 0.15 0.41 0.28 0.53c1.21 1.14 4.3 1.14 5.51 0c0.13-0.12 0.28-0.31 0.28-0.53c0-0.22-0.15-0.41-0.28-0.53c-0.61-0.57-1.68-0.86-2.76-0.86z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m850.1 169.56l2.38-0.37l1.12 2.42l-2.36 0.37c0.05 1.03-0.41 2.06-1.38 2.97l1.73 1l-3.07 1.77l-1.73-1c-1.57 0.56-3.36 0.83-5.15 0.8l-0.63 1.36l-4.19-0.65l0.64-1.38c-0.78-0.24-1.52-0.53-2.18-0.91c-0.66-0.38-1.15-0.81-1.57-1.26l-2.38 0.37l-1.12-2.42l2.36-0.37c-0.05-1.03 0.41-2.06 1.38-2.97l-1.73-1l3.07-1.77l1.73 1c1.57-0.56 3.36-0.83 5.15-0.8l0.63-1.36l4.19 0.65l-0.64 1.38c0.78 0.24 1.52 0.53 2.18 0.91c0.66 0.38 1.15 0.81 1.57 1.26zm-4.86 1.43c-1.54-1.46-5.12-1.46-6.66 0c-0.73 0.69-0.73 1.59 0 2.28c1.55 1.46 5.12 1.46 6.66 0c0.73-0.69 0.73-1.59 0-2.28z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>",
    clipPath: "url(#cp6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m701.35 142.22l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m705.04 144.19l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m708.39 146.28l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m712.15 148.21l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m715.25 150.37l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m718.94 152.34l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m722.29 154.43l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m726.05 156.36l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m729.4 158.46l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m733.14 160.42l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m736.49 162.51l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m740.25 164.44l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m743.36 166.6l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m747.04 168.56l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m750.39 170.66l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m754.15 172.59l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m757.5 174.68l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m687.01 134.25l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m690.7 136.22l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m694.05 138.31l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m697.81 140.24l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m701.15 142.34l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>",
    clipPath: "url(#cp7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m686.88 174.44l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m690.57 176.4l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m693.92 178.5l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m697.68 180.43l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m700.78 182.59l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m704.47 184.55l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m707.82 186.65l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m711.58 188.57l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m714.92 190.67l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m718.67 192.63l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m722.02 194.73l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m725.78 196.65l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m728.89 198.81l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m732.58 200.78l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m735.92 202.88l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m739.68 204.8l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m743.03 206.9l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m672.54 166.47l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m676.23 168.43l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m679.58 170.53l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m683.34 172.45l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m686.68 174.55l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m617.25 133.43l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m620.94 135.4l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m624.29 137.5l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m628.05 139.42l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m631.15 141.58l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m634.84 143.55l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m638.19 145.64l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m641.95 147.57l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m645.3 149.67l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m649.05 151.63l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m652.39 153.72l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m656.16 155.65l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m659.26 157.81l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m662.95 159.78l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m666.29 161.87l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m670.06 163.8l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m602.91 125.46l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m606.6 127.43l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m609.95 129.53l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m613.71 131.45l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m617.06 133.55l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m725.21 177.52l-49.52-28.8c-0.5-0.29-0.73-0.68-0.71-1.09v0c0-0.02 0-0.05 0-0.07l0.09-9.79c0-0.23 0.19-0.42 0.42-0.42l33.41-10.11c0.07 0 0.15-0.02 0.21-0.06l15.69-8.87c1.22-0.71 3.07-0.79 4.13-0.19l33.66 19.72c0.07 0.04 0.14 0.06 0.22 0.06l15.98-0.13c0.24 0 0.43 0.19 0.43 0.43l-0.07 9.84c-0.03 0.45-0.37 0.91-1 1.28l-48.83 28.03c-1.22 0.71-3.07 0.79-4.13 0.19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m727 179.02c-0.86 0-1.68-0.18-2.33-0.56l-0.01 0l-49.52-28.8c-0.84-0.48-1.3-1.25-1.25-2.09l0.09-9.82c0.01-0.75 0.57-1.38 1.3-1.49l33.43-10.11l15.56-8.79c1.56-0.91 3.8-0.99 5.21-0.18l33.51 19.63l15.8-0.13c0 0 0.01 0 0.01 0c0.41 0 0.79 0.16 1.08 0.45c0.29 0.29 0.45 0.67 0.44 1.08l-0.07 9.84c-0.07 0.91-0.61 1.67-1.54 2.21l-48.84 28.03c-0.84 0.49-1.88 0.74-2.88 0.74zm-1.24-2.44c0.65 0.37 2.08 0.37 3.04-0.18l48.84-28.03c0.34-0.2 0.44-0.37 0.45-0.42l0.06-9.08l-15.31 0.13c-0.28-0.01-0.53-0.06-0.77-0.2l-33.67-19.72c-0.64-0.36-2.08-0.37-3.03 0.19l-15.7 8.87c-0.16 0.09-0.34 0.16-0.54 0.19l-32.96 9.97l-0.09 9.29c0 0.09 0.04 0.15 0.16 0.21l49.52 28.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m764.66 137.77c0.02-0.01 4.7-0.01 14.02 0c0.31 0 0.56 0.25 0.56 0.56l-0.07 9.71c-0.03 0.45-0.37 0.91-1 1.28l-48.63 27.91c-0.09 0.05-0.19-0.01-0.19-0.11l0.09-10.16c0-0.01 0.01-0.01 0.01-0.02h0c-0.82-2.15 10.92-11.87 35.21-29.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m729.54 178.48l-0.67-0.32c-0.37-0.22-0.61-0.62-0.61-1.05l0.09-10.04c-0.33-1.16 0.34-3.53 17.58-16.79c8.87-6.82 18.01-13.33 18.1-13.4l0.24-0.13c0.22-0.08 0.22-0.08 14.41-0.07c0.36 0.02 0.85 0.17 1.16 0.48c0.32 0.31 0.49 0.73 0.49 1.18l-0.07 9.71c-0.07 0.91-0.61 1.67-1.54 2.21l-49.19 28.23zm0.98-11.22l-0.07 8.19l47.18-27.08c0.34-0.2 0.44-0.37 0.45-0.42l0.06-9.09c-3.71 0-11.46-0.01-13.14 0c-16.38 11.67-33.54 25.12-34.48 27.85l0.12 0.33l-0.13 0.22z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m778.26 138.92l-48.83 28.03c-1.22 0.71-3.07 0.79-4.13 0.19l-49.52-28.8c-1.06-0.61-0.93-1.68 0.29-2.39l48.83-28.03c1.22-0.71 3.07-0.79 4.13-0.19l49.52 28.8c1.06 0.61 0.93 1.68-0.29 2.39z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m727.09 168.63c-0.86 0-1.68-0.18-2.33-0.55l-49.53-28.8c-0.8-0.45-1.26-1.17-1.26-1.97c0-0.89 0.56-1.72 1.55-2.3l48.84-28.03c1.56-0.91 3.81-1 5.22-0.19l49.52 28.8c0.8 0.46 1.26 1.18 1.26 1.97c0 0.89-0.56 1.72-1.55 2.3l-48.84 28.03c-0.84 0.49-1.88 0.74-2.89 0.74zm-50.92-31.34c0.02 0 0.07 0.04 0.16 0.09l49.52 28.8c0.64 0.37 2.08 0.37 3.04-0.19l48.84-28.03c0.3-0.17 0.42-0.34 0.45-0.4c-0.02 0.01-0.07-0.04-0.17-0.1l-0.01 0l-49.52-28.8c-0.64-0.37-2.08-0.37-3.04 0.19l-48.83 28.03c-0.3 0.18-0.42 0.34-0.45 0.4c0 0 0 0 0 0z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m682.66 152.13l-2.18-0.07l0.3-10.11l2.18 0.07l-0.3 10.11z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m771.03 153.29l-1.68-0.03l0.13-8.82l1.68 0.03l-0.13 8.82z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m708.54 163.89v6.78c0 0.3-0.12 0.6-0.37 0.9l-8.61 5.37c-0.16 0.1-0.38 0.05-0.47-0.11l4.23-2.63c-0.03-0.05-0.07-0.09-0.12-0.12c-0.63-0.36-3.98 2.05-3.98 1.21v-2.87c0-0.06-0.02-0.12-0.05-0.17l-8.28-8.88c-0.1-0.16-0.04-0.37 0.11-0.46l8.58-5.35c0.2-0.13 0.47-0.14 0.77 0.03l7.06 4.14c0.63 0.36 1.14 1.34 1.14 2.17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m699.38 178.09c-0.11 0-0.23-0.01-0.34-0.04c-0.37-0.09-0.7-0.33-0.9-0.66l-0.55-0.92l0.64-0.4l-0.05-0.03l-0.07-0.75v-2.56l-8.18-8.8c-0.39-0.67-0.18-1.54 0.48-1.95l8.58-5.35c0.54-0.35 1.25-0.36 1.89 0.01l7.07 4.14c0.96 0.55 1.68 1.89 1.68 3.11v6.78c0 0.79-0.52 1.46-0.62 1.59l-0.27 0.24l-8.61 5.37c-0.23 0.14-0.49 0.22-0.75 0.22zm-7.04-14.74l7.75 8.35c0.13 0.22 0.2 0.47 0.2 0.73v1.55c0.12-0.06 0.23-0.11 0.33-0.17c1.31-0.65 2.26-1.12 3.04-0.71l3.72-2.32c0.03-0.05 0.05-0.1 0.06-0.13l0-6.75c0-0.52-0.35-1.09-0.59-1.23l0 0l-6.92-4.05l-7.59 4.73z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m699.67 169.5c0.02-0.03 0.05-0.06 0.08-0.08l8.5-5.3c0.16-0.1 0.36 0.01 0.36 0.2v6.36c0 0.3-0.12 0.6-0.37 0.9l-8.41 5.24c-0.27 0.17-0.63 0.08-0.8-0.19l-6.01-5.06c0.03-0.24 0.05-0.43 0.06-0.57l6.6-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m699.51 177.99c-0.13 0-0.26-0.01-0.39-0.05c-0.36-0.09-0.68-0.29-0.91-0.58l-6.35-5.35l0.21-1.91l7.12-1.63l8.48-5.29c0.41-0.25 0.92-0.27 1.34-0.03c0.42 0.23 0.68 0.68 0.68 1.16v6.36c0 0.79-0.52 1.46-0.62 1.59l-0.27 0.24l-8.41 5.24c-0.27 0.17-0.57 0.25-0.88 0.25zm-4.65-6.29l4.72 3.97l7.87-4.9c0.03-0.05 0.05-0.1 0.06-0.13l0-4.79l-6.99 4.36l-0.12 0.23l-5.53 1.26z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m698.5 177.08l-7.06-4.14c-0.63-0.36-1.14-1.34-1.14-2.17v-6.78c0-0.84 0.51-1.22 1.14-0.86l7.06 4.14c0.63 0.36 1.14 1.34 1.14 2.17v6.78c0 0.84-0.51 1.22-1.14 0.86z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m698.95 178.31c-0.33 0-0.67-0.09-1-0.28l0-0.01l-7.06-4.14c-0.95-0.55-1.68-1.89-1.68-3.11v-6.78c0-0.84 0.34-1.52 0.94-1.86c0.55-0.32 1.22-0.29 1.83 0.06l7.07 4.14c0.95 0.55 1.68 1.89 1.68 3.11v6.78c0 0.84-0.34 1.52-0.94 1.86c-0.26 0.15-0.54 0.22-0.83 0.22zm0.1-2.17l-0.55 0.94l0.56-0.94c0 0 0 0-0.01 0zm-7.65-11.77l-0.01 6.4c0 0.51 0.36 1.09 0.59 1.23l6.55 3.84l0.01-6.4c0-0.51-0.36-1.09-0.59-1.23l-6.55-3.84z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m700.82 173.71l-0.86-1.44l7.56-4.55l0.86 1.44l-7.56 4.55z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m733.15 133.07l-31.84-18.49c-0.5-0.29-0.73-0.68-0.71-1.09v0c0-0.03 0-0.05 0-0.07l0.09-9.79c0-0.23 0.19-0.42 0.42-0.42l16.05-0.13c0.07 0 0.15-0.02 0.21-0.06l15.69-8.87c1.22-0.71 3.07-0.79 4.13-0.19l15.99 9.41c0.07 0.04 0.14 0.06 0.22 0.06l15.98-0.13c0.24 0 0.43 0.19 0.43 0.43l-0.07 9.84c-0.03 0.45-0.37 0.91-1 1.27l-31.47 18.05c-1.22 0.71-3.07 0.79-4.13 0.19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m734.94 134.57c-0.86 0-1.68-0.18-2.33-0.55l0 0l-31.84-18.49c-0.84-0.48-1.3-1.25-1.25-2.1l0-0.02h0l0.09-9.79c0.01-0.82 0.68-1.49 1.5-1.5l15.89-0.13l15.54-8.78c1.56-0.91 3.8-0.99 5.21-0.18l15.84 9.32l15.8-0.13c0 0 0.01 0 0.01 0c0.41 0 0.79 0.16 1.07 0.45c0.29 0.29 0.45 0.67 0.44 1.08l-0.07 9.84c-0.07 0.91-0.61 1.67-1.54 2.21l-31.48 18.06c-0.84 0.49-1.88 0.74-2.89 0.74zm-1.25-2.44c0.65 0.37 2.09 0.37 3.04-0.18l31.48-18.06c0.34-0.2 0.44-0.37 0.46-0.42l0.06-9.08l-15.31 0.13c-0.28 0-0.54-0.07-0.77-0.2l-16-9.42c-0.64-0.36-2.08-0.37-3.03 0.19l-15.7 8.87c-0.23 0.13-0.49 0.2-0.75 0.2l-15.39 0.13l-0.08 9.17c0.01 0.08 0.06 0.13 0.16 0.18l31.84 18.49z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m755.23 103.29c0.02-0.01 4.7-0.01 14.02 0c0.31 0 0.56 0.25 0.56 0.56l-0.07 9.71c-0.03 0.45-0.37 0.91-1 1.27l-31.28 17.94c-0.09 0.05-0.19-0.01-0.19-0.11l0.09-10.16c0-0.01 0.01-0.01 0.01-0.02c-0.82-2.15 5.13-8.54 17.85-19.19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m737.48 134.02l-0.67-0.31c-0.38-0.22-0.62-0.62-0.62-1.06l0.09-10.14c-0.46-3.77 11.14-14.11 18.26-20.06l0.31-0.18c0.22-0.08 0.22-0.08 14.41-0.07c0.45 0 0.85 0.17 1.16 0.48c0.32 0.31 0.49 0.73 0.49 1.18l-0.07 9.71c-0.07 0.91-0.61 1.67-1.54 2.21l-31.82 18.25zm0.98-11.12l-0.07 8.09l29.83-17.11c0.34-0.2 0.44-0.37 0.46-0.42l0.06-9.09c-3.68 0-11.32-0.01-13.09 0c-8.45 7.1-17.36 15.83-17.22 17.77l0.21 0.56l-0.18 0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m768.84 104.43l-31.47 18.05c-1.22 0.71-3.07 0.79-4.13 0.19l-31.84-18.49c-1.06-0.61-0.93-1.68 0.29-2.39l31.47-18.05c1.22-0.71 3.07-0.79 4.13-0.19l31.84 18.49c1.06 0.61 0.93 1.68-0.29 2.39z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m735.03 124.17c-0.86 0-1.68-0.18-2.33-0.56l-31.85-18.49c-0.8-0.46-1.26-1.18-1.26-1.97c0-0.89 0.56-1.72 1.55-2.3l31.48-18.06c1.56-0.91 3.81-0.99 5.22-0.19l31.84 18.49c0.8 0.46 1.26 1.18 1.26 1.98c0 0.89-0.56 1.72-1.55 2.3l-31.48 18.06c-0.84 0.49-1.88 0.74-2.88 0.74zm-33.25-21.03c0.02 0 0.07 0.04 0.16 0.1l31.85 18.49c0.64 0.37 2.09 0.37 3.04-0.18l31.48-18.06c0.3-0.18 0.42-0.34 0.45-0.4c-0.01 0.01-0.07-0.04-0.17-0.1l-0.01 0l-31.84-18.49c-0.64-0.37-2.08-0.37-3.04 0.19l-31.48 18.06c-0.3 0.18-0.42 0.34-0.45 0.4c0 0 0 0 0 0z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m708.27 117.98l-2.18-0.07l0.3-10.11l2.18 0.07l-0.3 10.11z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m761.61 118.8l-1.68-0.03l0.13-8.82l1.68 0.03l-0.13 8.82z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m734.61 112.58l-6.49-1l0.8-1.73c-0.67-0.25-1.24-0.51-1.74-0.8c-0.61-0.35-1.15-0.76-1.67-1.26l-2.91 0.45l-2.01-4.33l3.11-0.48c0.11-0.86 0.46-1.69 1.06-2.45l-2.32-1.34l5.16-2.98l2.06 1.19c1.61-0.52 3.4-0.81 5.23-0.83l0.76-1.64l6.49 1l-0.8 1.73c0.67 0.25 1.24 0.51 1.74 0.8l0 0c0.6 0.35 1.15 0.77 1.66 1.26l2.91-0.45l2.01 4.33l-3.11 0.48c-0.11 0.86-0.46 1.68-1.06 2.45l2.32 1.34l-5.16 2.98l-2.06-1.19c-1.61 0.52-3.4 0.81-5.23 0.83l-0.76 1.64zm-4.03-2.32l3.04 0.47l0.68-1.47l0.54 0.01c1.98 0.04 3.89-0.26 5.56-0.86l0.37-0.13l1.88 1.09l1.81-1.05l-1.69-0.98l0.82-0.77c0.9-0.84 1.35-1.79 1.31-2.73l-0.04-0.75l2.33-0.36l-0.54-1.17l-2.53 0.39l-0.3-0.32c-0.49-0.53-1-0.93-1.6-1.28c-0.61-0.35-1.35-0.66-2.31-0.96l-0.91-0.29l0.66-1.42l-3.04-0.47l-0.68 1.47l-0.54-0.01c-1.97-0.04-3.89 0.27-5.56 0.86l-0.36 0.13l-1.88-1.09l-1.81 1.05l1.68 0.97l-0.82 0.77c-0.9 0.85-1.35 1.79-1.31 2.73l0.04 0.75l-2.33 0.36l0.54 1.17l2.52-0.39l0.3 0.32c0.5 0.53 1.01 0.94 1.6 1.28c0.61 0.35 1.35 0.66 2.31 0.96l0.91 0.29l-0.66 1.42zm4.55-2.91c-1.66 0-3.32-0.49-4.36-1.47c-0.57-0.54-0.88-1.21-0.88-1.9c0-0.69 0.31-1.37 0.88-1.9c2.08-1.96 6.65-1.96 8.73 0c0.57 0.54 0.88 1.21 0.88 1.9c0 0.69-0.31 1.37-0.88 1.9h0c-1.04 0.98-2.7 1.47-4.36 1.47zm0-5.08c-1.25 0-2.49 0.34-3.21 1.02c-0.16 0.15-0.36 0.4-0.36 0.69c0 0.29 0.19 0.53 0.36 0.68c1.44 1.36 4.99 1.36 6.43 0c0.16-0.15 0.36-0.4 0.36-0.69c0-0.29-0.19-0.53-0.36-0.69c-0.72-0.68-1.97-1.02-3.21-1.02z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m744.57 98.87l2.71-0.42l1.28 2.75l-2.68 0.42c0.06 1.17-0.47 2.35-1.57 3.38l1.97 1.14l-3.49 2.01l-1.97-1.14c-1.79 0.64-3.82 0.94-5.85 0.91l-0.72 1.55l-4.76-0.74l0.73-1.56c-0.88-0.28-1.73-0.6-2.48-1.03c-0.75-0.43-1.31-0.92-1.79-1.43l-2.71 0.42l-1.28-2.75l2.68-0.42c-0.06-1.17 0.47-2.35 1.57-3.38l-1.97-1.14l3.49-2.01l1.97 1.14c1.79-0.64 3.82-0.94 5.85-0.91l0.72-1.55l4.76 0.74l-0.73 1.56c0.88 0.28 1.73 0.6 2.48 1.03c0.75 0.43 1.31 0.92 1.79 1.43zm-5.53 1.62c-1.76-1.66-5.82-1.66-7.58 0c-0.83 0.78-0.83 1.81 0 2.59c1.76 1.66 5.82 1.66 7.58 0c0.83-0.78 0.83-1.81 0-2.59z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>",
    clipPath: "url(#cp8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m542.47 182.64l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m546.16 184.6l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m549.51 186.7l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m553.27 188.63l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m556.37 190.79l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m560.06 192.75l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m563.41 194.85l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m567.17 196.78l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m570.52 198.87l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m574.27 200.83l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m577.61 202.93l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m581.37 204.86l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m584.48 207.02l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m588.17 208.98l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m591.51 211.08l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m595.27 213l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m598.62 215.1l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m528.13 174.67l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m531.82 176.63l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m535.17 178.73l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m538.93 180.66l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m542.28 182.75l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>",
    clipPath: "url(#cp9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m544.25 151.07l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m547.94 153.04l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m551.28 155.13l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m555.05 157.06l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m558.15 159.22l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m561.84 161.18l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m565.18 163.28l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m568.95 165.21l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m572.29 167.3l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m576.04 169.26l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m579.39 171.36l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m583.15 173.28l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m586.25 175.44l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m589.94 177.41l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m593.29 179.51l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m597.05 181.43l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m600.4 183.53l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m529.91 143.1l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m533.6 145.06l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m536.94 147.16l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m540.71 149.09l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m544.05 151.18l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m599.99 134.92l-31.84-18.49c-0.51-0.29-0.73-0.68-0.71-1.09l0 0c0-0.02 0-0.05 0-0.07l0.09-9.79c0-0.23 0.19-0.42 0.42-0.42l16.05-0.13c0.07 0 0.15-0.02 0.21-0.06l-5.41 3.05c1.22-0.71 3.07-0.79 4.13-0.19l15.99 9.41c0.07 0.04 0.14 0.06 0.22 0.06l15.98-0.13c0.24 0 0.43 0.19 0.43 0.43l-0.07 9.84c-0.03 0.45-0.37 0.91-1 1.28l-10.38 6.13c-1.22 0.71-3.07 0.79-4.13 0.19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m601.77 136.41c-0.86 0-1.68-0.18-2.33-0.55l0 0l-31.84-18.49c-0.84-0.48-1.3-1.25-1.25-2.1l0.09-9.82c0.01-0.82 0.68-1.5 1.51-1.5l16.05-0.13c-0.12 0-0.22 0.03-0.32 0.08l1.09 1.89c-0.01 0.01-0.02 0.01-0.04 0.02l-1.49 0.84c0.08 0.04 0.16 0.08 0.24 0.12l15.84 9.32l15.8-0.13c0.41 0.03 0.79 0.15 1.08 0.44c0.29 0.29 0.45 0.68 0.45 1.09l-0.07 9.84c-0.07 0.91-0.61 1.67-1.54 2.21l-10.37 6.13c-0.85 0.5-1.9 0.75-2.9 0.75zm-1.24-2.44c0.65 0.37 2.09 0.37 3.04-0.18l10.37-6.13c0.35-0.2 0.46-0.38 0.47-0.43l0.06-9.08l-15.31 0.13c-0.28 0-0.54-0.07-0.77-0.2l-16-9.42c-0.63-0.36-2.02-0.37-2.97 0.15l-0.07 0.04l-1.08-1.89c0.03-0.02 0.06-0.04 0.1-0.05l1.55-0.88l-11.3 0.09l-0.09 9.14c0 0.09 0.05 0.15 0.16 0.21l31.84 18.49z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m600.98 117.06c0.02-0.01 4.7-0.01 14.02 0c0.31 0 0.56 0.25 0.56 0.56l-0.07 9.71c-0.03 0.45-0.37 0.91-1 1.28l-10.18 6.02c-0.09 0.05-0.19-0.01-0.19-0.11l0.09-10.16c0-0.01 0.01-0.01 0.01-0.02c-0.82-2.15-1.9-4.57-3.24-7.27z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m604.32 135.88l-0.68-0.32c-0.38-0.22-0.61-0.63-0.61-1.06l0.09-10.01c-1.21-3.1-3.1-6.91-3.12-6.95l-0.57-1.14l1.21-0.38c0.2-0.06 0.2-0.07 14.35-0.05c0.4 0 0.86 0.17 1.17 0.48c0.31 0.31 0.48 0.73 0.48 1.18l-0.07 9.7c-0.07 0.91-0.61 1.67-1.54 2.21l-10.72 6.34zm0.98-11.27l-0.07 8.2l8.72-5.15c0.35-0.2 0.46-0.38 0.47-0.43l0.06-9.09c-3.06 0-8.88 0-11.76 0c0.71 1.49 1.76 3.78 2.53 5.79l0.17 0.45l-0.11 0.23z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m614.59 118.2l-10.38 6.13c-1.22 0.71-3.07 0.79-4.13 0.19l-31.84-18.49c-1.06-0.61-0.93-1.68 0.29-2.39l10.38-6.13c1.22-0.71 3.07-0.79 4.13-0.19l31.84 18.49c1.06 0.61 0.93 1.68-0.29 2.39z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m601.86 126.02c-0.86 0-1.68-0.18-2.33-0.55l-31.85-18.49c-0.8-0.46-1.26-1.17-1.26-1.97c0-0.89 0.56-1.72 1.55-2.3l10.37-6.13c1.58-0.92 3.82-1 5.23-0.19l31.85 18.49c0.8 0.46 1.26 1.18 1.26 1.97c0 0.89-0.56 1.72-1.55 2.3l-10.37 6.13c-0.85 0.5-1.9 0.75-2.9 0.75zm-33.25-21.03c0.02 0 0.07 0.04 0.16 0.09l31.85 18.49c0.65 0.37 2.08 0.37 3.04-0.18l10.37-6.13c0.31-0.18 0.43-0.34 0.47-0.41c-0.01 0-0.07-0.04-0.16-0.09l-0.01 0l-31.84-18.49c-0.65-0.37-2.08-0.37-3.04 0.18l-10.37 6.13c-0.31 0.18-0.43 0.34-0.47 0.41c0 0 0 0 0 0z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m575.11 119.83l-2.18-0.07l0.3-10.11l2.18 0.07l-0.3 10.11z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m607.36 132.57l-1.68-0.03l0.13-8.82l1.68 0.03l-0.13 8.82z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m584.91 173.48l-31.84-18.49c-0.5-0.29-0.73-0.68-0.71-1.09l0 0c0-0.02 0-0.05 0-0.07l0.09-9.79c0-0.23 0.19-0.42 0.42-0.42l16.05-0.13c0.07 0 0.15-0.02 0.21-0.06l15.69-8.87c1.22-0.71 3.07-0.79 4.13-0.19l15.99 9.41c0.07 0.04 0.14 0.06 0.22 0.06l15.98-0.13c0.24 0 0.43 0.19 0.43 0.43l-0.07 9.84c-0.03 0.45-0.37 0.91-1 1.27l-31.47 18.05c-1.22 0.71-3.07 0.79-4.13 0.19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m586.7 174.98c-0.86 0-1.68-0.18-2.33-0.56l-0.01 0l-31.84-18.49c-0.84-0.48-1.3-1.25-1.25-2.1l0.09-9.82c0.01-0.83 0.67-1.49 1.5-1.5l15.89-0.13l15.54-8.78c1.56-0.91 3.81-0.99 5.21-0.18l15.84 9.32l15.8-0.13c0.47 0.05 0.8 0.16 1.09 0.45c0.29 0.29 0.45 0.67 0.44 1.08l-0.07 9.84c-0.07 0.91-0.61 1.67-1.54 2.21l-31.48 18.06c-0.84 0.49-1.88 0.74-2.88 0.74zm-1.25-2.44c0.65 0.37 2.09 0.37 3.04-0.18l31.48-18.06c0.34-0.2 0.44-0.37 0.45-0.42l0.06-9.08l-15.31 0.13c-0.27 0-0.53-0.07-0.76-0.2l-16-9.42c-0.64-0.37-2.08-0.37-3.03 0.19l-15.7 8.87c-0.21 0.12-0.46 0.19-0.72 0.2l-15.42 0.13l-0.09 9.14c0 0.09 0.04 0.15 0.16 0.21l31.85 18.49z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m607 143.7c0.02-0.01 4.7-0.01 14.02 0c0.31 0 0.56 0.25 0.56 0.56l-0.07 9.71c-0.03 0.45-0.37 0.91-1 1.28l-31.28 17.94c-0.09 0.05-0.19-0.01-0.19-0.11l0.09-10.16c0-0.01 0.01-0.01 0.01-0.02c-0.82-2.15 5.13-8.54 17.85-19.19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m589.24 174.44l-0.67-0.31c-0.38-0.22-0.61-0.63-0.61-1.06l0.09-10.13c-0.46-3.77 11.14-14.11 18.25-20.06l0.36-0.2c0.2-0.07 0.2-0.07 14.36-0.05c0.48-0.06 0.85 0.17 1.17 0.48c0.31 0.31 0.48 0.73 0.48 1.17l-0.07 9.71c-0.07 0.91-0.61 1.67-1.54 2.21l-31.82 18.26zm0.98-11.12l-0.07 8.09l29.82-17.11c0.34-0.2 0.44-0.37 0.45-0.42l0.06-9.09c-3.67 0-11.32-0.01-13.09 0c-8.45 7.1-17.36 15.83-17.22 17.77l0.21 0.56l-0.17 0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m620.61 144.85l-31.47 18.05c-1.22 0.71-3.07 0.79-4.13 0.19l-31.84-18.49c-1.06-0.61-0.93-1.68 0.29-2.39l31.47-18.05c1.22-0.71 3.07-0.79 4.13-0.19l31.84 18.49c1.06 0.61 0.93 1.68-0.29 2.39z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m586.79 164.59c-0.86 0-1.68-0.18-2.33-0.56l-31.85-18.49c-0.8-0.46-1.26-1.18-1.26-1.97c0-0.89 0.56-1.72 1.55-2.3l31.48-18.06c1.56-0.91 3.81-0.99 5.22-0.19l31.85 18.49c0.8 0.46 1.26 1.18 1.26 1.97c0 0.89-0.56 1.72-1.55 2.3l-31.48 18.06c-0.84 0.49-1.88 0.74-2.88 0.74zm-33.25-21.03c0.02 0 0.07 0.05 0.16 0.1l31.85 18.49c0.65 0.37 2.09 0.37 3.04-0.18l31.48-18.06c0.3-0.18 0.42-0.34 0.45-0.4c0 0-0.07-0.04-0.17-0.1l0 0l-31.84-18.49c-0.65-0.37-2.08-0.37-3.04 0.18l-31.48 18.06c-0.3 0.18-0.42 0.34-0.45 0.4c0 0 0 0 0 0z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m560.04 158.4l-2.18-0.07l0.3-10.11l2.18 0.07l-0.3 10.11z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m613.37 159.22l-1.68-0.03l0.13-8.82l1.68 0.03l-0.13 8.82z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m610.07 151.64v6.78c0 0.3-0.12 0.6-0.37 0.9l-8.61 5.37c-0.16 0.1-0.38 0.05-0.47-0.12l4.23-2.63c-0.03-0.05-0.07-0.09-0.12-0.12c-0.63-0.36-3.98 2.05-3.98 1.21v-2.87c0-0.06-0.02-0.12-0.05-0.17l-8.28-8.88c-0.09-0.16-0.04-0.37 0.11-0.46l8.58-5.35c0.2-0.13 0.47-0.14 0.77 0.03l7.06 4.14c0.63 0.36 1.14 1.34 1.14 2.17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m600.9 165.83c-0.11 0-0.23-0.01-0.34-0.04c-0.37-0.09-0.7-0.33-0.89-0.66l-0.54-0.92l0.63-0.39l-0.05-0.03l-0.07-0.75v-2.56l-8.18-8.8c-0.39-0.66-0.18-1.54 0.48-1.94l8.58-5.35c0.53-0.36 1.25-0.36 1.89 0.01l7.06 4.14c0.96 0.55 1.68 1.89 1.68 3.11v6.78c0 0.79-0.52 1.46-0.62 1.59l-0.27 0.24l-8.61 5.37c-0.23 0.14-0.49 0.22-0.76 0.22zm-7.04-14.74l7.76 8.36c0.13 0.22 0.19 0.47 0.19 0.72v1.55c0.12-0.06 0.23-0.11 0.33-0.17c1.3-0.64 2.25-1.12 3.04-0.71l3.72-2.32c0.03-0.05 0.05-0.1 0.06-0.13l0-6.75c0-0.51-0.35-1.09-0.59-1.23l-0.01 0l-6.92-4.05l-7.6 4.73z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m601.2 157.24c0.02-0.03 0.05-0.06 0.08-0.08l8.5-5.3c0.16-0.1 0.36 0.01 0.36 0.2v6.36c0 0.3-0.12 0.6-0.37 0.9l-8.41 5.24c-0.27 0.17-0.63 0.08-0.8-0.19l-6.01-5.06c0.03-0.24 0.05-0.43 0.06-0.57l6.6-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m601.05 165.74c-0.13 0-0.26-0.01-0.4-0.05c-0.36-0.09-0.68-0.29-0.91-0.58l-6.35-5.35l0.21-1.92l7.1-1.61l8.5-5.3c0.41-0.25 0.92-0.27 1.34-0.03c0.42 0.23 0.68 0.68 0.68 1.16v6.36c0 0.79-0.52 1.46-0.62 1.59l-0.27 0.24l-8.41 5.24c-0.27 0.17-0.57 0.25-0.88 0.25zm-4.65-6.29l4.72 3.98l7.87-4.9c0.03-0.05 0.05-0.1 0.06-0.13l0-4.79l-7.01 4.37l-0.13 0.23l-5.51 1.25z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m600.03 164.83l-7.06-4.14c-0.63-0.36-1.14-1.34-1.14-2.17v-6.78c0-0.84 0.51-1.22 1.14-0.86l7.06 4.14c0.63 0.36 1.14 1.34 1.14 2.17v6.78c0 0.84-0.51 1.22-1.14 0.86z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m600.48 166.06c-0.33 0-0.67-0.09-1-0.28l-0.01 0l-7.06-4.14c-0.95-0.55-1.68-1.89-1.68-3.11v-6.78c0-0.84 0.34-1.52 0.94-1.86c0.55-0.32 1.22-0.29 1.83 0.06l7.07 4.14c0.95 0.55 1.68 1.89 1.68 3.11v6.78c0 0.84-0.34 1.52-0.94 1.86c-0.26 0.15-0.54 0.22-0.83 0.22zm0.09-2.17l-0.55 0.94l0.56-0.94c0 0 0 0-0.01 0zm-7.64-11.77l-0.01 6.4c0 0.51 0.35 1.09 0.59 1.23l6.55 3.84l0.01-6.4c0-0.51-0.35-1.09-0.59-1.23l-6.55-3.84z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m602.35 161.46l-0.86-1.44l7.56-4.55l0.86 1.44l-7.56 4.55z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m797.56 375.66l-49.52-28.8c-0.5-0.29-0.73-0.68-0.71-1.09v0c0-0.03 0-0.05 0-0.07l0.09-9.79c0-0.23 0.19-0.42 0.42-0.42l33.41-10.11c0.07 0 0.15-0.02 0.21-0.06l15.69-8.87c1.22-0.71 3.07-0.79 4.13-0.19l33.66 19.72c0.07 0.04 0.14 0.06 0.22 0.06l15.98-0.13c0.24 0 0.43 0.19 0.43 0.43l-0.07 9.84c-0.03 0.45-0.37 0.91-1 1.28l-48.83 28.03c-1.22 0.71-3.07 0.79-4.13 0.19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m799.35 377.16c-0.86 0-1.68-0.18-2.33-0.56l-0.01 0l-49.52-28.8c-0.84-0.48-1.3-1.25-1.25-2.1l0.09-9.81c0.01-0.75 0.57-1.38 1.3-1.49l33.42-10.11l15.56-8.8c1.56-0.91 3.8-0.99 5.21-0.18l33.51 19.63l15.8-0.13c0.47-0.03 0.79 0.15 1.08 0.44c0.29 0.28 0.45 0.68 0.45 1.09l-0.07 9.84c-0.07 0.91-0.61 1.67-1.54 2.21l-48.84 28.03c-0.84 0.49-1.88 0.74-2.88 0.74zm-1.24-2.44c0.65 0.37 2.09 0.37 3.04-0.18l48.84-28.03c0.34-0.2 0.44-0.37 0.45-0.42l0.06-9.08l-15.31 0.13c-0.28 0-0.54-0.07-0.77-0.2l-33.67-19.72c-0.64-0.36-2.08-0.37-3.03 0.19l-15.7 8.87c-0.16 0.09-0.34 0.16-0.53 0.18l-32.97 9.97l-0.09 9.29c0 0.09 0.04 0.15 0.16 0.21l49.52 28.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m837.01 335.91c0.02-0.01 4.7-0.01 14.02 0c0.31 0 0.56 0.25 0.56 0.56l-0.07 9.71c-0.03 0.45-0.37 0.91-1 1.28l-48.63 27.91c-0.09 0.05-0.19-0.01-0.19-0.11l0.09-10.16c0-0.01 0.01-0.01 0.01-0.02c-0.82-2.15 10.92-11.87 35.21-29.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m801.89 376.62l-0.67-0.31c-0.38-0.22-0.62-0.62-0.62-1.06l0.09-10.04c-0.33-1.16 0.34-3.53 17.58-16.8c8.87-6.82 18.01-13.33 18.1-13.4l0.29-0.15c0.2-0.07 0.21-0.07 14.37-0.06c0 0 0 0 0.01 0c0.43 0 0.85 0.17 1.16 0.48c0.31 0.31 0.48 0.73 0.48 1.17l-0.07 9.71c-0.07 0.91-0.61 1.67-1.54 2.21l-49.18 28.22zm0.98-11.16l-0.07 8.13l47.18-27.08c0.34-0.2 0.44-0.37 0.45-0.42l0.06-9.09c-3.7 0-11.45-0.01-13.14 0c-16.38 11.67-33.54 25.12-34.48 27.86l0.15 0.39l-0.16 0.21z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m850.61 337.06l-48.83 28.03c-1.22 0.71-3.07 0.79-4.13 0.19l-49.52-28.8c-1.06-0.61-0.93-1.68 0.29-2.39l48.83-28.03c1.22-0.71 3.07-0.79 4.13-0.19l49.52 28.8c1.06 0.61 0.93 1.68-0.29 2.39z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m799.44 366.77c-0.86 0-1.68-0.18-2.33-0.56l-49.52-28.8c-0.8-0.46-1.26-1.18-1.26-1.97c0-0.89 0.56-1.72 1.55-2.3l48.84-28.03c1.56-0.91 3.81-0.99 5.22-0.19l49.52 28.8c0.8 0.46 1.26 1.18 1.27 1.97c0 0.89-0.56 1.72-1.55 2.3l-48.84 28.03c-0.84 0.49-1.88 0.74-2.88 0.74zm-50.93-31.34c0.02 0 0.07 0.04 0.16 0.1l49.52 28.8c0.64 0.37 2.08 0.37 3.04-0.18l48.84-28.03c0.3-0.18 0.42-0.34 0.45-0.4c-0.02 0-0.07-0.04-0.16-0.09l-0.01 0l-49.52-28.8c-0.64-0.37-2.08-0.37-3.04 0.19l-48.84 28.03c-0.3 0.17-0.42 0.34-0.45 0.4c0 0 0 0 0 0z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m755.01 350.27l-2.18-0.07l0.3-10.11l2.18 0.07l-0.3 10.11z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m843.38 351.43l-1.68-0.03l0.13-8.82l1.68 0.03l-0.13 8.82z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m798.26 349.49l-9.23-1.43l1.22-2.62c-1.25-0.43-2.27-0.89-3.17-1.4c-1-0.57-1.86-1.24-2.7-2.08l-4.46 0.69l-2.74-5.91l4.63-0.72c0.11-1.55 0.77-3.05 1.96-4.41l-3.43-1.98l7.17-4.14l3.19 1.84c2.62-0.88 5.58-1.35 8.6-1.35l1.17-2.53l9.22 1.43l-1.21 2.62c1.25 0.43 2.27 0.89 3.17 1.4c1 0.58 1.87 1.25 2.7 2.08l4.46-0.69l2.74 5.91l-4.63 0.72c-0.11 1.55-0.77 3.05-1.96 4.41l3.43 1.98l-7.17 4.14l-3.19-1.84c-2.63 0.88-5.58 1.35-8.6 1.35l-1.17 2.52zm-6.77-2.74l5.78 0.89l1.09-2.36l0.54 0.01c3.18 0.07 6.25-0.43 8.93-1.38l0.36-0.13l3.01 1.74l3.82-2.2l-2.82-1.63l0.82-0.77c1.52-1.43 2.29-3.05 2.21-4.67l-0.04-0.75l3.87-0.6l-1.27-2.75l-4.08 0.63l-0.3-0.32c-0.82-0.87-1.65-1.54-2.63-2.1c-1-0.57-2.18-1.07-3.74-1.55l-0.91-0.29l1.08-2.32l-5.78-0.89l-1.09 2.36l-0.54-0.01c-3.17-0.06-6.24 0.43-8.93 1.38l-0.36 0.13l-3.01-1.74l-3.82 2.2l2.82 1.63l-0.82 0.77c-1.52 1.43-2.29 3.04-2.21 4.67l0.04 0.75l-3.87 0.6l1.27 2.75l4.08-0.63l0.3 0.32c0.82 0.87 1.65 1.54 2.63 2.1c1 0.57 2.18 1.07 3.73 1.55l0.91 0.28l-1.08 2.32zm7.87-5.42c-2.49 0-4.99-0.74-6.55-2.21c-0.81-0.76-1.24-1.68-1.24-2.65c0-0.97 0.43-1.88 1.24-2.65c3.12-2.95 9.97-2.95 13.09 0c0.81 0.76 1.24 1.68 1.24 2.65c0 0.97-0.43 1.89-1.24 2.65h0c-1.56 1.47-4.05 2.21-6.54 2.21zm0-8c-2.09 0-4.18 0.57-5.39 1.71c-0.47 0.44-0.71 0.94-0.71 1.43c0 0.49 0.25 0.99 0.71 1.43c2.42 2.28 8.37 2.28 10.79 0c0.47-0.44 0.71-0.94 0.71-1.43c0-0.49-0.25-0.99-0.71-1.43c-1.21-1.14-3.3-1.71-5.39-1.71z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m814.24 328.43l4.27-0.66l2.01 4.33l-4.23 0.65c0.09 1.85-0.74 3.7-2.47 5.32l3.1 1.79l-5.49 3.17l-3.1-1.79c-2.82 1-6.02 1.48-9.22 1.43l-1.13 2.44l-7.5-1.16l1.14-2.46c-1.39-0.44-2.73-0.95-3.9-1.63c-1.18-0.68-2.07-1.45-2.82-2.25l-4.27 0.66l-2.01-4.33l4.23-0.65c-0.09-1.85 0.74-3.7 2.47-5.32l-3.1-1.79l5.49-3.17l3.1 1.79c2.82-1 6.02-1.48 9.22-1.43l1.13-2.44l7.5 1.16l-1.14 2.46c1.39 0.44 2.73 0.95 3.9 1.63c1.18 0.68 2.07 1.45 2.82 2.25zm-8.71 2.55c-2.77-2.61-9.17-2.61-11.94 0c-1.3 1.23-1.3 2.85 0 4.08c2.77 2.61 9.17 2.61 11.94 0c1.3-1.23 1.3-2.85 0-4.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m772.43 271.92l-55.68-32.44c-0.51-0.29-0.73-0.68-0.71-1.09v0c0-0.03 0-0.05 0-0.07l0.09-9.79c0-0.23 0.19-0.42 0.42-0.42l33.41-10.11c0.07 0 0.15-0.02 0.21-0.06l15.69-8.87c1.22-0.71 3.07-0.79 4.13-0.19l39.83 23.36c0.07 0.04 0.14 0.06 0.22 0.06l15.98-0.13c0.24 0 0.43 0.19 0.43 0.43l-0.07 9.84c-0.03 0.45-0.37 0.91-1 1.27l-48.83 28.03c-1.22 0.71-3.07 0.79-4.13 0.19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m774.22 272.42c-0.86 0-1.68-0.18-2.33-0.55l-0.01 0l-55.69-32.44c-0.84-0.48-1.3-1.25-1.25-2.09l0.09-9.81c0.01-0.75 0.57-1.38 1.3-1.49l33.43-10.11l15.56-8.8c1.56-0.91 3.8-0.99 5.21-0.18l39.68 23.27l15.8-0.13c0 0 0.01 0 0.01 0c0.41 0 0.79 0.16 1.08 0.44c0.29 0.29 0.45 0.67 0.45 1.08l-0.07 9.84c-0.07 0.91-0.61 1.67-1.54 2.21l-48.84 28.03c-0.84 0.49-1.88 0.74-2.88 0.74zm-1.25-2.44c0.65 0.37 2.09 0.37 3.04-0.18l48.84-28.03c0.34-0.2 0.44-0.37 0.45-0.42l0.06-9.08l-15.31 0.13c-0.28 0-0.54-0.07-0.77-0.2l-39.84-23.37c-0.64-0.37-2.08-0.37-3.03 0.19l-15.7 8.87c-0.16 0.09-0.35 0.16-0.54 0.18l-32.96 9.97l-0.09 9.29c0 0.09 0.04 0.15 0.16 0.21l55.69 32.44z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m811.87 232.17c0.02-0.01 4.7-0.01 14.02 0c0.31 0 0.56 0.25 0.56 0.56l-0.07 9.71c-0.03 0.45-0.37 0.91-1 1.27l-48.63 27.91c-0.09 0.05-0.19-0.01-0.19-0.11l0.09-10.16c0-0.01 0.01-0.01 0.01-0.02c-0.82-2.15 10.92-11.87 35.21-29.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m776.75 272.89l-0.68-0.32c-0.38-0.22-0.61-0.63-0.6-1.07l0.09-10.02c-0.33-1.15 0.31-3.52 17.58-16.8c8.87-6.82 18.01-13.33 18.1-13.4l0.28-0.14c0.21-0.07 0.2-0.07 14.37-0.06c0 0 0.01 0 0.01 0c0.43 0 0.84 0.17 1.16 0.48c0.31 0.31 0.48 0.73 0.48 1.18l-0.07 9.7c-0.07 0.91-0.61 1.67-1.54 2.21l-49.19 28.23zm0.99-11.29l-0.07 8.25l47.18-27.08c0.34-0.2 0.44-0.37 0.45-0.42l0.06-9.09c-3.71 0-11.46-0.01-13.14 0c-16.38 11.67-33.54 25.12-34.48 27.85l0.1 0.25l-0.1 0.23z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m825.48 233.32l-48.83 28.03c-1.22 0.71-3.07 0.79-4.13 0.19l-55.68-32.44c-1.06-0.61-0.93-1.68 0.29-2.39l48.83-28.03c1.22-0.71 3.07-0.79 4.13-0.19l55.68 32.44c1.06 0.61 0.93 1.68-0.29 2.39z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m774.31 263.03c-0.86 0-1.68-0.18-2.33-0.55l-55.69-32.45c-0.8-0.45-1.26-1.18-1.26-1.97c0-0.89 0.56-1.72 1.55-2.3l48.84-28.03c1.56-0.91 3.81-0.99 5.22-0.19l55.69 32.44c0.8 0.46 1.26 1.18 1.26 1.97c0 0.89-0.56 1.73-1.55 2.3l-48.84 28.03c-0.84 0.49-1.88 0.74-2.88 0.74zm-57.09-34.98c0.02 0 0.07 0.04 0.16 0.1l55.69 32.45c0.64 0.37 2.08 0.37 3.04-0.19l48.83-28.03c0.3-0.18 0.42-0.34 0.45-0.4c-0.01 0.01-0.07-0.04-0.16-0.09l-0.01 0l-55.69-32.44c-0.64-0.37-2.08-0.37-3.04 0.19l-48.84 28.03c-0.3 0.18-0.42 0.34-0.45 0.4c0 0 0 0 0 0h0z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m723.71 242.89l-2.18-0.07l0.3-10.11l2.18 0.07l-0.3 10.11z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m818.25 247.69l-1.68-0.02l0.13-8.82l1.68 0.02l-0.13 8.82z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m872.31 241.33l-0.02 12c-0.14 2.39-1.8 4.7-4.81 6.44l-19.44 11.22l-0.81-0.47c-5.61-3.24-12.96-5.32-20.99-5.94c-8.5-0.65-16.73-2-24.45-3.99l-8.13-2.1c-3.43-0.88-7.05-1.53-10.79-1.93c-2.65-0.28-4.49-1.52-4.74-3.01l0-0.02c-0.03-0.19-0.05-11.07-0.05-12.27c0-0.07 0.05-0.11 0.12-0.12l4.11-0.51c0.05-0.01 0.1-0.04 0.11-0.09l0.93-3.01c0.02-0.06-0.01-0.13-0.06-0.16l-7.76-4.48c-1.14-0.66-1.69-1.53-1.69-2.42v-11.9c0-0.09 0.08-0.15 0.17-0.13l14.32 3.88c0.6 0.16 5.11 0.9 1.95 2.8l-0.35 1.68l14.9 4.41c0.02 0.01 0.04 0.01 0.06 0c2.28-0.56 4.94-0.34 6.71 0.68l1.38 0.79l4.18-2.41c2.51-1.45 6.46-1.51 8.83-0.14l1.38 0.79l4.18-2.41c2.51-1.45 6.46-1.51 8.83-0.14l20.35 11.75c0.02 0.01 0.04 0.02 0.06 0.02l11.39 1.03c0.07 0.01 0.12 0.06 0.12 0.13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m848.04 272.25l-1.35-0.78c-5.51-3.18-12.61-5.19-20.53-5.8c-8.56-0.66-16.85-2.01-24.64-4.02l-8.13-2.1c-3.38-0.87-6.96-1.51-10.63-1.9c-3.12-0.33-5.36-1.87-5.7-3.92c-0.02-0.12-0.05-0.31-0.07-12.46c0-0.61 0.46-1.13 1.08-1.21l3.5-0.43l0.52-1.69l-7.1-4.1c-1.44-0.83-2.24-2.03-2.24-3.36v-12.44l0.48-0.43c0.3-0.23 0.69-0.31 1.06-0.21l14.54 3.93c1.18 0.26 3.39 0.76 3.64 2.3c0.17 1.04-0.63 1.77-1.21 2.17l-0.05 0.25l13.69 4.05c2.56-0.56 5.37-0.23 7.26 0.86l0.83 0.48l3.64-2.1c2.85-1.65 7.21-1.71 9.92-0.14l0.83 0.48l3.64-2.1c2.85-1.65 7.21-1.71 9.92-0.14l20.17 11.64l11.18 1.02c0.63 0.06 1.11 0.58 1.11 1.22l-0.01 12c-0.17 2.88-2.07 5.48-5.36 7.38l-19.98 11.53zm-68.87-30.11c0.01 3.9 0.02 10.9 0.05 11.34c0.13 0.78 1.48 1.78 3.77 2.02c3.78 0.4 7.47 1.06 10.95 1.96l8.13 2.1c7.67 1.98 15.83 3.31 24.26 3.96c8.24 0.63 15.66 2.74 21.45 6.08l0.27 0.15l18.89-10.91c2.63-1.52 4.15-3.49 4.27-5.56l0.01-11.06l-10.75-0.98l-0.26-0.13l-20.37-11.76c-2.03-1.17-5.58-1.11-7.74 0.14l-4.73 2.73l-1.92-1.11c-2.03-1.17-5.58-1.11-7.74 0.14l-4.73 2.73l-1.92-1.11c-1.47-0.85-3.84-1.08-5.91-0.57l-0.28 0.07l-0.34-0.08l-15.87-4.7l0.66-3.13l0.41-0.24c0.15-0.09 0.26-0.17 0.35-0.23c-0.28-0.13-0.79-0.31-1.72-0.51l-0.3-0.07l-13.12-3.55v10.65c0 0.52 0.41 1.05 1.15 1.47l7.76 4.48c0.51 0.3 0.73 0.89 0.55 1.44l-1.13 3.67l-0.81 0.18l-3.28 0.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m848.07 241.59c0-0.23 0.19-0.42 0.42-0.42h23.36l0.35 0.03c0.07 0.01 0.12 0.06 0.12 0.13l-0.02 12c-0.14 2.39-1.8 4.7-4.81 6.44l-18.79 10.85c-0.28 0.16-0.64-0.04-0.64-0.37v-28.66z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m848.49 271.76c-0.26 0-0.52-0.07-0.76-0.2c-0.47-0.27-0.76-0.77-0.76-1.31v-28.66c0-0.83 0.68-1.51 1.51-1.51l23.81 0.04c0.63 0.06 1.11 0.58 1.11 1.22l-0.01 12c-0.17 2.88-2.07 5.48-5.36 7.38l-18.79 10.85c-0.23 0.13-0.5 0.2-0.76 0.2zm0.67-29.51v26.84l17.79-10.27c2.63-1.52 4.15-3.49 4.27-5.56l0.01-11.02l-22.07 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon 1 "
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s1",
    d: "m831.56 216.4c2.51-1.45 6.46-1.51 8.83-0.14l22.68 13.09c4.06 2.34 6.96 5.27 8.45 8.52l0.26 0.57c1.5 3.29-0.13 6.79-4.3 9.19l-19.44 11.22l-0.81-0.47c-5.61-3.24-12.96-5.32-20.99-5.94c-8.5-0.65-16.73-2-24.45-3.99l-8.13-2.1c-3.43-0.88-7.05-1.53-10.79-1.93c-3.2-0.34-5.26-2.07-4.7-3.96l0.14-0.47c0.59-1.98 3.83-3.4 7.23-3.17l3.16 0.22c4.22 0.29 8.41 0.72 12.55 1.3l5.74 0.8c0.14 0.02 0.24-0.08 0.14-0.14l-31.59-18.24c-2.37-1.37-2.26-3.65 0.25-5.1l1.09-0.63c2.51-1.45 6.46-1.51 8.83-0.14l12.89 7.44l4.18-2.41c2.51-1.45 6.46-1.51 8.83-0.14l1.38 0.79l4.18-2.41c2.51-1.45 6.46-1.51 8.83-0.14l1.38 0.79l4.18-2.41z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m848.04 260.11l-1.36-0.78c-5.51-3.18-12.61-5.19-20.52-5.8c-8.56-0.66-16.85-2.01-24.64-4.02l-8.13-2.09c-3.37-0.87-6.95-1.51-10.63-1.9c-2.37-0.25-4.26-1.19-5.18-2.57c-0.57-0.85-0.72-1.84-0.44-2.78l0.14-0.47c0.74-2.48 4.4-4.22 8.35-3.94l3.16 0.22c4.24 0.29 8.49 0.73 12.63 1.31l0.71 0.1l-27.11-15.65c-1.45-0.84-2.25-2.03-2.25-3.36c0-1.39 0.91-2.71 2.5-3.62l1.09-0.63c2.85-1.65 7.21-1.71 9.92-0.14l12.34 7.13l3.64-2.1c2.85-1.65 7.21-1.71 9.92-0.14l0.83 0.48l3.64-2.1c2.85-1.65 7.21-1.71 9.92-0.14l0.83 0.48l3.64-2.1c2.85-1.65 7.21-1.71 9.92-0.14l22.68 13.09c4.24 2.45 7.32 5.57 8.89 9.01l0.26 0.57c1.75 3.83-0.07 7.89-4.74 10.58l-19.98 11.53zm-63.25-22.21c-2.81 0-5.08 1.21-5.43 2.41l-0.14 0.47c-0.1 0.32-0.04 0.64 0.17 0.95c0.43 0.64 1.6 1.4 3.6 1.62c3.79 0.4 7.47 1.06 10.95 1.96l8.13 2.09c7.67 1.98 15.83 3.31 24.26 3.96c8.24 0.63 15.66 2.74 21.45 6.08l0.27 0.15l18.89-10.91c3.67-2.12 5.11-5.03 3.85-7.79l-0.26-0.57c-1.39-3.03-4.15-5.81-8-8.03l-22.68-13.09c-2.03-1.17-5.57-1.11-7.74 0.14l-4.73 2.73l-1.92-1.11c-2.03-1.18-5.58-1.11-7.74 0.14l-4.73 2.73l-1.92-1.11c-2.03-1.17-5.58-1.11-7.74 0.14l-4.73 2.73l-13.43-7.75c-2.03-1.17-5.58-1.11-7.74 0.14l-1.09 0.63c-0.9 0.52-1.41 1.15-1.41 1.74c0 0.52 0.41 1.04 1.17 1.48l32.36 18.69l-0.25 0.92c-0.19 0.54-0.75 0.88-1.36 0.8l-5.74-0.8c-4.09-0.57-8.28-1-12.47-1.29l-3.15-0.22c-0.23-0.02-0.45-0.02-0.68-0.02z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m808.37 229.23l-10.31-5.95l1.09-1.89l10.31 5.95l-1.09 1.89z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m811.59 242.84l-6.53-3.77l1.09-1.89l6.53 3.77l-1.09 1.89z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m820.35 226.08l-7.9-4.56l1.09-1.89l7.9 4.56l-1.09 1.89z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m833.19 223.43l-6.36-3.67l1.09-1.89l6.36 3.67l-1.09 1.89z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m780.86 235.35h-2.18v-12.14h2.18v12.14z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m801.3 260.15h-2.18v-12.14h2.18v12.14z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m839.57 267.06h-2.18v-12.14h2.18v12.14z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m785.71 256.86h-2.18v-12.14h2.18v12.14z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m761.2 277v5.97c0 0.26-0.11 0.53-0.33 0.79l-7.58 4.72c-0.14 0.09-0.33 0.04-0.42-0.1l-8.02-9.04c-0.03-0.04-0.06-0.08-0.11-0.11l-2.51 2.98c-0.55-0.32-1-1.17-1-1.91v-2.52c0-0.05-0.01-0.11-0.04-0.15l-7.29-7.81c-0.08-0.14-0.04-0.32 0.1-0.41l7.55-4.71c0.18-0.12 0.41-0.12 0.68 0.03l17.96 10.37c0.55 0.32 1 1.17 1 1.91z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m753.14 289.61c-0.11 0-0.22-0.01-0.33-0.04c-0.32-0.08-0.6-0.26-0.79-0.52l-7.24-8.17l-2.29 2.72l-0.79-0.46c-0.9-0.52-1.55-1.72-1.55-2.86v-2.2l-7.18-7.73c-0.38-0.65-0.17-1.5 0.46-1.89l7.55-4.7c0.51-0.34 1.19-0.34 1.8 0.01l17.96 10.37c0.9 0.52 1.55 1.72 1.55 2.85v5.97c0 0.72-0.44 1.32-0.58 1.48l-0.27 0.23l-7.58 4.72c-0.22 0.14-0.47 0.21-0.73 0.21zm-7.46-11l7.61 8.58l6.8-4.24c0.01-0.02 0.02-0.04 0.02-0.05l-0.01-5.91c0-0.39-0.28-0.86-0.45-0.97l-17.76-10.26l-6.48 4.04l6.88 7.51l0.04 0.45v2.52c0 0.04 0 0.07 0.01 0.11l2.17-2.58l1.03 0.61l0.13 0.19z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m753.4 281.92c0.02-0.03 0.04-0.05 0.07-0.07l7.48-4.66c0.14-0.09 0.31 0.01 0.31 0.17v5.6c0 0.26-0.11 0.52-0.33 0.79l-7.4 4.61c-0.24 0.15-0.56 0.07-0.7-0.17l-5.29-4.46c0.02-0.21 0.04-0.37 0.05-0.5l5.81-1.32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m753.26 289.53c-0.13 0-0.25-0.01-0.38-0.04c-0.35-0.08-0.64-0.27-0.86-0.54l-5.63-4.74l0.2-1.85l6.31-1.43l7.46-4.65c0.39-0.25 0.9-0.26 1.31-0.03c0.41 0.23 0.67 0.66 0.67 1.13v5.6c0 0.72-0.44 1.32-0.58 1.48l-0.27 0.23l-7.4 4.61c-0.26 0.16-0.55 0.24-0.84 0.24zm-3.81-5.6l3.88 3.27l6.81-4.25c0.01-0.02 0.02-0.04 0.02-0.05l0-3.95l-5.93 3.7l-0.12 0.22l-4.65 1.06z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m752.37 288.6l-17.96-10.37c-0.55-0.32-1-1.17-1-1.91v-5.97c0-0.74 0.45-1.08 1-0.76l17.96 10.37c0.55 0.32 1 1.17 1 1.91v5.97c0 0.74-0.45 1.08-1 0.76z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m752.77 289.81c-0.31 0-0.63-0.09-0.94-0.27l0 0l-17.96-10.37c-0.9-0.52-1.55-1.72-1.55-2.85v-5.97c0-0.79 0.33-1.43 0.89-1.75c0.52-0.3 1.16-0.28 1.74 0.05l17.96 10.37c0.89 0.51 1.54 1.72 1.54 2.85v5.97c0 0.79-0.32 1.43-0.89 1.75c-0.25 0.14-0.52 0.22-0.8 0.22zm-18.26-18.9l-0.01 5.41c0 0.39 0.28 0.86 0.46 0.97l17.31 10l0.01-5.41c0-0.39-0.27-0.86-0.45-0.97l-17.32-10zm18.4 16.74l-0.55 0.94l0.55-0.94z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m739.45 272.76l-1.15-1.85l7.55-4.71l1.15 1.85l-7.55 4.71z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m754.47 286.12l-0.86-1.44l6.65-4.01l0.86 1.44l-6.65 4.01z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>",
    clipPath: "url(#cp10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m616.37 479.7l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m620.06 481.67l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m623.4 483.76l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m627.16 485.69l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m630.27 487.85l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m633.96 489.82l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m637.3 491.91l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m641.06 493.84l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m644.41 495.94l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m648.16 497.9l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m651.51 499.99l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m655.27 501.92l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m658.37 504.08l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m662.06 506.04l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m665.41 508.14l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m669.17 510.07l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m672.52 512.16l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m602.03 471.73l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m605.72 473.7l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m609.06 475.79l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m612.82 477.72l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m616.17 479.81l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m659.12 450.59v6.78c0 0.3-0.12 0.6-0.37 0.9l-8.61 5.37c-0.16 0.1-0.38 0.05-0.47-0.12l4.23-2.63c-0.03-0.05-0.07-0.09-0.12-0.12c-0.63-0.36-3.98 2.05-3.98 1.21v-2.87c0-0.06-0.02-0.12-0.05-0.17l-8.28-8.88c-0.1-0.16-0.04-0.37 0.11-0.46l8.58-5.35c0.2-0.13 0.47-0.14 0.77 0.03l7.06 4.14c0.63 0.36 1.14 1.34 1.14 2.17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m649.96 464.78c-0.11 0-0.23-0.01-0.34-0.04c-0.38-0.09-0.69-0.33-0.89-0.66l-0.54-0.92l0.63-0.4l-0.05-0.03l-0.07-0.75v-2.56l-8.17-8.8c-0.4-0.66-0.19-1.53 0.46-1.95l8.59-5.35c0.53-0.36 1.25-0.36 1.89 0.01l7.07 4.14c0.96 0.55 1.68 1.89 1.68 3.11v6.78c0 0.79-0.52 1.46-0.62 1.59l-0.27 0.23l-8.61 5.37c-0.23 0.14-0.5 0.21-0.76 0.21zm-7.03-14.74l7.75 8.34c0.14 0.22 0.21 0.48 0.21 0.74v1.55c0.12-0.06 0.23-0.11 0.34-0.17c1.3-0.65 2.25-1.12 3.04-0.71l3.72-2.32c0.03-0.05 0.05-0.1 0.06-0.13l0-6.75c0-0.51-0.35-1.09-0.59-1.23l-0.01 0l-6.92-4.05l-7.6 4.73z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m650.25 456.19c0.02-0.03 0.05-0.06 0.08-0.08l8.5-5.3c0.15-0.1 0.36 0.01 0.36 0.2v6.36c0 0.3-0.12 0.6-0.37 0.9l-8.41 5.24c-0.27 0.17-0.63 0.08-0.8-0.19l-6.01-5.06c0.03-0.24 0.05-0.43 0.06-0.57l6.6-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m650.1 464.69c-0.13 0-0.26-0.02-0.4-0.05c-0.36-0.09-0.68-0.29-0.91-0.58l-6.35-5.35l0.2-1.91l7.12-1.63l8.48-5.29c0.4-0.25 0.92-0.27 1.34-0.03c0.42 0.23 0.68 0.68 0.68 1.16v6.36c0 0.79-0.52 1.46-0.62 1.59l-0.27 0.23l-8.41 5.24c-0.27 0.17-0.57 0.25-0.87 0.25zm-4.65-6.29l4.72 3.97l7.87-4.9c0.03-0.05 0.05-0.1 0.06-0.13l0-4.79l-7.01 4.37l-0.13 0.23l-5.51 1.25z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m649.08 463.78l-7.06-4.14c-0.63-0.36-1.14-1.34-1.14-2.17v-6.78c0-0.84 0.51-1.22 1.14-0.86l7.06 4.14c0.63 0.36 1.14 1.34 1.14 2.17v6.78c0 0.84-0.51 1.22-1.14 0.86z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m649.54 465.01c-0.33 0-0.67-0.1-1-0.28l0 0l-7.06-4.14c-0.95-0.55-1.68-1.89-1.68-3.11v-6.78c0-0.84 0.34-1.52 0.94-1.86c0.55-0.32 1.22-0.3 1.83 0.06l7.07 4.14c0.95 0.55 1.68 1.89 1.68 3.11v6.78c0 0.84-0.34 1.52-0.94 1.86c-0.26 0.15-0.54 0.22-0.83 0.22zm0.1-2.17l-0.55 0.94l0.56-0.94c0 0 0 0-0.01 0zm-7.65-11.77l-0.01 6.4c0 0.52 0.35 1.09 0.59 1.23l6.55 3.84l0.01-6.4c0-0.51-0.35-1.09-0.59-1.23l-6.55-3.84z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m651.41 460.41l-0.86-1.44l7.56-4.55l0.86 1.44l-7.56 4.55z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>",
    clipPath: "url(#cp11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m556.37 457.85l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m560.06 459.82l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m563.41 461.91l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m567.17 463.84l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m570.27 466l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m573.96 467.97l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m577.31 470.06l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m581.07 471.99l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m584.41 474.08l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m588.16 476.04l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m591.51 478.14l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m595.27 480.07l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m598.38 482.23l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m602.07 484.19l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m605.41 486.29l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m609.17 488.21l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m612.52 490.31l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m542.03 449.88l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m545.72 451.85l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m549.07 453.94l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m552.83 455.87l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m556.17 457.96l-0.63-1.09l70.2-40.54l0.63 1.09l-70.2 40.54z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m599.13 428.74v6.78c0 0.3-0.12 0.6-0.37 0.9l-8.61 5.37c-0.16 0.1-0.38 0.05-0.47-0.12l4.23-2.63c-0.03-0.05-0.07-0.09-0.12-0.12c-0.63-0.36-3.98 2.05-3.98 1.21v-2.87c0-0.06-0.02-0.12-0.05-0.17l-8.28-8.88c-0.1-0.16-0.05-0.37 0.11-0.46l8.58-5.35c0.2-0.13 0.47-0.14 0.77 0.03l7.06 4.14c0.63 0.36 1.14 1.34 1.14 2.17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m589.97 442.93c-0.11 0-0.22-0.01-0.34-0.04c-0.37-0.09-0.7-0.33-0.89-0.66l-0.55-0.92l0.64-0.4l-0.05-0.03l-0.07-0.75v-2.56l-8.18-8.8c-0.39-0.66-0.18-1.54 0.47-1.95l8.59-5.35c0.53-0.35 1.25-0.36 1.89 0.01l7.07 4.14c0.96 0.55 1.68 1.89 1.68 3.11v6.78c0 0.79-0.52 1.47-0.62 1.59l-0.27 0.23l-8.61 5.37c-0.23 0.14-0.49 0.22-0.75 0.22zm-7.04-14.74l7.74 8.33c0.14 0.22 0.22 0.49 0.22 0.75v1.55c0.12-0.06 0.23-0.11 0.33-0.16c1.31-0.65 2.26-1.12 3.04-0.71l3.73-2.32c0.03-0.05 0.05-0.1 0.06-0.13l0-6.75c0-0.51-0.35-1.09-0.59-1.23l0 0l-6.92-4.05l-7.6 4.73z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m590.26 434.34c0.02-0.03 0.05-0.06 0.08-0.08l8.5-5.3c0.16-0.1 0.36 0.01 0.36 0.2v6.36c0 0.3-0.12 0.6-0.37 0.9l-8.41 5.24c-0.27 0.17-0.63 0.08-0.8-0.19l-6.01-5.06c0.03-0.24 0.05-0.43 0.06-0.57l6.6-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m590.11 442.84c-0.13 0-0.26-0.02-0.39-0.05c-0.37-0.09-0.68-0.29-0.91-0.58l-6.35-5.35l0.21-1.92l7.1-1.61l8.5-5.3c0.41-0.25 0.92-0.27 1.34-0.03c0.42 0.23 0.68 0.68 0.68 1.16v6.36c0 0.79-0.52 1.47-0.62 1.59l-0.27 0.23l-8.41 5.24c-0.26 0.17-0.57 0.25-0.88 0.25zm-4.65-6.29l4.72 3.98l7.87-4.9c0.03-0.05 0.05-0.1 0.06-0.13l0-4.79l-6.99 4.36l-0.12 0.23l-5.52 1.25z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m589.09 441.93l-7.06-4.14c-0.63-0.36-1.14-1.34-1.14-2.17v-6.78c0-0.84 0.51-1.22 1.14-0.86l7.06 4.14c0.63 0.36 1.14 1.34 1.14 2.17v6.78c0 0.84-0.51 1.22-1.14 0.86z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m589.54 443.16c-0.33 0-0.67-0.09-1-0.28l0 0l-7.06-4.14c-0.95-0.55-1.68-1.89-1.68-3.11v-6.78c0-0.84 0.34-1.52 0.94-1.86c0.55-0.32 1.22-0.3 1.83 0.06l7.07 4.14c0.95 0.55 1.68 1.89 1.68 3.11v6.78c0 0.84-0.34 1.52-0.94 1.86c-0.26 0.15-0.54 0.22-0.84 0.22zm0.1-2.17l-0.55 0.94l0.56-0.94c0 0 0 0-0.01 0zm-7.65-11.77l-0.01 6.4c0 0.51 0.35 1.09 0.59 1.23l6.55 3.84l0.01-6.4c0-0.51-0.35-1.09-0.59-1.23l-6.55-3.84z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m591.41 438.56l-0.86-1.44l7.56-4.55l0.86 1.44l-7.56 4.55z"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftwareDevelopment);
export default __webpack_public_path__ + "static/media/software-development.422ff85c0dabc9752378d174611333d5.svg";
export { ForwardRef as ReactComponent };